import React from "react";

import UFDiagramText from "../UFDiagramsText";

import "./../index.css";

const UFDiagramDuPontCIPFiltrate = () => (
  <div className='uf-diagram-container'>
    <svg width='100%' height='100%' viewBox='0 0 10750 5200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='Group 1356'>
        <g id='Subtract' filter='url(#filter0_iii_344_5378)'>
          <path fillRule='evenodd' clipRule='evenodd' d='M9557 1136V863H9637V1136H9557Z' fill='#4F6228' />
        </g>
        <g id='Subtract_2' filter='url(#filter1_iii_344_5378)'>
          <path fillRule='evenodd' clipRule='evenodd' d='M9557 903V1176H9637V903H9557Z' fill='#4F6228' />
        </g>
        <g id='Subtract_3' filter='url(#filter2_iii_344_5378)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3598.61 863.875C3598.61 844.545 3582.94 828.875 3563.61 828.875C3544.28 828.875 3528.61 844.545 3528.61 863.875V1455.85C3528.61 1475.18 3544.28 1490.85 3563.61 1490.85H3728V1420.85H3598.61V863.875Z'
            fill='#4F6228'
          />
        </g>
        <g id='Vector 255' filter='url(#filter3_iii_344_5378)'>
          <path d='M3865 3589V3684' stroke='#0F35BA' strokeWidth='70' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <g id='Vector 258' filter='url(#filter4_iii_344_5378)'>
          <path d='M3865 1109V1204' stroke='#1C9EE8' strokeWidth='70' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <g id='Vector 256' filter='url(#filter5_iii_344_5378)'>
          <path d='M4235 3589V3684' stroke='#0F35BA' strokeWidth='70' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <g id='Vector 259' filter='url(#filter6_iii_344_5378)'>
          <path d='M4235 1109V1204' stroke='#1C9EE8' strokeWidth='70' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <g id='Vector 257' filter='url(#filter7_iii_344_5378)'>
          <path d='M4605 3589V3684' stroke='#0F35BA' strokeWidth='70' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <g id='Vector 260' filter='url(#filter8_iii_344_5378)'>
          <path d='M4605 1109V1204' stroke='#1C9EE8' strokeWidth='80' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <g id='Vector 253' filter='url(#filter9_iii_344_5378)'>
          <path d='M4180 4014H10010' stroke='#4F6228' strokeWidth='80' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <g id='Vector 261' filter='url(#filter10_iii_344_5378)'>
          <path
            d='M4180 4014H10010'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 252' filter='url(#filter11_iii_344_5378)'>
          <path
            d='M40 3334H460V2604H1570V4014H4650V3704H3820'
            stroke='#0F35BA'
            strokeWidth='80'
            strokeLinecap='square'
            strokeLinejoin='round'
          />
        </g>
        <g id='Vector 254' filter='url(#filter12_iii_344_5378)'>
          <path
            d='M40 3334H460V2604H1570V4014H4650V3704H3820'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 242' filter='url(#filter13_iii_344_5378)'>
          <path
            d='M2730 4014V2154H2125V2529H1830V2254V1844H2230'
            stroke='url(#paint0_linear_344_5378)'
            strokeWidth='80'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <g id='Vector 261_2' filter='url(#filter14_iii_344_5378)'>
          <path
            d='M2730 4014V2154H2125V2529H1830V2254V1844H2230'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 257_2' filter='url(#filter15_iii_344_5378)'>
          <path
            d='M2445 654V189H4620'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 248' filter='url(#filter16_iii_344_5378)'>
          <path
            d='M8710 3804H8188.75H8005V3419H7170V3804H5050V1094'
            stroke='#1C9EE8'
            strokeWidth='80'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <g id='Vector 256_2' filter='url(#filter17_iii_344_5378)'>
          <path
            d='M8710 3789H8188.75H8005V3404H7170V3789H5050V1079'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 249' filter='url(#filter18_iii_344_5378)'>
          <path
            d='M2445 694V179H3566'
            stroke='url(#paint1_linear_344_5378)'
            strokeWidth='80'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <g id='Vector 260_2' filter='url(#filter19_iii_344_5378)'>
          <path
            d='M2445 644V179H4620'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 245' filter='url(#filter20_iii_344_5378)'>
          <path
            d='M2665 699V509H5370V1084'
            stroke='url(#paint2_linear_344_5378)'
            strokeWidth='80'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <g id='Vector 252_2' filter='url(#filter21_iii_344_5378)'>
          <path
            d='M2665 629V509H5370V1084'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 246' filter='url(#filter22_iii_344_5378)'>
          <path
            d='M3810 1089H8650V1804'
            stroke='#1C9EE8'
            strokeWidth='80'
            strokeLinecap='square'
            strokeLinejoin='round'
          />
        </g>
        <g id='Vector 251' filter='url(#filter23_iii_344_5378)'>
          <path
            d='M3830 1089H8650C8650 1376.04 8650 1536.96 8650 1824'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 250' filter='url(#filter24_iii_344_5378)'>
          <path
            d='M2995 3279V3454H3695'
            stroke='#FFA903'
            strokeWidth='80'
            strokeLinecap='square'
            strokeLinejoin='round'
            strokeDasharray='100 100'
          />
        </g>
        <g id='Vector 259_2' filter='url(#filter25_iii_344_5378)'>
          <path
            d='M2995 3279V3454H3695'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='square'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Group 1349'>
          <g id='Vector 247' filter='url(#filter26_iii_344_5378)'>
            <path
              d='M10038 3535.62H9320V3534'
              stroke='#1C9EE8'
              strokeWidth='80'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <g id='Vector 255_2' filter='url(#filter27_iii_344_5378)'>
            <path
              d='M10038 3535.62H9320V3534'
              stroke='white'
              strokeWidth='10'
              strokeLinecap='square'
              strokeLinejoin='round'
              strokeDasharray='110 110'
            />
          </g>
        </g>
        <g id='Group 1208'>
          <rect
            id='Rectangle 1224'
            x='884.453'
            y='3194.58'
            width='48.735'
            height='288.929'
            fill='url(#paint3_linear_344_5378)'
          />
          <path
            id='Rectangle 1223'
            d='M908.805 3194.58H932.794C971.453 3194.58 1002.79 3225.92 1002.79 3264.58V3413.51C1002.79 3452.17 971.453 3483.51 932.794 3483.51H908.805V3194.58Z'
            fill='url(#paint4_linear_344_5378)'
          />
          <path
            id='Rectangle 1225'
            d='M884.453 3455.66L619.892 3455.66L619.892 3218.95L884.453 3218.95L884.453 3455.66Z'
            fill='url(#paint5_linear_344_5378)'
          />
          <path
            id='Rectangle 1231'
            d='M341.387 3257.24L306.576 3257.24L306.576 3413.89L341.387 3413.89L341.387 3257.24Z'
            fill='url(#paint6_linear_344_5378)'
          />
          <path
            id='Rectangle 1233'
            d='M383.164 3135.41L383.164 3100.6L539.812 3100.6L539.812 3135.41L383.164 3135.41Z'
            fill='url(#paint7_linear_344_5378)'
          />
          <path
            id='Rectangle 1232'
            d='M306.582 3295.54L229.999 3295.54L229.999 3372.12L306.582 3372.12L306.582 3295.54Z'
            fill='url(#paint8_linear_344_5378)'
          />
          <path
            id='Rectangle 1234'
            d='M424.934 3100.58L424.934 3024L501.517 3024L501.517 3100.58L424.934 3100.58Z'
            fill='url(#paint9_linear_344_5378)'
          />
          <path
            id='Vector 224'
            d='M619.883 3218.95H874.001L839.513 3177.18H650.74L619.883 3218.95Z'
            fill='url(#paint10_linear_344_5378)'
          />
          <path
            id='Vector 225'
            d='M619.883 3267.68H874.001L839.513 3229.39H650.74L619.883 3267.68Z'
            fill='url(#paint11_linear_344_5378)'
          />
          <path
            id='Vector 227'
            d='M619.883 3319.9H874.001L839.513 3288.57H650.74L619.883 3319.9Z'
            fill='url(#paint12_linear_344_5378)'
          />
          <path
            id='Vector 229'
            d='M619.883 3351.23H874.001L839.513 3382.55H650.74L619.883 3351.23Z'
            fill='url(#paint13_linear_344_5378)'
          />
          <path
            id='Vector 231'
            d='M619.883 3406.92H874.001L839.513 3438.25H650.74L619.883 3406.92Z'
            fill='url(#paint14_linear_344_5378)'
          />
          <path
            id='Vector 233'
            d='M619.883 3455.66H874.001L839.513 3486.99H650.74L619.883 3455.66Z'
            fill='url(#paint15_linear_344_5378)'
          />
          <path
            id='Vector 223'
            d='M630.324 3218.94H860.075L834.125 3187.62H652.786L630.324 3218.94Z'
            fill='url(#paint16_linear_344_5378)'
          />
          <path
            id='Vector 226'
            d='M630.324 3267.69H860.075L834.125 3239.84H652.786L630.324 3267.69Z'
            fill='url(#paint17_linear_344_5378)'
          />
          <path
            id='Vector 228'
            d='M630.324 3319.9H860.075L834.125 3299.01H652.786L630.324 3319.9Z'
            fill='url(#paint18_linear_344_5378)'
          />
          <path
            id='Vector 230'
            d='M630.324 3351.23H860.075L834.125 3372.12H652.786L630.324 3351.23Z'
            fill='url(#paint19_linear_344_5378)'
          />
          <path
            id='Vector 232'
            d='M630.324 3406.92H860.075L834.125 3427.81H652.786L630.324 3406.92Z'
            fill='url(#paint20_linear_344_5378)'
          />
          <path
            id='Vector 234'
            d='M630.324 3455.66H860.075L834.125 3476.55H652.786L630.324 3455.66Z'
            fill='url(#paint21_linear_344_5378)'
          />
          <rect
            id='Rectangle 1226'
            x='574.629'
            y='3267.69'
            width='45.2539'
            height='139.243'
            fill='url(#paint22_linear_344_5378)'
          />
          <rect
            id='Rectangle 1229'
            x='372.727'
            y='3295.54'
            width='48.735'
            height='76.5835'
            fill='url(#paint23_linear_344_5378)'
          />
          <rect
            id='Rectangle 1230'
            x='341.387'
            y='3257.24'
            width='31.3296'
            height='156.648'
            fill='url(#paint24_linear_344_5378)'
          />
          <rect
            id='Rectangle 1235'
            x='539.812'
            y='3135.41'
            width='31.3296'
            height='156.648'
            transform='rotate(90 539.812 3135.41)'
            fill='url(#paint25_linear_344_5378)'
          />
          <rect
            id='Rectangle 1228'
            x='574.629'
            y='3218.94'
            width='233.232'
            height='153.167'
            rx='50'
            transform='rotate(90 574.629 3218.94)'
            fill='url(#paint26_linear_344_5378)'
          />
          <path
            id='Rectangle 1227'
            d='M498.047 3166.73L498.047 3309.46C498.047 3330.61 480.903 3347.75 459.755 3347.75C438.607 3347.75 421.463 3330.61 421.463 3309.46L421.463 3166.73L498.047 3166.73Z'
            fill='url(#paint27_linear_344_5378)'
          />
          <path
            id='Rectangle 1236'
            d='M574.629 3330.35L574.629 3402.19C574.629 3429.8 552.243 3452.19 524.629 3452.19L471.462 3452.19C443.848 3452.19 421.462 3429.8 421.462 3402.19L421.462 3330.35L574.629 3330.35Z'
            fill='url(#paint28_linear_344_5378)'
          />
        </g>
        <g id='Group 1223'>
          <rect
            id='Rectangle 1224_2'
            width='48.735'
            height='288.929'
            transform='matrix(-1 0 0 1 7585.34 3634.58)'
            fill='url(#paint29_linear_344_5378)'
          />
          <path
            id='Rectangle 1223_2'
            d='M7561 3634.58H7537.01C7498.35 3634.58 7467.01 3665.92 7467.01 3704.58V3853.51C7467.01 3892.17 7498.35 3923.51 7537.01 3923.51H7561V3634.58Z'
            fill='url(#paint30_linear_344_5378)'
          />
          <path
            id='Rectangle 1225_2'
            d='M7585.34 3895.66L7849.91 3895.66L7849.91 3658.95L7585.34 3658.95L7585.34 3895.66Z'
            fill='url(#paint31_linear_344_5378)'
          />
          <path
            id='Rectangle 1231_2'
            d='M8128.41 3697.24L8163.22 3697.24L8163.22 3853.89L8128.41 3853.89L8128.41 3697.24Z'
            fill='url(#paint32_linear_344_5378)'
          />
          <path
            id='Rectangle 1233_2'
            d='M8086.63 3575.4L8086.63 3540.59L7929.98 3540.59L7929.98 3575.4L8086.63 3575.4Z'
            fill='url(#paint33_linear_344_5378)'
          />
          <path
            id='Rectangle 1232_2'
            d='M8163.21 3735.53L8239.8 3735.53L8239.8 3812.12L8163.21 3812.12L8163.21 3735.53Z'
            fill='url(#paint34_linear_344_5378)'
          />
          <path
            id='Rectangle 1234_2'
            d='M8044.86 3540.58L8044.86 3464L7968.28 3464L7968.28 3540.58L8044.86 3540.58Z'
            fill='url(#paint35_linear_344_5378)'
          />
          <path
            id='Vector 224_2'
            d='M7849.91 3658.95H7595.8L7630.28 3617.17H7819.06L7849.91 3658.95Z'
            fill='url(#paint36_linear_344_5378)'
          />
          <path
            id='Vector 225_2'
            d='M7849.91 3707.68H7595.8L7630.28 3669.39H7819.06L7849.91 3707.68Z'
            fill='url(#paint37_linear_344_5378)'
          />
          <path
            id='Vector 227_2'
            d='M7849.91 3759.9H7595.8L7630.28 3728.57H7819.06L7849.91 3759.9Z'
            fill='url(#paint38_linear_344_5378)'
          />
          <path
            id='Vector 229_2'
            d='M7849.91 3791.22H7595.8L7630.28 3822.55H7819.06L7849.91 3791.22Z'
            fill='url(#paint39_linear_344_5378)'
          />
          <path
            id='Vector 231_2'
            d='M7849.91 3846.92H7595.8L7630.28 3878.25H7819.06L7849.91 3846.92Z'
            fill='url(#paint40_linear_344_5378)'
          />
          <path
            id='Vector 233_2'
            d='M7849.91 3895.66H7595.8L7630.28 3926.99H7819.06L7849.91 3895.66Z'
            fill='url(#paint41_linear_344_5378)'
          />
          <path
            id='Vector 223_2'
            d='M7839.47 3658.94H7609.72L7635.67 3627.61H7817.01L7839.47 3658.94Z'
            fill='url(#paint42_linear_344_5378)'
          />
          <path
            id='Vector 226_2'
            d='M7839.47 3707.69H7609.72L7635.67 3679.84H7817.01L7839.47 3707.69Z'
            fill='url(#paint43_linear_344_5378)'
          />
          <path
            id='Vector 228_2'
            d='M7839.47 3759.9H7609.72L7635.67 3739.01H7817.01L7839.47 3759.9Z'
            fill='url(#paint44_linear_344_5378)'
          />
          <path
            id='Vector 230_2'
            d='M7839.47 3791.23H7609.72L7635.67 3812.12H7817.01L7839.47 3791.23Z'
            fill='url(#paint45_linear_344_5378)'
          />
          <path
            id='Vector 232_2'
            d='M7839.47 3846.92H7609.72L7635.67 3867.81H7817.01L7839.47 3846.92Z'
            fill='url(#paint46_linear_344_5378)'
          />
          <path
            id='Vector 234_2'
            d='M7839.47 3895.66H7609.72L7635.67 3916.55H7817.01L7839.47 3895.66Z'
            fill='url(#paint47_linear_344_5378)'
          />
          <rect
            id='Rectangle 1226_2'
            width='45.2539'
            height='139.243'
            transform='matrix(-1 0 0 1 7895.17 3707.68)'
            fill='url(#paint48_linear_344_5378)'
          />
          <rect
            id='Rectangle 1229_2'
            width='48.735'
            height='76.5835'
            transform='matrix(-1 0 0 1 8097.07 3735.53)'
            fill='url(#paint49_linear_344_5378)'
          />
          <rect
            id='Rectangle 1230_2'
            width='31.3296'
            height='156.648'
            transform='matrix(-1 0 0 1 8128.41 3697.24)'
            fill='url(#paint50_linear_344_5378)'
          />
          <rect
            id='Rectangle 1235_2'
            width='31.3296'
            height='156.648'
            transform='matrix(4.37114e-08 1 1 -4.37114e-08 7929.98 3575.4)'
            fill='url(#paint51_linear_344_5378)'
          />
          <rect
            id='Rectangle 1228_2'
            width='233.232'
            height='153.167'
            rx='50'
            transform='matrix(4.37114e-08 1 1 -4.37114e-08 7895.17 3658.94)'
            fill='url(#paint52_linear_344_5378)'
          />
          <path
            id='Rectangle 1227_2'
            d='M7971.75 3606.73L7971.75 3749.46C7971.75 3770.6 7988.89 3787.75 8010.04 3787.75C8031.19 3787.75 8048.33 3770.6 8048.33 3749.46L8048.33 3606.73L7971.75 3606.73Z'
            fill='url(#paint53_linear_344_5378)'
          />
          <path
            id='Rectangle 1236_2'
            d='M7895.17 3770.35L7895.17 3842.19C7895.17 3869.8 7917.55 3892.19 7945.17 3892.19L7998.33 3892.19C8025.95 3892.19 8048.34 3869.8 8048.34 3842.19L8048.34 3770.35L7895.17 3770.35Z'
            fill='url(#paint54_linear_344_5378)'
          />
        </g>
        <g id='Group 1222'>
          <rect
            id='Rectangle 1224_3'
            x='2554.45'
            y='2384.58'
            width='48.735'
            height='288.929'
            fill='url(#paint55_linear_344_5378)'
          />
          <path
            id='Rectangle 1223_3'
            d='M2578.8 2384.58H2602.79C2641.45 2384.58 2672.79 2415.92 2672.79 2454.58V2603.51C2672.79 2642.17 2641.45 2673.51 2602.79 2673.51H2578.8V2384.58Z'
            fill='url(#paint56_linear_344_5378)'
          />
          <path
            id='Rectangle 1225_3'
            d='M2554.45 2645.66L2289.89 2645.66L2289.89 2408.95L2554.45 2408.95L2554.45 2645.66Z'
            fill='url(#paint57_linear_344_5378)'
          />
          <path
            id='Rectangle 1231_3'
            d='M2011.39 2447.24L1976.58 2447.24L1976.58 2603.89L2011.39 2603.89L2011.39 2447.24Z'
            fill='url(#paint58_linear_344_5378)'
          />
          <path
            id='Rectangle 1233_3'
            d='M2053.16 2325.41L2053.16 2290.6L2209.81 2290.6L2209.81 2325.41L2053.16 2325.41Z'
            fill='url(#paint59_linear_344_5378)'
          />
          <path
            id='Rectangle 1232_3'
            d='M1976.58 2485.54L1900 2485.54L1900 2562.12L1976.58 2562.12L1976.58 2485.54Z'
            fill='url(#paint60_linear_344_5378)'
          />
          <path
            id='Rectangle 1234_3'
            d='M2094.93 2290.58L2094.93 2214L2171.52 2214L2171.52 2290.58L2094.93 2290.58Z'
            fill='url(#paint61_linear_344_5378)'
          />
          <path
            id='Vector 224_3'
            d='M2289.88 2408.95H2544L2509.51 2367.18H2320.74L2289.88 2408.95Z'
            fill='url(#paint62_linear_344_5378)'
          />
          <path
            id='Vector 225_3'
            d='M2289.88 2457.68H2544L2509.51 2419.39H2320.74L2289.88 2457.68Z'
            fill='url(#paint63_linear_344_5378)'
          />
          <path
            id='Vector 227_3'
            d='M2289.88 2509.9H2544L2509.51 2478.57H2320.74L2289.88 2509.9Z'
            fill='url(#paint64_linear_344_5378)'
          />
          <path
            id='Vector 229_3'
            d='M2289.88 2541.23H2544L2509.51 2572.55H2320.74L2289.88 2541.23Z'
            fill='url(#paint65_linear_344_5378)'
          />
          <path
            id='Vector 231_3'
            d='M2289.88 2596.92H2544L2509.51 2628.25H2320.74L2289.88 2596.92Z'
            fill='url(#paint66_linear_344_5378)'
          />
          <path
            id='Vector 233_3'
            d='M2289.88 2645.66H2544L2509.51 2676.99H2320.74L2289.88 2645.66Z'
            fill='url(#paint67_linear_344_5378)'
          />
          <path
            id='Vector 223_3'
            d='M2300.32 2408.94H2530.07L2504.13 2377.62H2322.79L2300.32 2408.94Z'
            fill='url(#paint68_linear_344_5378)'
          />
          <path
            id='Vector 226_3'
            d='M2300.32 2457.69H2530.07L2504.13 2429.84H2322.79L2300.32 2457.69Z'
            fill='url(#paint69_linear_344_5378)'
          />
          <path
            id='Vector 228_3'
            d='M2300.32 2509.9H2530.07L2504.13 2489.01H2322.79L2300.32 2509.9Z'
            fill='url(#paint70_linear_344_5378)'
          />
          <path
            id='Vector 230_3'
            d='M2300.32 2541.23H2530.07L2504.13 2562.12H2322.79L2300.32 2541.23Z'
            fill='url(#paint71_linear_344_5378)'
          />
          <path
            id='Vector 232_3'
            d='M2300.32 2596.92H2530.07L2504.13 2617.81H2322.79L2300.32 2596.92Z'
            fill='url(#paint72_linear_344_5378)'
          />
          <path
            id='Vector 234_3'
            d='M2300.32 2645.66H2530.07L2504.13 2666.55H2322.79L2300.32 2645.66Z'
            fill='url(#paint73_linear_344_5378)'
          />
          <rect
            id='Rectangle 1226_3'
            x='2244.63'
            y='2457.69'
            width='45.2539'
            height='139.243'
            fill='url(#paint74_linear_344_5378)'
          />
          <rect
            id='Rectangle 1229_3'
            x='2042.73'
            y='2485.54'
            width='48.735'
            height='76.5835'
            fill='url(#paint75_linear_344_5378)'
          />
          <rect
            id='Rectangle 1230_3'
            x='2011.39'
            y='2447.24'
            width='31.3296'
            height='156.648'
            fill='url(#paint76_linear_344_5378)'
          />
          <rect
            id='Rectangle 1235_3'
            x='2209.81'
            y='2325.41'
            width='31.3296'
            height='156.648'
            transform='rotate(90 2209.81 2325.41)'
            fill='url(#paint77_linear_344_5378)'
          />
          <rect
            id='Rectangle 1228_3'
            x='2244.63'
            y='2408.94'
            width='233.232'
            height='153.167'
            rx='50'
            transform='rotate(90 2244.63 2408.94)'
            fill='url(#paint78_linear_344_5378)'
          />
          <path
            id='Rectangle 1227_3'
            d='M2168.05 2356.73L2168.05 2499.46C2168.05 2520.61 2150.9 2537.75 2129.76 2537.75C2108.61 2537.75 2091.46 2520.61 2091.46 2499.46L2091.46 2356.73L2168.05 2356.73Z'
            fill='url(#paint79_linear_344_5378)'
          />
          <path
            id='Rectangle 1236_3'
            d='M2244.63 2520.35L2244.63 2592.19C2244.63 2619.8 2222.24 2642.19 2194.63 2642.19L2141.46 2642.19C2113.85 2642.19 2091.46 2619.8 2091.46 2592.19L2091.46 2520.35L2244.63 2520.35Z'
            fill='url(#paint80_linear_344_5378)'
          />
        </g>
        <g id='Group 1216'>
          <g id='Rectangle 1238' className='blenmode-multiply'>
            <path
              d='M8429.69 1948.76C8429.69 1903.89 8456.91 1863.2 8499.05 1847.77C8781.85 1744.18 8970.54 1746.78 9263.29 1848.51C9306.5 1863.52 9334.8 1904.77 9334.8 1950.51V3611.93C9334.8 3656.06 9308.5 3696.17 9267.44 3712.33C8965.04 3831.4 8775.69 3834.24 8493.52 3713.39C8454.28 3696.58 8429.69 3657.46 8429.69 3614.78V1948.76Z'
              fill='url(#paint81_linear_344_5378)'
            />
          </g>
          <g id='Group 1210'>
            <g id='Rectangle 1237' className='blenmode-multiply'>
              <path
                d='M8429.68 1904.02C8823.39 1966.1 9019.4 1960.13 9334.79 1904.02V3625.7C8988.13 3837.69 8789.62 3846.83 8429.68 3625.7V1904.02Z'
                fill='url(#paint82_linear_344_5378)'
              />
            </g>
          </g>
          <g id='Group 1211'>
            <path
              id='Vector 235 (Stroke)'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8410.44 2283.1C8412.98 2269.75 8425.86 2261 8439.21 2263.54C8781.99 2328.88 8974.18 2328.23 9330.4 2263.5C9343.76 2261.07 9356.56 2269.94 9358.99 2283.3C9361.42 2296.67 9352.55 2309.47 9339.19 2311.9C8977.34 2377.65 8779.04 2378.4 8429.99 2311.86C8416.65 2309.32 8407.9 2296.44 8410.44 2283.1Z'
              fill='url(#paint83_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8424.93 2285.86C8425.95 2280.53 8431.1 2277.03 8436.44 2278.04C8781.1 2343.74 8975.12 2343.06 9333.03 2278.03C9338.38 2277.06 9343.5 2280.6 9344.47 2285.95C9345.44 2291.29 9341.89 2296.42 9336.55 2297.39C8976.39 2362.83 8779.92 2363.55 8432.76 2297.37C8427.42 2296.35 8423.92 2291.2 8424.93 2285.86Z'
              fill='url(#paint84_linear_344_5378)'
            />
          </g>
          <g id='Group 1212'>
            <path
              id='Vector 235 (Stroke)_2'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8410.44 2578.25C8412.98 2564.91 8425.86 2556.15 8439.21 2558.7C8781.99 2624.04 8974.18 2623.39 9330.4 2558.66C9343.76 2556.23 9356.56 2565.1 9358.99 2578.46C9361.42 2591.83 9352.55 2604.63 9339.19 2607.06C8977.34 2672.81 8779.04 2673.55 8429.99 2607.02C8416.65 2604.47 8407.9 2591.6 8410.44 2578.25Z'
              fill='url(#paint85_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)_2'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8424.93 2581.02C8425.95 2575.68 8431.1 2572.18 8436.44 2573.2C8781.1 2638.9 8975.12 2638.22 9333.03 2573.18C9338.38 2572.21 9343.5 2575.76 9344.47 2581.1C9345.44 2586.45 9341.89 2591.57 9336.55 2592.54C8976.39 2657.99 8779.92 2658.7 8432.76 2592.53C8427.42 2591.51 8423.92 2586.36 8424.93 2581.02Z'
              fill='url(#paint86_linear_344_5378)'
            />
          </g>
          <g id='Group 1213'>
            <path
              id='Vector 235 (Stroke)_3'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8410.44 2873.39C8412.98 2860.05 8425.86 2851.29 8439.21 2853.83C8781.99 2919.17 8974.18 2918.52 9330.4 2853.8C9343.76 2851.37 9356.56 2860.23 9358.99 2873.6C9361.42 2886.96 9352.55 2899.77 9339.19 2902.19C8977.34 2967.95 8779.04 2968.69 8429.99 2902.15C8416.65 2899.61 8407.9 2886.73 8410.44 2873.39Z'
              fill='url(#paint87_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)_3'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8424.93 2876.15C8425.95 2870.81 8431.1 2867.31 8436.44 2868.33C8781.1 2934.03 8975.12 2933.35 9333.03 2868.31C9338.38 2867.34 9343.5 2870.89 9344.47 2876.23C9345.44 2881.58 9341.89 2886.7 9336.55 2887.67C8976.39 2953.11 8779.92 2953.83 8432.76 2887.65C8427.42 2886.64 8423.92 2881.49 8424.93 2876.15Z'
              fill='url(#paint88_linear_344_5378)'
            />
          </g>
          <g id='Group 1214'>
            <path
              id='Vector 235 (Stroke)_4'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8410.44 3168.54C8412.98 3155.19 8425.86 3146.44 8439.21 3148.98C8781.99 3214.32 8974.18 3213.67 9330.4 3148.94C9343.76 3146.52 9356.56 3155.38 9358.99 3168.75C9361.42 3182.11 9352.55 3194.91 9339.19 3197.34C8977.34 3263.09 8779.04 3263.84 8429.99 3197.3C8416.65 3194.76 8407.9 3181.88 8410.44 3168.54Z'
              fill='url(#paint89_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)_4'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8424.93 3171.3C8425.95 3165.97 8431.1 3162.47 8436.44 3163.48C8781.1 3229.18 8975.12 3228.5 9333.03 3163.47C9338.38 3162.5 9343.5 3166.04 9344.47 3171.39C9345.44 3176.73 9341.89 3181.85 9336.55 3182.83C8976.39 3248.27 8779.92 3248.99 8432.76 3182.81C8427.42 3181.79 8423.92 3176.64 8424.93 3171.3Z'
              fill='url(#paint90_linear_344_5378)'
            />
          </g>
          <g id='Group 1215'>
            <path
              id='Vector 235 (Stroke)_5'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8410.44 3463.68C8412.98 3450.34 8425.86 3441.58 8439.21 3444.13C8781.99 3509.47 8974.18 3508.82 9330.4 3444.09C9343.76 3441.66 9356.56 3450.53 9358.99 3463.89C9361.42 3477.25 9352.55 3490.06 9339.19 3492.49C8977.34 3558.24 8779.04 3558.98 8429.99 3492.45C8416.65 3489.9 8407.9 3477.03 8410.44 3463.68Z'
              fill='url(#paint91_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)_5'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M8424.93 3466.44C8425.95 3461.1 8431.1 3457.6 8436.44 3458.62C8781.1 3524.32 8975.12 3523.64 9333.03 3458.6C9338.38 3457.63 9343.5 3461.18 9344.47 3466.52C9345.44 3471.87 9341.89 3476.99 9336.55 3477.96C8976.39 3543.41 8779.92 3544.12 8432.76 3477.95C8427.42 3476.93 8423.92 3471.78 8424.93 3466.44Z'
              fill='url(#paint92_linear_344_5378)'
            />
          </g>
          <g id='Reflection 02' opacity='0.5' filter='url(#filter28_f_344_5378)'>
            <rect
              x='8744.49'
              y='1805.64'
              width='157.411'
              height='1790.55'
              fill='url(#paint93_linear_344_5378)'
              fillOpacity='0.6'
            />
          </g>
          <g id='Ellipse 711' className='blenmode-overlay' opacity='0.2' filter='url(#filter29_f_344_5378)'>
            <ellipse cx='8695.32' cy='1859.75' rx='186.925' ry='93.4626' fill='white' fillOpacity='0.8' />
          </g>
          <g id='Ellipse 712' className='blenmode-overlay' opacity='0.3' filter='url(#filter30_f_344_5378)'>
            <ellipse cx='9098.67' cy='1913.86' rx='196.763' ry='39.3527' fill='white' fillOpacity='0.8' />
          </g>
        </g>
        <g id='Group 1180'>
          <rect
            id='Rectangle 1207'
            x='5767.5'
            y='954'
            width='172.5'
            height='52.5'
            rx='26.25'
            fill='url(#paint94_linear_344_5378)'
          />
          <g id='Rectangle 1211' filter='url(#filter31_f_344_5378)'>
            <rect x='5925' y='961.5' width='15' height='142.5' transform='rotate(90 5925 961.5)' fill='#B29D96' />
          </g>
          <g id='Rectangle 1212' filter='url(#filter32_f_344_5378)'>
            <rect x='5925' y='991.5' width='7.50001' height='142.5' transform='rotate(90 5925 991.5)' fill='black' />
          </g>
          <rect
            id='Rectangle 1208'
            x='5820'
            y='1006.5'
            width='67.5'
            height='82.5'
            fill='url(#paint95_linear_344_5378)'
          />
          <path
            id='Polygon 30'
            d='M5850 1089L5962.5 1017.55L5962.5 1160.45L5850 1089Z'
            fill='url(#paint96_linear_344_5378)'
          />
          <path
            id='Polygon 31'
            d='M5850 1089L5737.5 1017.55L5737.5 1160.45L5850 1089Z'
            fill='url(#paint97_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239'
            x='5920'
            y='1024'
            width='130'
            height='140'
            rx='10'
            transform='rotate(90 5920 1024)'
            fill='url(#paint98_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216'
            x='5962.5'
            y='1006.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint99_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217'
            x='5715'
            y='1006.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint100_linear_344_5378)'
          />
        </g>
        <g id='Group 1270'>
          <rect
            id='Rectangle 1207_2'
            x='2670'
            y='24'
            width='240'
            height='50'
            rx='25'
            fill='url(#paint101_linear_344_5378)'
          />
          <g id='Rectangle 1211_2' filter='url(#filter33_f_344_5378)'>
            <rect x='2890' y='34' width='10' height='200' transform='rotate(90 2890 34)' fill='#B29D96' />
          </g>
          <rect id='Rectangle 1208_2' x='2700' y='74' width='70' height='90' fill='url(#paint102_linear_344_5378)' />
          <path
            id='Polygon 30_2'
            d='M2730 179L2842.5 107.553L2842.5 250.447L2730 179Z'
            fill='url(#paint103_linear_344_5378)'
          />
          <path
            id='Polygon 31_2'
            d='M2730 179L2617.5 107.553L2617.5 250.447L2730 179Z'
            fill='url(#paint104_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_2'
            x='2800'
            y='114'
            width='130'
            height='140'
            rx='10'
            transform='rotate(90 2800 114)'
            fill='url(#paint105_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_2'
            x='2842.5'
            y='96.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint106_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_2'
            x='2595'
            y='96.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint107_linear_344_5378)'
          />
        </g>
        <g id='Group 1273'>
          <rect
            id='Rectangle 1207_3'
            x='2900'
            y='344'
            width='240'
            height='50'
            rx='25'
            fill='url(#paint108_linear_344_5378)'
          />
          <g id='Rectangle 1211_3' filter='url(#filter34_f_344_5378)'>
            <rect x='3120' y='354' width='10' height='200' transform='rotate(90 3120 354)' fill='#B29D96' />
          </g>
          <rect id='Rectangle 1208_3' x='2930' y='394' width='70' height='90' fill='url(#paint109_linear_344_5378)' />
          <path
            id='Polygon 30_3'
            d='M2960 499L3072.5 427.553L3072.5 570.447L2960 499Z'
            fill='url(#paint110_linear_344_5378)'
          />
          <path
            id='Polygon 31_3'
            d='M2960 499L2847.5 427.553L2847.5 570.447L2960 499Z'
            fill='url(#paint111_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_3'
            x='3030'
            y='434'
            width='130'
            height='140'
            rx='10'
            transform='rotate(90 3030 434)'
            fill='url(#paint112_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_3'
            x='3072.5'
            y='416.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint113_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_3'
            x='2825'
            y='416.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint114_linear_344_5378)'
          />
        </g>
        <g id='Group 1274'>
          <rect
            id='Rectangle 1207_4'
            x='2586.25'
            y='3347.75'
            width='240'
            height='50'
            rx='25'
            transform='rotate(-90 2586.25 3347.75)'
            fill='url(#paint115_linear_344_5378)'
          />
          <g id='Rectangle 1211_4' filter='url(#filter35_f_344_5378)'>
            <rect x='2596.25' y='3127.75' width='10' height='200' fill='#B29D96' />
          </g>
          <rect
            id='Rectangle 1208_4'
            x='2636.25'
            y='3317.75'
            width='70'
            height='90'
            transform='rotate(-90 2636.25 3317.75)'
            fill='url(#paint116_linear_344_5378)'
          />
          <path
            id='Polygon 30_4'
            d='M2741.25 3287.75L2669.8 3175.25L2812.7 3175.25L2741.25 3287.75Z'
            fill='url(#paint117_linear_344_5378)'
          />
          <path
            id='Polygon 31_4'
            d='M2741.25 3287.75L2669.8 3400.25H2812.7L2741.25 3287.75Z'
            fill='url(#paint118_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_4'
            x='2676.25'
            y='3217.75'
            width='130'
            height='140'
            rx='10'
            fill='url(#paint119_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_4'
            x='2658.75'
            y='3175.25'
            width='22.5'
            height='165'
            rx='11.25'
            transform='rotate(-90 2658.75 3175.25)'
            fill='url(#paint120_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_4'
            x='2658.75'
            y='3422.75'
            width='22.5'
            height='165'
            rx='11.25'
            transform='rotate(-90 2658.75 3422.75)'
            fill='url(#paint121_linear_344_5378)'
          />
        </g>
        <g id='Group 1227'>
          <rect
            id='Rectangle 1207_5'
            x='5427.5'
            y='3884'
            width='172.5'
            height='52.5'
            rx='26.25'
            fill='url(#paint122_linear_344_5378)'
          />
          <g id='Rectangle 1211_5' filter='url(#filter36_f_344_5378)'>
            <rect x='5585' y='3891.5' width='15' height='142.5' transform='rotate(90 5585 3891.5)' fill='#B29D96' />
          </g>
          <g id='Rectangle 1212_2' filter='url(#filter37_f_344_5378)'>
            <rect x='5585' y='3921.5' width='7.50001' height='142.5' transform='rotate(90 5585 3921.5)' fill='black' />
          </g>
          <rect
            id='Rectangle 1208_5'
            x='5480'
            y='3936.5'
            width='67.5'
            height='82.5'
            fill='url(#paint123_linear_344_5378)'
          />
          <path
            id='Polygon 30_5'
            d='M5510 4019L5622.5 3947.55L5622.5 4090.45L5510 4019Z'
            fill='url(#paint124_linear_344_5378)'
          />
          <path
            id='Polygon 31_5'
            d='M5510 4019L5397.5 3947.55L5397.5 4090.45L5510 4019Z'
            fill='url(#paint125_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_5'
            x='5580'
            y='3954'
            width='130'
            height='140'
            rx='10'
            transform='rotate(90 5580 3954)'
            fill='url(#paint126_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_5'
            x='5622.5'
            y='3936.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint127_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_5'
            x='5375'
            y='3936.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint128_linear_344_5378)'
          />
        </g>
        <g id='Group 1269'>
          <rect
            id='Rectangle 1207_6'
            x='3197.5'
            y='3314'
            width='172.5'
            height='52.5'
            rx='26.25'
            fill='url(#paint129_linear_344_5378)'
          />
          <g id='Rectangle 1211_6' filter='url(#filter38_f_344_5378)'>
            <rect x='3355' y='3321.5' width='15' height='142.5' transform='rotate(90 3355 3321.5)' fill='#B29D96' />
          </g>
          <g id='Rectangle 1212_3' filter='url(#filter39_f_344_5378)'>
            <rect x='3355' y='3351.5' width='7.50001' height='142.5' transform='rotate(90 3355 3351.5)' fill='black' />
          </g>
          <rect
            id='Rectangle 1208_6'
            x='3250'
            y='3366.5'
            width='67.5'
            height='82.5'
            fill='url(#paint130_linear_344_5378)'
          />
          <path
            id='Polygon 30_6'
            d='M3280 3449L3392.5 3377.55L3392.5 3520.45L3280 3449Z'
            fill='url(#paint131_linear_344_5378)'
          />
          <path
            id='Polygon 31_6'
            d='M3280 3449L3167.5 3377.55L3167.5 3520.45L3280 3449Z'
            fill='url(#paint132_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_6'
            x='3350'
            y='3384'
            width='130'
            height='140'
            rx='10'
            transform='rotate(90 3350 3384)'
            fill='url(#paint133_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_6'
            x='3392.5'
            y='3366.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint134_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_6'
            x='3145'
            y='3366.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint135_linear_344_5378)'
          />
        </g>
        <g id='Group 1243'>
          <rect
            id='Rectangle 1207_7'
            x='2157.5'
            y='3884'
            width='172.5'
            height='52.5'
            rx='26.25'
            fill='url(#paint136_linear_344_5378)'
          />
          <g id='Rectangle 1211_7' filter='url(#filter40_f_344_5378)'>
            <rect x='2315' y='3891.5' width='15' height='142.5' transform='rotate(90 2315 3891.5)' fill='#B29D96' />
          </g>
          <g id='Rectangle 1212_4' filter='url(#filter41_f_344_5378)'>
            <rect x='2315' y='3921.5' width='7.50001' height='142.5' transform='rotate(90 2315 3921.5)' fill='black' />
          </g>
          <rect
            id='Rectangle 1208_7'
            x='2210'
            y='3936.5'
            width='67.5'
            height='82.5'
            fill='url(#paint137_linear_344_5378)'
          />
          <path
            id='Polygon 30_7'
            d='M2240 4019L2352.5 3947.55L2352.5 4090.45L2240 4019Z'
            fill='url(#paint138_linear_344_5378)'
          />
          <path
            id='Polygon 31_7'
            d='M2240 4019L2127.5 3947.55L2127.5 4090.45L2240 4019Z'
            fill='url(#paint139_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_7'
            x='2310'
            y='3954'
            width='130'
            height='140'
            rx='10'
            transform='rotate(90 2310 3954)'
            fill='url(#paint140_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_7'
            x='2352.5'
            y='3936.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint141_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_7'
            x='2105'
            y='3936.5'
            width='22.5'
            height='165'
            rx='11.25'
            fill='url(#paint142_linear_344_5378)'
          />
        </g>
        <g id='Group 1228'>
          <rect
            id='Rectangle 1207_8'
            x='5187.5'
            y='1471.5'
            width='172.5'
            height='52.5'
            rx='26.25'
            transform='rotate(90 5187.5 1471.5)'
            fill='url(#paint143_linear_344_5378)'
          />
          <g id='Rectangle 1211_8' filter='url(#filter42_f_344_5378)'>
            <rect x='5180' y='1629' width='15' height='142.5' transform='rotate(-180 5180 1629)' fill='#B29D96' />
          </g>
          <g id='Rectangle 1212_5' filter='url(#filter43_f_344_5378)'>
            <rect x='5150' y='1629' width='7.50001' height='142.5' transform='rotate(-180 5150 1629)' fill='black' />
          </g>
          <rect
            id='Rectangle 1208_8'
            x='5135'
            y='1524'
            width='67.5'
            height='82.5'
            transform='rotate(90 5135 1524)'
            fill='url(#paint144_linear_344_5378)'
          />
          <path
            id='Polygon 30_8'
            d='M5052.5 1554L5123.95 1666.5L4981.05 1666.5L5052.5 1554Z'
            fill='url(#paint145_linear_344_5378)'
          />
          <path
            id='Polygon 31_8'
            d='M5052.5 1554L5123.95 1441.5L4981.05 1441.5L5052.5 1554Z'
            fill='url(#paint146_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_8'
            x='5117.5'
            y='1624'
            width='130'
            height='140'
            rx='10'
            transform='rotate(-180 5117.5 1624)'
            fill='url(#paint147_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_8'
            x='5135'
            y='1666.5'
            width='22.5'
            height='165'
            rx='11.25'
            transform='rotate(90 5135 1666.5)'
            fill='url(#paint148_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_8'
            x='5135'
            y='1419'
            width='22.5'
            height='165'
            rx='11.25'
            transform='rotate(90 5135 1419)'
            fill='url(#paint149_linear_344_5378)'
          />
        </g>
        <g id='Group 1218'>
          <g id='Rectangle 1238_2' className='blenmode-multiply'>
            <path
              d='M2200 851.28C2200 801.591 2233.34 757.779 2281.65 746.156C2551.97 681.116 2736.88 682.807 3016.72 746.922C3065.78 758.162 3100 802.326 3100 852.658V1892.15C3100 1941.29 3067.35 1984.72 3019.79 1997.07C2731.73 2071.81 2546.28 2073.72 2277.46 1998.28C2231.2 1985.3 2200 1942.49 2200 1894.45V851.28Z'
              fill='url(#paint150_linear_344_5378)'
            />
          </g>
          <g id='Group 1210_2'>
            <g id='Rectangle 1237_2' className='blenmode-multiply'>
              <path
                d='M2200 942.916C2591.49 978.905 2786.4 975.442 3100 942.916V1941C2755.3 2063.89 2557.92 2069.19 2200 1941V942.916Z'
                fill='url(#paint151_linear_344_5378)'
              />
            </g>
          </g>
          <g id='Group 1213_2'>
            <path
              id='Vector 235 (Stroke)_6'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2180.44 1175.59C2182.98 1163.03 2195.86 1154.78 2209.21 1157.18C2551.99 1218.7 2744.18 1218.09 3100.4 1157.14C3113.76 1154.85 3126.56 1163.2 3128.99 1175.79C3131.42 1188.37 3122.55 1200.43 3109.19 1202.71C2747.34 1264.62 2549.04 1265.33 2199.99 1202.68C2186.65 1200.28 2177.9 1188.15 2180.44 1175.59Z'
              fill='url(#paint152_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)_6'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2194.93 1178.19C2195.95 1173.17 2201.1 1169.87 2206.44 1170.83C2551.1 1232.69 2745.12 1232.05 3103.03 1170.81C3108.38 1169.9 3113.5 1173.24 3114.47 1178.27C3115.44 1183.3 3111.89 1188.13 3106.55 1189.04C2746.39 1250.66 2549.92 1251.34 2202.76 1189.03C2197.42 1188.07 2193.92 1183.22 2194.93 1178.19Z'
              fill='url(#paint153_linear_344_5378)'
            />
          </g>
          <g id='Group 1214_2'>
            <path
              id='Vector 235 (Stroke)_7'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2180.44 1453.5C2182.98 1440.94 2195.86 1432.69 2209.21 1435.09C2551.99 1496.61 2744.18 1496 3100.4 1435.05C3113.76 1432.76 3126.56 1441.11 3128.99 1453.7C3131.42 1466.28 3122.55 1478.34 3109.19 1480.62C2747.34 1542.53 2549.04 1543.24 2199.99 1480.59C2186.65 1478.19 2177.9 1466.06 2180.44 1453.5Z'
              fill='url(#paint154_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)_7'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2194.93 1456.11C2195.95 1451.09 2201.1 1447.79 2206.44 1448.75C2551.1 1510.61 2745.12 1509.97 3103.03 1448.73C3108.38 1447.82 3113.5 1451.16 3114.47 1456.19C3115.44 1461.22 3111.89 1466.05 3106.55 1466.96C2746.39 1528.58 2549.92 1529.26 2202.76 1466.95C2197.42 1465.99 2193.92 1461.14 2194.93 1456.11Z'
              fill='url(#paint155_linear_344_5378)'
            />
          </g>
          <g id='Group 1215_2'>
            <path
              id='Vector 235 (Stroke)_8'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2180.44 1731.41C2182.98 1718.84 2195.86 1710.6 2209.21 1713C2551.99 1774.52 2744.18 1773.91 3100.4 1712.96C3113.76 1710.67 3126.56 1719.02 3128.99 1731.6C3131.42 1744.19 3122.55 1756.24 3109.19 1758.53C2747.34 1820.44 2549.04 1821.14 2199.99 1758.49C2186.65 1756.1 2177.9 1743.97 2180.44 1731.41Z'
              fill='url(#paint156_linear_344_5378)'
            />
            <path
              id='Vector 240 (Stroke)_8'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2194.93 1734.01C2195.95 1728.99 2201.1 1725.69 2206.44 1726.65C2551.1 1788.51 2745.12 1787.87 3103.03 1726.63C3108.38 1725.72 3113.5 1729.06 3114.47 1734.09C3115.44 1739.12 3111.89 1743.95 3106.55 1744.86C2746.39 1806.48 2549.92 1807.16 2202.76 1744.85C2197.42 1743.89 2193.92 1739.04 2194.93 1734.01Z'
              fill='url(#paint157_linear_344_5378)'
            />
          </g>
          <g id='Reflection 01' className='blenmode-overlay' opacity='0.2' filter='url(#filter44_f_344_5378)'>
            <rect x='2337.42' y='374' width='127.896' height='1500.7' rx='63.9481' fill='white' fillOpacity='0.8' />
          </g>
          <g id='Reflection 06' className='blenmode-overlay' opacity='0.2' filter='url(#filter45_f_344_5378)'>
            <rect x='2670' y='764.01' width='290' height='1224.07' rx='145' fill='white' fillOpacity='0.51' />
          </g>
          <g id='Reflection 02_2' opacity='0.3' filter='url(#filter46_f_344_5378)'>
            <rect
              x='2510'
              y='707.516'
              width='160'
              height='1148.75'
              fill='url(#paint158_linear_344_5378)'
              fillOpacity='0.6'
            />
          </g>
          <g id='Ellipse 711_2' className='blenmode-overlay' opacity='0.3' filter='url(#filter47_f_344_5378)'>
            <ellipse cx='2465.32' cy='795.52' rx='186.925' ry='88.0039' fill='white' fillOpacity='0.8' />
          </g>
          <g id='Ellipse 712_2' className='blenmode-overlay' opacity='0.2' filter='url(#filter48_f_344_5378)'>
            <ellipse cx='2868.67' cy='846.472' rx='196.763' ry='37.0543' fill='white' fillOpacity='0.8' />
          </g>
        </g>
        <g id='arrow'>
          <g id='Rectangle 1099' className='blenmode-overlay' filter='url(#filter49_f_344_5378)'>
            <rect
              x='3324.39'
              y='613.688'
              width='33.7867'
              height='59.1267'
              rx='16.8933'
              transform='rotate(61.1206 3324.39 613.688)'
              fill='#F1EFED'
            />
          </g>
          <g id='Rectangle 1100' className='blenmode-overlay' filter='url(#filter50_f_344_5378)'>
            <rect
              x='3331.28'
              y='707.281'
              width='12.67'
              height='59.1267'
              rx='6.335'
              transform='rotate(119.055 3331.28 707.281)'
              fill='#F1EFED'
            />
          </g>
        </g>

        <UFDiagramText />

        <path
          id='Arrow 41'
          d='M1680 3284L1723.3 3209L1636.7 3209L1680 3284ZM1672.5 3134L1672.5 3216.5L1687.5 3216.5L1687.5 3134L1672.5 3134Z'
          fill='#434343'
        />
        <path
          id='Arrow 43'
          d='M3540 4114L3465 4070.7L3465 4157.3L3540 4114ZM3390 4121.5L3472.5 4121.5L3472.5 4106.5L3390 4106.5L3390 4121.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 62'
          d='M3660 3334L3585 3290.7L3585 3377.3L3660 3334ZM3510 3341.5L3592.5 3341.5L3592.5 3326.5L3510 3326.5L3510 3341.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 61'
          d='M3090 3374L3133.3 3299L3046.7 3299L3090 3374ZM3082.5 3214L3082.5 3306.5L3097.5 3306.5L3097.5 3214L3082.5 3214Z'
          fill='#434343'
        />
        <path
          id='Arrow 46'
          d='M7780 4164L7705 4120.7L7705 4207.3L7780 4164ZM7630 4171.5L7712.5 4171.5L7712.5 4156.5L7630 4156.5L7630 4171.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 47'
          d='M7370 74L7295 30.6987L7295 117.301L7370 74ZM7220 81.5L7302.5 81.5L7302.5 66.5L7220 66.5L7220 81.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 49'
          d='M7370 964L7295 920.699L7295 1007.3L7370 964ZM7220 971.5L7302.5 971.5L7302.5 956.5L7220 956.5L7220 971.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 52'
          d='M9495 3364L9420 3320.7L9420 3407.3L9495 3364ZM9345 3371.5L9427.5 3371.5L9427.5 3356.5L9345 3356.5L9345 3371.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 50'
          d='M8765 1469L8808.3 1394L8721.7 1394L8765 1469ZM8757.5 1319L8757.5 1401.5L8772.5 1401.5L8772.5 1319L8757.5 1319Z'
          fill='#434343'
        />
        <path
          id='Arrow 56'
          d='M2350 404L2393.3 329L2306.7 329L2350 404ZM2342.5 254L2342.5 336.5L2357.5 336.5L2357.5 254L2342.5 254Z'
          fill='#434343'
        />
        <path
          id='Arrow 60'
          d='M2840 2784L2883.3 2709L2796.7 2709L2840 2784ZM2832.5 2634L2832.5 2716.5L2847.5 2716.5L2847.5 2634L2832.5 2634Z'
          fill='#434343'
        />
        <path
          id='Arrow 63'
          d='M1730 2284L1773.3 2209L1686.7 2209L1730 2284ZM1722.5 2134L1722.5 2216.5L1737.5 2216.5L1737.5 2134L1722.5 2134Z'
          fill='#434343'
        />
        <path
          id='Arrow 48'
          d='M9755 2439L9798.3 2364L9711.7 2364L9755 2439ZM9747.5 2289L9747.5 2371.5L9762.5 2371.5L9762.5 2289L9747.5 2289Z'
          fill='#434343'
        />
        <path
          id='Arrow 57'
          d='M4910 2504L4866.7 2579L4953.3 2579L4910 2504ZM4917.5 2654L4917.5 2571.5L4902.5 2571.5L4902.5 2654L4917.5 2654Z'
          fill='#434343'
        />
        <path
          id='Arrow 53'
          d='M5480 704L5436.7 779L5523.3 779L5480 704ZM5487.5 854L5487.5 771.5L5472.5 771.5L5472.5 854L5487.5 854Z'
          fill='#434343'
        />
        <path
          id='Arrow 45'
          d='M4080 3824L4155 3867.3L4155 3780.7L4080 3824ZM4230 3816.5L4147.5 3816.5L4147.5 3831.5L4230 3831.5L4230 3816.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 54'
          d='M4250 384L4325 427.301L4325 340.699L4250 384ZM4400 376.5L4317.5 376.5L4317.5 391.5L4400 391.5L4400 376.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 55'
          d='M3160 44L3235 87.3013L3235 0.698724L3160 44ZM3310 36.5L3227.5 36.5L3227.5 51.5L3310 51.5L3310 36.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 58'
          d='M5270 3634L5345 3677.3L5345 3590.7L5270 3634ZM5420 3626.5L5337.5 3626.5L5337.5 3641.5L5420 3641.5L5420 3626.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 39'
          d='M1080 2514L1005 2470.7L1005 2557.3L1080 2514ZM930 2521.5L1012.5 2521.5L1012.5 2506.5L930 2506.5L930 2521.5Z'
          fill='#434343'
        />
        <path
          id='Arrow 40'
          d='M370 2774L326.699 2849L413.301 2849L370 2774ZM377.5 2924L377.5 2841.5L362.5 2841.5L362.5 2924L377.5 2924Z'
          fill='#434343'
        />
        <g id='Group 1248'>
          <path
            id='Rectangle 1188'
            d='M4460.01 1710.9C4460.01 1632.11 4501.55 1554.61 4580.33 1554.01C4666.54 1553.35 4730.01 1640.01 4730.01 1726.23V3152.75C4730.01 3238.78 4657.98 3326.66 4572 3323.85C4493.03 3321.26 4460.01 3246.2 4460.01 3167.19V1710.9Z'
            fill='url(#paint159_linear_344_5378)'
          />
          <g id='Rectangle 1215' className='blenmode-overlay' filter='url(#filter51_f_344_5378)'>
            <rect x='4617.7' y='1798.78' width='35.575' height='406.572' fill='white' fillOpacity='0.54' />
          </g>
          <g id='Group 1204'>
            <rect
              id='Rectangle 1189'
              x='4450.01'
              y='1284'
              width='290'
              height='280'
              rx='10'
              fill='url(#paint160_linear_344_5378)'
            />
            <g id='Rectangle 1213' filter='url(#filter52_f_344_5378)'>
              <rect x='4501' y='1285.47' width='76.2322' height='259.19' fill='white' />
            </g>
            <g id='Ellipse 710' filter='url(#filter53_f_344_5378)'>
              <ellipse cx='4615.34' cy='1407.45' rx='33.034' ry='101.643' fill='white' />
            </g>
            <g id='Rectangle 1214' filter='url(#filter54_f_344_5378)'>
              <rect x='4617.88' y='1305.8' width='5.08215' height='238.861' fill='white' />
            </g>
            <rect
              id='Rectangle 1194'
              x='4692.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint161_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1223_4'
              x='4642.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint162_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1224_4'
              x='4582.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint163_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1225_4'
              x='4522.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint164_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1226_4'
              x='4462.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint165_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1196'
              x='4450.01'
              y='1614'
              width='290'
              height='200'
              rx='10'
              fill='url(#paint166_linear_344_5378)'
            />
            <rect
              id='Rectangle 1195'
              x='4440.01'
              y='1544.66'
              width='315.093'
              height='81.3144'
              rx='5'
              fill='url(#paint167_linear_344_5378)'
            />
            <rect
              id='Rectangle 1240'
              x='4462.51'
              y='1576.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint168_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1241'
              x='4552.51'
              y='1576.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint169_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1242'
              x='4662.51'
              y='1576.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint170_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <g id='Rectangle 1243' filter='url(#filter55_f_344_5378)'>
              <rect x='4440.01' y='1554' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1244' filter='url(#filter56_f_344_5378)'>
              <rect x='4440.01' y='1604' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1245' filter='url(#filter57_f_344_5378)'>
              <rect x='4510.01' y='1554' width='50' height='70' fill='white' />
            </g>
            <rect
              id='Rectangle 1219'
              x='4692.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint171_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1220'
              x='4612.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint172_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1221'
              x='4542.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint173_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1222'
              x='4482.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint174_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <g id='Rectangle 1211_9' filter='url(#filter58_f_344_5378)'>
              <rect x='4570.01' y='1624' width='50.8215' height='172.793' fill='#959595' />
            </g>
            <g id='Rectangle 1212_6' filter='url(#filter59_f_344_5378)'>
              <rect x='4592.47' y='1625.98' width='5.08215' height='172.793' fill='#B29D96' />
            </g>
          </g>
          <g id='Group 1207'>
            <rect
              id='Rectangle 1189_2'
              x='4745.1'
              y='3584'
              width='290'
              height='280'
              rx='10'
              transform='rotate(-180 4745.1 3584)'
              fill='url(#paint175_linear_344_5378)'
            />
            <g id='Rectangle 1213_2' filter='url(#filter60_f_344_5378)'>
              <rect
                x='4694.11'
                y='3582.53'
                width='76.2322'
                height='259.19'
                transform='rotate(-180 4694.11 3582.53)'
                fill='white'
              />
            </g>
            <g id='Ellipse 710_2' filter='url(#filter61_f_344_5378)'>
              <ellipse
                cx='4579.77'
                cy='3460.55'
                rx='33.034'
                ry='101.643'
                transform='rotate(-180 4579.77 3460.55)'
                fill='white'
              />
            </g>
            <g id='Rectangle 1214_2' filter='url(#filter62_f_344_5378)'>
              <rect
                x='4577.23'
                y='3562.2'
                width='5.08215'
                height='238.861'
                transform='rotate(-180 4577.23 3562.2)'
                fill='white'
              />
            </g>
            <rect
              id='Rectangle 1194_2'
              x='4502.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4502.6 3561.5)'
              fill='url(#paint176_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1223_5'
              x='4552.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4552.6 3561.5)'
              fill='url(#paint177_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1224_5'
              x='4612.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4612.6 3561.5)'
              fill='url(#paint178_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1225_5'
              x='4672.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4672.6 3561.5)'
              fill='url(#paint179_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1226_5'
              x='4732.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4732.6 3561.5)'
              fill='url(#paint180_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1196_2'
              x='4745.1'
              y='3254'
              width='290'
              height='200'
              rx='10'
              transform='rotate(-180 4745.1 3254)'
              fill='url(#paint181_linear_344_5378)'
            />
            <rect
              id='Rectangle 1195_2'
              x='4755.1'
              y='3323.34'
              width='315.093'
              height='81.3144'
              rx='5'
              transform='rotate(-180 4755.1 3323.34)'
              fill='url(#paint182_linear_344_5378)'
            />
            <rect
              id='Rectangle 1240_2'
              x='4462.5'
              y='3266.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint183_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1241_2'
              x='4552.5'
              y='3266.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint184_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1242_2'
              x='4662.5'
              y='3266.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint185_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <g id='Rectangle 1243_2' filter='url(#filter63_f_344_5378)'>
              <rect x='4440' y='3244' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1244_2' filter='url(#filter64_f_344_5378)'>
              <rect x='4440' y='3294' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1245_2' filter='url(#filter65_f_344_5378)'>
              <rect x='4510' y='3244' width='50' height='70' fill='white' />
            </g>
            <rect
              id='Rectangle 1219_2'
              x='4502.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4502.6 3231.5)'
              fill='url(#paint186_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1220_2'
              x='4582.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4582.6 3231.5)'
              fill='url(#paint187_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1221_2'
              x='4652.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4652.6 3231.5)'
              fill='url(#paint188_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1222_2'
              x='4712.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4712.6 3231.5)'
              fill='url(#paint189_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <g id='Rectangle 1211_10' filter='url(#filter66_f_344_5378)'>
              <rect
                x='4625.1'
                y='3244'
                width='50.8215'
                height='172.793'
                transform='rotate(-180 4625.1 3244)'
                fill='#959595'
              />
            </g>
            <g id='Rectangle 1212_7' filter='url(#filter67_f_344_5378)'>
              <rect
                x='4602.64'
                y='3242.02'
                width='5.08215'
                height='172.793'
                transform='rotate(-180 4602.64 3242.02)'
                fill='#B29D96'
              />
            </g>
          </g>
          <g id='image 293' className='blenmode-multiply'>
            <rect x='4480.5' y='1849.6' width='249.025' height='137.218' />
          </g>
          <g id='Group 1206'>
            <path
              id='Rectangle 1208_9'
              d='M4570.01 1224C4570.01 1218.48 4574.49 1214 4580.01 1214H4640.01C4645.53 1214 4650.01 1218.48 4650.01 1224V1284H4570.01V1224Z'
              fill='url(#paint190_linear_344_5378)'
            />
            <rect
              id='Rectangle 1207_9'
              x='4530.01'
              y='1224'
              width='160'
              height='40'
              rx='20'
              fill='url(#paint191_linear_344_5378)'
            />
            <g id='Rectangle 1211_11' filter='url(#filter68_f_344_5378)'>
              <rect
                x='4663.3'
                y='1229.08'
                width='10.1643'
                height='96.5608'
                transform='rotate(90 4663.3 1229.08)'
                fill='#B29D96'
              />
            </g>
            <g id='Rectangle 1212_8' filter='url(#filter69_f_344_5378)'>
              <rect
                x='4663.3'
                y='1249.41'
                width='5.08215'
                height='96.5608'
                transform='rotate(90 4663.3 1249.41)'
                fill='black'
              />
            </g>
          </g>
        </g>
        <g id='Group 1262'>
          <path
            id='Rectangle 1188_2'
            d='M4100.01 1710.9C4100.01 1632.11 4141.55 1554.61 4220.33 1554.01C4306.54 1553.35 4370.01 1640.01 4370.01 1726.23V3152.75C4370.01 3238.78 4297.98 3326.66 4212 3323.85C4133.03 3321.26 4100.01 3246.2 4100.01 3167.19V1710.9Z'
            fill='url(#paint192_linear_344_5378)'
          />
          <g id='Rectangle 1215_2' className='blenmode-overlay' filter='url(#filter70_f_344_5378)'>
            <rect x='4257.7' y='1798.78' width='35.575' height='406.572' fill='white' fillOpacity='0.54' />
          </g>
          <g id='Group 1204_2'>
            <rect
              id='Rectangle 1189_3'
              x='4090.01'
              y='1284'
              width='290'
              height='280'
              rx='10'
              fill='url(#paint193_linear_344_5378)'
            />
            <g id='Rectangle 1213_3' filter='url(#filter71_f_344_5378)'>
              <rect x='4141' y='1285.47' width='76.2322' height='259.19' fill='white' />
            </g>
            <g id='Ellipse 710_3' filter='url(#filter72_f_344_5378)'>
              <ellipse cx='4255.34' cy='1407.45' rx='33.034' ry='101.643' fill='white' />
            </g>
            <g id='Rectangle 1214_3' filter='url(#filter73_f_344_5378)'>
              <rect x='4257.88' y='1305.8' width='5.08215' height='238.861' fill='white' />
            </g>
            <rect
              id='Rectangle 1194_3'
              x='4332.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint194_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1223_6'
              x='4282.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint195_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1224_6'
              x='4222.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint196_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1225_6'
              x='4162.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint197_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1226_6'
              x='4102.51'
              y='1306.5'
              width='25'
              height='215'
              rx='12.5'
              fill='url(#paint198_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1196_3'
              x='4090.01'
              y='1614'
              width='290'
              height='200'
              rx='10'
              fill='url(#paint199_linear_344_5378)'
            />
            <rect
              id='Rectangle 1195_3'
              x='4080.01'
              y='1544.66'
              width='315.093'
              height='81.3144'
              rx='5'
              fill='url(#paint200_linear_344_5378)'
            />
            <rect
              id='Rectangle 1240_3'
              x='4102.51'
              y='1576.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint201_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1241_3'
              x='4192.51'
              y='1576.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint202_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1242_3'
              x='4302.51'
              y='1576.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint203_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <g id='Rectangle 1243_3' filter='url(#filter74_f_344_5378)'>
              <rect x='4080.01' y='1554' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1244_3' filter='url(#filter75_f_344_5378)'>
              <rect x='4080.01' y='1604' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1245_3' filter='url(#filter76_f_344_5378)'>
              <rect x='4150.01' y='1554' width='50' height='70' fill='white' />
            </g>
            <rect
              id='Rectangle 1219_3'
              x='4332.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint204_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1220_3'
              x='4252.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint205_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1221_3'
              x='4182.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint206_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1222_3'
              x='4122.51'
              y='1636.5'
              width='25'
              height='155'
              rx='7.5'
              fill='url(#paint207_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <g id='Rectangle 1211_12' filter='url(#filter77_f_344_5378)'>
              <rect x='4210.01' y='1624' width='50.8215' height='172.793' fill='#959595' />
            </g>
            <g id='Rectangle 1212_9' filter='url(#filter78_f_344_5378)'>
              <rect x='4232.47' y='1625.98' width='5.08215' height='172.793' fill='#B29D96' />
            </g>
          </g>
          <g id='Group 1207_2'>
            <rect
              id='Rectangle 1189_4'
              x='4385.1'
              y='3584'
              width='290'
              height='280'
              rx='10'
              transform='rotate(-180 4385.1 3584)'
              fill='url(#paint208_linear_344_5378)'
            />
            <g id='Rectangle 1213_4' filter='url(#filter79_f_344_5378)'>
              <rect
                x='4334.11'
                y='3582.53'
                width='76.2322'
                height='259.19'
                transform='rotate(-180 4334.11 3582.53)'
                fill='white'
              />
            </g>
            <g id='Ellipse 710_4' filter='url(#filter80_f_344_5378)'>
              <ellipse
                cx='4219.77'
                cy='3460.55'
                rx='33.034'
                ry='101.643'
                transform='rotate(-180 4219.77 3460.55)'
                fill='white'
              />
            </g>
            <g id='Rectangle 1214_4' filter='url(#filter81_f_344_5378)'>
              <rect
                x='4217.23'
                y='3562.2'
                width='5.08215'
                height='238.861'
                transform='rotate(-180 4217.23 3562.2)'
                fill='white'
              />
            </g>
            <rect
              id='Rectangle 1194_4'
              x='4142.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4142.6 3561.5)'
              fill='url(#paint209_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1223_7'
              x='4192.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4192.6 3561.5)'
              fill='url(#paint210_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1224_7'
              x='4252.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4252.6 3561.5)'
              fill='url(#paint211_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1225_7'
              x='4312.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4312.6 3561.5)'
              fill='url(#paint212_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1226_7'
              x='4372.6'
              y='3561.5'
              width='25'
              height='215'
              rx='12.5'
              transform='rotate(-180 4372.6 3561.5)'
              fill='url(#paint213_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#C9C9C9'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1196_4'
              x='4385.1'
              y='3254'
              width='290'
              height='200'
              rx='10'
              transform='rotate(-180 4385.1 3254)'
              fill='url(#paint214_linear_344_5378)'
            />
            <rect
              id='Rectangle 1195_4'
              x='4395.1'
              y='3323.34'
              width='315.093'
              height='81.3144'
              rx='5'
              transform='rotate(-180 4395.1 3323.34)'
              fill='url(#paint215_linear_344_5378)'
            />
            <rect
              id='Rectangle 1240_4'
              x='4102.5'
              y='3266.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint216_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1241_4'
              x='4192.5'
              y='3266.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint217_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1242_4'
              x='4302.5'
              y='3266.5'
              width='55'
              height='15'
              rx='7.5'
              fill='url(#paint218_linear_344_5378)'
              stroke='#B3B3B3'
              strokeWidth='5'
            />
            <g id='Rectangle 1243_4' filter='url(#filter82_f_344_5378)'>
              <rect x='4080' y='3244' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1244_4' filter='url(#filter83_f_344_5378)'>
              <rect x='4080' y='3294' width='310' height='10' fill='white' />
            </g>
            <g id='Rectangle 1245_4' filter='url(#filter84_f_344_5378)'>
              <rect x='4150' y='3244' width='50' height='70' fill='white' />
            </g>
            <rect
              id='Rectangle 1219_4'
              x='4142.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4142.6 3231.5)'
              fill='url(#paint219_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1220_4'
              x='4222.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4222.6 3231.5)'
              fill='url(#paint220_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1221_4'
              x='4292.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4292.6 3231.5)'
              fill='url(#paint221_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <rect
              id='Rectangle 1222_4'
              x='4352.6'
              y='3231.5'
              width='25'
              height='155'
              rx='7.5'
              transform='rotate(-180 4352.6 3231.5)'
              fill='url(#paint222_linear_344_5378)'
              fillOpacity='0.26'
              stroke='#646464'
              strokeWidth='5'
            />
            <g id='Rectangle 1211_13' filter='url(#filter85_f_344_5378)'>
              <rect
                x='4265.1'
                y='3244'
                width='50.8215'
                height='172.793'
                transform='rotate(-180 4265.1 3244)'
                fill='#959595'
              />
            </g>
            <g id='Rectangle 1212_10' filter='url(#filter86_f_344_5378)'>
              <rect
                x='4242.64'
                y='3242.02'
                width='5.08215'
                height='172.793'
                transform='rotate(-180 4242.64 3242.02)'
                fill='#B29D96'
              />
            </g>
          </g>
          <g id='image 293_2' className='blenmode-multiply'>
            <rect x='4120.5' y='1849.6' width='249.025' height='137.218' />
          </g>
          <g id='Group 1206_2'>
            <path
              id='Rectangle 1208_10'
              d='M4190.01 1224C4190.01 1218.48 4194.49 1214 4200.01 1214H4260.01C4265.53 1214 4270.01 1218.48 4270.01 1224V1284H4190.01V1224Z'
              fill='url(#paint223_linear_344_5378)'
            />
            <rect
              id='Rectangle 1207_10'
              x='4150.01'
              y='1224'
              width='160'
              height='40'
              rx='20'
              fill='url(#paint224_linear_344_5378)'
            />
            <g id='Rectangle 1211_14' filter='url(#filter87_f_344_5378)'>
              <rect
                x='4283.3'
                y='1229.08'
                width='10.1643'
                height='96.5608'
                transform='rotate(90 4283.3 1229.08)'
                fill='#B29D96'
              />
            </g>
            <g id='Rectangle 1212_11' filter='url(#filter88_f_344_5378)'>
              <rect
                x='4283.3'
                y='1249.41'
                width='5.08215'
                height='96.5608'
                transform='rotate(90 4283.3 1249.41)'
                fill='black'
              />
            </g>
          </g>
        </g>
        <g id='Group 1264'>
          <path
            id='Rectangle 1188_3'
            d='M1720 3858.9C1720 3848.65 1727.76 3840.04 1737.97 3839.1C1818.17 3831.7 1874.2 3832.8 1971.41 3839.53C1981.87 3840.26 1990 3848.97 1990 3859.46V4268.7C1990 4279.17 1981.88 4287.88 1971.43 4288.61C1865.83 4295.96 1808.01 4295.49 1737.97 4289.03C1727.76 4288.08 1720 4279.47 1720 4269.22V3858.9Z'
            fill='url(#paint225_linear_344_5378)'
          />
          <g id='Rectangle 1215_3' className='blenmode-overlay' filter='url(#filter89_f_344_5378)'>
            <rect x='1880' y='3924' width='60' height='350' fill='white' />
          </g>
          <g id='Group 1204_3'>
            <rect
              id='Rectangle 1189_5'
              x='1710'
              y='3804'
              width='290'
              height='110'
              rx='10'
              fill='url(#paint226_linear_344_5378)'
            />
            <g id='Rectangle 1213_5' filter='url(#filter90_f_344_5378)'>
              <rect x='1760.98' y='3785.47' width='76.2322' height='259.19' fill='white' />
            </g>
            <g id='Ellipse 710_5' filter='url(#filter91_f_344_5378)'>
              <ellipse cx='1875.33' cy='3907.45' rx='33.034' ry='101.643' fill='white' />
            </g>
            <g id='Rectangle 1214_5' filter='url(#filter92_f_344_5378)'>
              <rect x='1877.88' y='3805.8' width='5.08215' height='238.861' fill='white' />
            </g>
            <g id='Group 1264_2'>
              <rect
                id='Rectangle 1195_5'
                x='1700'
                y='3814.66'
                width='315.093'
                height='81.3144'
                rx='5'
                fill='url(#paint227_linear_344_5378)'
              />
              <g id='Rectangle 1243_5' filter='url(#filter93_f_344_5378)'>
                <rect x='1700' y='3824' width='310' height='10' fill='white' />
              </g>
              <g id='Rectangle 1244_5' filter='url(#filter94_f_344_5378)'>
                <rect x='1700' y='3874' width='310' height='10' fill='white' />
              </g>
              <g id='Rectangle 1245_5' filter='url(#filter95_f_344_5378)'>
                <rect x='1770' y='3824' width='50' height='70' fill='white' />
              </g>
            </g>
            <g id='Rectangle 1212_12' filter='url(#filter96_f_344_5378)'>
              <rect x='1840' y='3924' width='20' height='370' fill='#ECECEC' />
            </g>
          </g>
        </g>
        <g id='Subtract_4' filter='url(#filter97_iii_344_5378)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3566 139.377C3585.33 139.377 3601 155.047 3601 174.377L3601 389.105C3647.87 404.001 3682 449.805 3682 504C3682 558.196 3647.87 604 3601 618.896L3601 1032.62C3601 1051.95 3585.33 1067.62 3566 1067.62C3546.67 1067.62 3531 1051.95 3531 1032.62L3531 617.539L3531 603.433C3531 601.362 3532.32 599.5 3534.24 598.738C3601.76 572.018 3610 540.801 3610 496.5C3610 459.349 3569.83 417.85 3537.18 419.198C3533.98 419.33 3531 416.959 3531 413.757L3531 390.462L3531 389.5V174.377C3531 155.047 3546.67 139.377 3566 139.377Z'
            fill='#4F6228'
          />
        </g>
        <g id='Vector 299' filter='url(#filter98_i_344_5378)'>
          <path
            d='M3570 232C3570 229.239 3567.76 227 3565 227C3562.24 227 3560 229.238 3560 232L3570 232ZM3565 396.5L3560 396.5L3560 399.664L3562.86 401.018L3565 396.5ZM3565 622.5L3562.58 618.122C3560.99 619.002 3560 620.679 3560 622.5L3565 622.5ZM3560 1021.5C3560 1024.26 3562.24 1026.5 3565 1026.5C3567.76 1026.5 3570 1024.26 3570 1021.5L3560 1021.5ZM3560 273.099C3560 275.86 3562.24 278.099 3565 278.099C3567.76 278.099 3570 275.86 3570 273.099L3560 273.099ZM3570 355.386C3570 352.624 3567.76 350.386 3565 350.386C3562.23 350.386 3560 352.624 3560 355.386L3570 355.386ZM3620.8 442.181C3622.6 444.269 3625.76 444.497 3627.85 442.689C3629.94 440.882 3630.16 437.725 3628.36 435.637L3620.8 442.181ZM3623.26 576.581C3624.92 574.37 3624.47 571.236 3622.26 569.582C3620.04 567.928 3616.91 568.379 3615.26 570.59L3623.26 576.581ZM3560 672.28C3560 675.041 3562.24 677.28 3565 677.28C3567.76 677.28 3570 675.041 3570 672.28L3560 672.28ZM3570 772.093C3570 769.331 3567.76 767.093 3565 767.093C3562.24 767.093 3560 769.331 3560 772.093H3570ZM3560 871.883C3560 874.644 3562.24 876.883 3565 876.883C3567.76 876.883 3570 874.644 3570 871.883L3560 871.883ZM3570 971.771C3570 969.009 3567.76 966.771 3565 966.771C3562.24 966.771 3560 969.009 3560 971.771L3570 971.771ZM3565 232C3560 232 3560 232 3560 232C3560 232 3560 232 3560 232.001C3560 232.001 3560 232.002 3560 232.003C3560 232.005 3560 232.008 3560 232.012C3560 232.021 3560 232.033 3560 232.049C3560 232.082 3560 232.132 3560 232.197C3560 232.327 3560 232.522 3560 232.778C3560 233.29 3560 234.049 3560 235.035C3560 237.007 3560 239.886 3560 243.518C3560 250.783 3560 261.058 3560 273.099L3570 273.099C3570 261.058 3570 250.783 3570 243.519C3570 239.886 3570 237.007 3570 235.035C3570 234.049 3570 233.291 3570 232.778C3570 232.522 3570 232.328 3570 232.197C3570 232.132 3570 232.083 3570 232.05C3570 232.033 3570 232.021 3570 232.013C3570 232.008 3570 232.005 3570 232.003C3570 232.002 3570 232.001 3570 232.001C3570 232.001 3570 232 3570 232C3570 232 3570 232 3565 232ZM3560 355.386C3560 370.342 3560 384.534 3560 396.5L3570 396.5C3570 384.533 3570 370.341 3570 355.386L3560 355.386ZM3562.86 401.018C3589.52 413.655 3608.23 427.669 3620.8 442.181L3628.36 435.637C3614.67 419.824 3594.72 405.052 3567.14 391.982L3562.86 401.018ZM3615.26 570.59C3599.31 591.901 3579.22 608.941 3562.58 618.122L3567.41 626.878C3585.41 616.95 3606.55 598.922 3623.26 576.581L3615.26 570.59ZM3560 622.5C3560 630.102 3560 648.023 3560 672.28L3570 672.28C3570 648.023 3570 630.102 3570 622.5L3560 622.5ZM3560 772.093C3560 804.811 3560 839.317 3560 871.883L3570 871.883C3570 839.317 3570 804.811 3570 772.093H3560ZM3560 971.771C3560 986.926 3560 999.359 3560 1008C3560 1012.32 3560 1015.7 3560 1017.99C3560 1019.14 3560 1020.02 3560 1020.61C3560 1020.9 3560 1021.12 3560 1021.27C3560 1021.35 3560 1021.41 3560 1021.44C3560 1021.46 3560 1021.48 3560 1021.49C3560 1021.49 3560 1021.49 3560 1021.5C3560 1021.5 3560 1021.5 3560 1021.5C3560 1021.5 3560 1021.5 3560 1021.5C3560 1021.5 3560 1021.5 3565 1021.5C3570 1021.5 3570 1021.5 3570 1021.5C3570 1021.5 3570 1021.5 3570 1021.5C3570 1021.5 3570 1021.5 3570 1021.5C3570 1021.49 3570 1021.49 3570 1021.49C3570 1021.48 3570 1021.46 3570 1021.44C3570 1021.41 3570 1021.35 3570 1021.27C3570 1021.12 3570 1020.9 3570 1020.61C3570 1020.02 3570 1019.14 3570 1017.99C3570 1015.7 3570 1012.32 3570 1008C3570 999.359 3570 986.926 3570 971.771L3560 971.771Z'
            fill='white'
          />
        </g>
        <g id='Subtract_5' filter='url(#filter99_iii_344_5378)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3581.05 168.965C3578.29 168.965 3576.05 171.203 3576.05 173.965C3576.05 176.726 3578.29 178.965 3581.05 178.965H3636.87C3639.63 178.965 3641.87 176.726 3641.87 173.965C3641.87 171.203 3639.63 168.965 3636.87 168.965H3581.05ZM3748.52 168.965C3745.76 168.965 3743.52 171.203 3743.52 173.965C3743.52 176.726 3745.76 178.965 3748.52 178.965H3860.17C3862.93 178.965 3865.17 176.726 3865.17 173.965C3865.17 171.203 3862.93 168.965 3860.17 168.965H3748.52ZM3971.81 168.965C3969.05 168.965 3966.81 171.203 3966.81 173.965C3966.81 176.726 3969.05 178.965 3971.81 178.965H4083.46C4086.22 178.965 4088.46 176.726 4088.46 173.965C4088.46 171.203 4086.22 168.965 4083.46 168.965H3971.81ZM4195.11 168.965C4192.35 168.965 4190.11 171.203 4190.11 173.965C4190.11 176.726 4192.35 178.965 4195.11 178.965H4306.75C4309.52 178.965 4311.75 176.726 4311.75 173.965C4311.75 171.203 4309.52 168.965 4306.75 168.965H4195.11ZM4418.4 168.965C4415.64 168.965 4413.4 171.203 4413.4 173.965C4413.4 176.726 4415.64 178.965 4418.4 178.965H4530.05C4532.81 178.965 4535.05 176.726 4535.05 173.965C4535.05 171.203 4532.81 168.965 4530.05 168.965H4418.4ZM4641.7 168.965C4638.94 168.965 4636.7 171.203 4636.7 173.965C4636.7 176.726 4638.94 178.965 4641.7 178.965H4753.34C4756.11 178.965 4758.34 176.726 4758.34 173.965C4758.34 171.203 4756.11 168.965 4753.34 168.965H4641.7ZM4864.99 168.965C4862.23 168.965 4859.99 171.203 4859.99 173.965C4859.99 176.726 4862.23 178.965 4864.99 178.965H4976.64C4979.4 178.965 4981.64 176.726 4981.64 173.965C4981.64 171.203 4979.4 168.965 4976.64 168.965H4864.99ZM5088.29 168.965C5085.52 168.965 5083.29 171.203 5083.29 173.965C5083.29 176.726 5085.52 178.965 5088.29 178.965H5199.93C5202.69 178.965 5204.93 176.726 5204.93 173.965C5204.93 171.203 5202.69 168.965 5199.93 168.965H5088.29ZM5311.58 168.965C5308.82 168.965 5306.58 171.203 5306.58 173.965C5306.58 176.726 5308.82 178.965 5311.58 178.965H5423.23C5425.99 178.965 5428.23 176.726 5428.23 173.965C5428.23 171.203 5425.99 168.965 5423.23 168.965H5311.58ZM5534.88 168.965C5532.11 168.965 5529.88 171.203 5529.88 173.965C5529.88 176.726 5532.11 178.965 5534.88 178.965H5646.52C5649.28 178.965 5651.52 176.726 5651.52 173.965C5651.52 171.203 5649.28 168.965 5646.52 168.965H5534.88ZM5758.17 168.965C5755.41 168.965 5753.17 171.203 5753.17 173.965C5753.17 176.726 5755.41 178.965 5758.17 178.965H5869.82C5872.58 178.965 5874.82 176.726 5874.82 173.965C5874.82 171.203 5872.58 168.965 5869.82 168.965H5758.17ZM5981.47 168.965C5978.7 168.965 5976.47 171.203 5976.47 173.965C5976.47 176.726 5978.7 178.965 5981.47 178.965H6093.11C6095.87 178.965 6098.11 176.726 6098.11 173.965C6098.11 171.203 6095.87 168.965 6093.11 168.965H5981.47ZM6204.76 168.965C6202 168.965 6199.76 171.203 6199.76 173.965C6199.76 176.726 6202 178.965 6204.76 178.965H6316.41C6319.17 178.965 6321.41 176.726 6321.41 173.965C6321.41 171.203 6319.17 168.965 6316.41 168.965H6204.76ZM6428.05 168.965C6425.29 168.965 6423.05 171.203 6423.05 173.965C6423.05 176.726 6425.29 178.965 6428.05 178.965H6539.7C6542.46 178.965 6544.7 176.726 6544.7 173.965C6544.7 171.203 6542.46 168.965 6539.7 168.965H6428.05ZM6651.35 168.965C6648.59 168.965 6646.35 171.203 6646.35 173.965C6646.35 176.726 6648.59 178.965 6651.35 178.965H6763C6765.76 178.965 6768 176.726 6768 173.965C6768 171.203 6765.76 168.965 6763 168.965H6651.35ZM6874.64 168.965C6871.88 168.965 6869.64 171.203 6869.64 173.965C6869.64 176.726 6871.88 178.965 6874.64 178.965H6986.29C6989.05 178.965 6991.29 176.726 6991.29 173.965C6991.29 171.203 6989.05 168.965 6986.29 168.965H6874.64ZM7097.94 168.965C7095.18 168.965 7092.94 171.203 7092.94 173.965C7092.94 176.726 7095.18 178.965 7097.94 178.965H7209.59C7212.35 178.965 7214.59 176.726 7214.59 173.965C7214.59 171.203 7212.35 168.965 7209.59 168.965H7097.94ZM7321.23 168.965C7318.47 168.965 7316.23 171.203 7316.23 173.965C7316.23 176.726 7318.47 178.965 7321.23 178.965H7432.88C7435.64 178.965 7437.88 176.726 7437.88 173.965C7437.88 171.203 7435.64 168.965 7432.88 168.965H7321.23ZM7544.53 168.965C7541.77 168.965 7539.53 171.203 7539.53 173.965C7539.53 176.726 7541.77 178.965 7544.53 178.965H7656.18C7658.94 178.965 7661.18 176.726 7661.18 173.965C7661.18 171.203 7658.94 168.965 7656.18 168.965H7544.53ZM7767.82 168.965C7765.06 168.965 7762.82 171.203 7762.82 173.965C7762.82 176.726 7765.06 178.965 7767.82 178.965H7879.47C7882.23 178.965 7884.47 176.726 7884.47 173.965C7884.47 171.203 7882.23 168.965 7879.47 168.965H7767.82ZM7991.12 168.965C7988.36 168.965 7986.12 171.203 7986.12 173.965C7986.12 176.726 7988.36 178.965 7991.12 178.965H8102.77C8105.53 178.965 8107.77 176.726 8107.77 173.965C8107.77 171.203 8105.53 168.965 8102.77 168.965H7991.12ZM8214.41 168.965C8211.65 168.965 8209.41 171.203 8209.41 173.965C8209.41 176.726 8211.65 178.965 8214.41 178.965H8326.06C8328.82 178.965 8331.06 176.726 8331.06 173.965C8331.06 171.203 8328.82 168.965 8326.06 168.965H8214.41ZM8437.71 168.965C8434.95 168.965 8432.71 171.203 8432.71 173.965C8432.71 176.726 8434.95 178.965 8437.71 178.965H8549.36C8552.12 178.965 8554.36 176.726 8554.36 173.965C8554.36 171.203 8552.12 168.965 8549.36 168.965H8437.71ZM8661 168.965C8658.24 168.965 8656 171.203 8656 173.965C8656 176.726 8658.24 178.965 8661 178.965H8772.65C8775.41 178.965 8777.65 176.726 8777.65 173.965C8777.65 171.203 8775.41 168.965 8772.65 168.965H8661ZM8884.3 168.965C8881.54 168.965 8879.3 171.203 8879.3 173.965C8879.3 176.726 8881.54 178.965 8884.3 178.965H8995.95C8998.71 178.965 9000.95 176.726 9000.95 173.965C9000.95 171.203 8998.71 168.965 8995.95 168.965H8884.3ZM9107.59 168.965C9104.83 168.965 9102.59 171.203 9102.59 173.965C9102.59 176.726 9104.83 178.965 9107.59 178.965H9219.24C9222 178.965 9224.24 176.726 9224.24 173.965C9224.24 171.203 9222 168.965 9219.24 168.965H9107.59ZM9330.89 168.965C9328.13 168.965 9325.89 171.203 9325.89 173.965C9325.89 176.726 9328.13 178.965 9330.89 178.965H9442.54C9445.3 178.965 9447.54 176.726 9447.54 173.965C9447.54 171.203 9445.3 168.965 9442.54 168.965H9330.89ZM9554.18 168.965C9551.42 168.965 9549.18 171.203 9549.18 173.965C9549.18 176.726 9551.42 178.965 9554.18 178.965H9605V228.487C9605 231.249 9607.24 233.487 9610 233.487C9612.77 233.487 9615 231.249 9615 228.487V173.965C9615 171.203 9612.77 168.965 9610 168.965H9554.18ZM9615 337.532C9615 334.77 9612.77 332.532 9610 332.532C9607.24 332.532 9605 334.77 9605 337.532V446.576C9605 449.338 9607.24 451.576 9610 451.576C9612.77 451.576 9615 449.338 9615 446.576V337.532ZM9615 555.621C9615 552.859 9612.77 550.621 9610 550.621C9607.24 550.621 9605 552.859 9605 555.621V664.665C9605 667.427 9607.24 669.665 9610 669.665C9612.77 669.665 9615 667.427 9615 664.665V555.621ZM9615 773.71C9615 770.948 9612.77 768.71 9610 768.71C9607.24 768.71 9605 770.948 9605 773.71V841.667C9608.44 842.181 9611.78 842.913 9615 843.845V773.71ZM9615 991.799C9615 989.037 9612.77 986.799 9610 986.799C9607.24 986.799 9605 989.037 9605 991.799V1004.48H9615V991.799ZM9615 1479.52H9605V1537.02C9605 1539.78 9607.24 1542.02 9610 1542.02C9612.77 1542.02 9615 1539.78 9615 1537.02V1479.52ZM9615 1646.07C9615 1643.3 9612.77 1641.07 9610 1641.07C9607.24 1641.07 9605 1643.3 9605 1646.07V1755.11C9605 1757.87 9607.24 1760.11 9610 1760.11C9612.77 1760.11 9615 1757.87 9615 1755.11V1646.07ZM9615 1864.15C9615 1861.39 9612.77 1859.15 9610 1859.15C9607.24 1859.15 9605 1861.39 9605 1864.15V1973.2C9605 1975.96 9607.24 1978.2 9610 1978.2C9612.77 1978.2 9615 1975.96 9615 1973.2V1864.15ZM9615 2082.24C9615 2079.48 9612.77 2077.24 9610 2077.24C9607.24 2077.24 9605 2079.48 9605 2082.24V2191.29C9605 2194.05 9607.24 2196.29 9610 2196.29C9612.77 2196.29 9615 2194.05 9615 2191.29V2082.24ZM9615 2300.33C9615 2297.57 9612.77 2295.33 9610 2295.33C9607.24 2295.33 9605 2297.57 9605 2300.33V2409.38C9605 2412.14 9607.24 2414.38 9610 2414.38C9612.77 2414.38 9615 2412.14 9615 2409.38V2300.33ZM9615 2518.42C9615 2515.66 9612.77 2513.42 9610 2513.42C9607.24 2513.42 9605 2515.66 9605 2518.42V2627.47C9605 2630.23 9607.24 2632.47 9610 2632.47C9612.77 2632.47 9615 2630.23 9615 2627.47V2518.42ZM9615 2736.51C9615 2733.75 9612.77 2731.51 9610 2731.51C9607.24 2731.51 9605 2733.75 9605 2736.51V2845.56C9605 2848.32 9607.24 2850.56 9610 2850.56C9612.77 2850.56 9615 2848.32 9615 2845.56V2736.51ZM9615 2954.6C9615 2951.84 9612.77 2949.6 9610 2949.6C9607.24 2949.6 9605 2951.84 9605 2954.6V3063.64C9605 3066.41 9607.24 3068.64 9610 3068.64C9612.77 3068.64 9615 3066.41 9615 3063.64V2954.6ZM9615 3172.69C9615 3169.93 9612.77 3167.69 9610 3167.69C9607.24 3167.69 9605 3169.93 9605 3172.69V3227.21C9605 3229.97 9607.24 3232.21 9610 3232.21C9612.77 3232.21 9615 3229.97 9615 3227.21V3172.69Z'
            fill='white'
          />
        </g>
        <g id='Subtract_6' filter='url(#filter100_i_344_5378)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3566 1083.81C3566 1081.05 3563.76 1078.81 3561 1078.81C3558.24 1078.81 3556 1081.05 3556 1083.81V1128.04C3556 1130.8 3558.24 1133.04 3561 1133.04C3563.76 1133.04 3566 1130.8 3566 1128.04V1083.81ZM3566 1216.5C3566 1213.74 3563.76 1211.5 3561 1211.5C3558.24 1211.5 3556 1213.74 3556 1216.5V1304.97C3556 1307.73 3558.24 1309.97 3561 1309.97C3563.76 1309.97 3566 1307.73 3566 1304.97V1216.5ZM3566 1393.43C3566 1390.67 3563.76 1388.43 3561 1388.43C3558.24 1388.43 3556 1390.67 3556 1393.43V1437.66V1442.66H3561H3603.25C3606.01 1442.66 3608.25 1440.42 3608.25 1437.66C3608.25 1434.9 3606.01 1432.66 3603.25 1432.66H3566V1393.43ZM3687.75 1432.66C3684.99 1432.66 3682.75 1434.9 3682.75 1437.66C3682.75 1440.42 3684.99 1442.66 3687.75 1442.66H3730C3732.76 1442.66 3735 1440.42 3735 1437.66C3735 1434.9 3732.76 1432.66 3730 1432.66H3687.75Z'
            fill='white'
          />
        </g>
        <g id='Group 1330'>
          <g id='Group 1263'>
            <g id='Rectangle 1215_4' className='blenmode-overlay' filter='url(#filter101_f_344_5378)'>
              <rect x='3897.7' y='1798.78' width='35.575' height='406.572' fill='white' fillOpacity='0.54' />
            </g>
            <g id='image 293_3' className='blenmode-multiply'>
              <rect x='3760.5' y='1849.6' width='249.025' height='137.218' />
            </g>
            <g id='Group 1206_3'>
              <path
                id='Rectangle 1208_11'
                d='M3820.01 1224C3820.01 1218.48 3824.49 1214 3830.01 1214H3890.01C3895.53 1214 3900.01 1218.48 3900.01 1224V1284H3820.01V1224Z'
                fill='url(#paint228_linear_344_5378)'
              />
              <rect
                id='Rectangle 1207_11'
                x='3780.01'
                y='1224'
                width='160'
                height='40'
                rx='20'
                fill='url(#paint229_linear_344_5378)'
              />
              <g id='Rectangle 1211_15' filter='url(#filter102_f_344_5378)'>
                <rect
                  x='3913.3'
                  y='1229.08'
                  width='10.1643'
                  height='96.5608'
                  transform='rotate(90 3913.3 1229.08)'
                  fill='#B29D96'
                />
              </g>
              <g id='Rectangle 1212_13' filter='url(#filter103_f_344_5378)'>
                <rect
                  x='3913.3'
                  y='1249.41'
                  width='5.08215'
                  height='96.5608'
                  transform='rotate(90 3913.3 1249.41)'
                  fill='black'
                />
              </g>
            </g>
          </g>
          <g id='Group 1329'>
            <path
              id='Rectangle 1188_4'
              d='M3740.01 1710.9C3740.01 1632.11 3781.55 1554.61 3860.33 1554.01C3946.54 1553.35 4010.01 1640.01 4010.01 1726.23V3152.75C4010.01 3238.78 3937.98 3326.66 3852 3323.85C3773.03 3321.26 3740.01 3246.2 3740.01 3167.19V1710.9Z'
              fill='url(#paint230_linear_344_5378)'
            />
            <g id='Group 1204_4'>
              <rect
                id='Rectangle 1189_6'
                x='3730.01'
                y='1284'
                width='290'
                height='280'
                rx='10'
                fill='url(#paint231_linear_344_5378)'
              />
              <g id='Rectangle 1213_6' filter='url(#filter104_f_344_5378)'>
                <rect x='3781' y='1285.47' width='76.2322' height='259.19' fill='white' />
              </g>
              <g id='Ellipse 710_6' filter='url(#filter105_f_344_5378)'>
                <ellipse cx='3895.34' cy='1407.45' rx='33.034' ry='101.643' fill='white' />
              </g>
              <g id='Rectangle 1214_6' filter='url(#filter106_f_344_5378)'>
                <rect x='3897.88' y='1305.8' width='5.08215' height='238.861' fill='white' />
              </g>
              <rect
                id='Rectangle 1194_5'
                x='3972.51'
                y='1306.5'
                width='25'
                height='215'
                rx='12.5'
                fill='url(#paint232_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1223_8'
                x='3922.51'
                y='1306.5'
                width='25'
                height='215'
                rx='12.5'
                fill='url(#paint233_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1224_8'
                x='3862.51'
                y='1306.5'
                width='25'
                height='215'
                rx='12.5'
                fill='url(#paint234_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1225_8'
                x='3802.51'
                y='1306.5'
                width='25'
                height='215'
                rx='12.5'
                fill='url(#paint235_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1226_8'
                x='3742.51'
                y='1306.5'
                width='25'
                height='215'
                rx='12.5'
                fill='url(#paint236_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1196_5'
                x='3730.01'
                y='1614'
                width='290'
                height='200'
                rx='10'
                fill='url(#paint237_linear_344_5378)'
              />
              <rect
                id='Rectangle 1195_6'
                x='3720.01'
                y='1544.66'
                width='315.093'
                height='81.3144'
                rx='5'
                fill='url(#paint238_linear_344_5378)'
              />
              <rect
                id='Rectangle 1240_5'
                x='3742.51'
                y='1576.5'
                width='55'
                height='15'
                rx='7.5'
                fill='url(#paint239_linear_344_5378)'
                stroke='#B3B3B3'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1241_5'
                x='3832.51'
                y='1576.5'
                width='55'
                height='15'
                rx='7.5'
                fill='url(#paint240_linear_344_5378)'
                stroke='#B3B3B3'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1242_5'
                x='3942.51'
                y='1576.5'
                width='55'
                height='15'
                rx='7.5'
                fill='url(#paint241_linear_344_5378)'
                stroke='#B3B3B3'
                strokeWidth='5'
              />
              <g id='Rectangle 1243_6' filter='url(#filter107_f_344_5378)'>
                <rect x='3720.01' y='1554' width='310' height='10' fill='white' />
              </g>
              <g id='Rectangle 1244_6' filter='url(#filter108_f_344_5378)'>
                <rect x='3720.01' y='1604' width='310' height='10' fill='white' />
              </g>
              <g id='Rectangle 1245_6' filter='url(#filter109_f_344_5378)'>
                <rect x='3790.01' y='1554' width='50' height='70' fill='white' />
              </g>
              <rect
                id='Rectangle 1219_5'
                x='3972.51'
                y='1636.5'
                width='25'
                height='155'
                rx='7.5'
                fill='url(#paint242_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1220_5'
                x='3892.51'
                y='1636.5'
                width='25'
                height='155'
                rx='7.5'
                fill='url(#paint243_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1221_5'
                x='3822.51'
                y='1636.5'
                width='25'
                height='155'
                rx='7.5'
                fill='url(#paint244_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1222_5'
                x='3762.51'
                y='1636.5'
                width='25'
                height='155'
                rx='7.5'
                fill='url(#paint245_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <g id='Rectangle 1211_16' filter='url(#filter110_f_344_5378)'>
                <rect x='3850.01' y='1624' width='50.8215' height='172.793' fill='#959595' />
              </g>
              <g id='Rectangle 1212_14' filter='url(#filter111_f_344_5378)'>
                <rect x='3872.47' y='1625.98' width='5.08215' height='172.793' fill='#B29D96' />
              </g>
            </g>
            <g id='Group 1207_3'>
              <rect
                id='Rectangle 1189_7'
                x='4025.1'
                y='3584'
                width='290'
                height='280'
                rx='10'
                transform='rotate(-180 4025.1 3584)'
                fill='url(#paint246_linear_344_5378)'
              />
              <g id='Rectangle 1213_7' filter='url(#filter112_f_344_5378)'>
                <rect
                  x='3974.11'
                  y='3582.53'
                  width='76.2322'
                  height='259.19'
                  transform='rotate(-180 3974.11 3582.53)'
                  fill='white'
                />
              </g>
              <g id='Ellipse 710_7' filter='url(#filter113_f_344_5378)'>
                <ellipse
                  cx='3859.77'
                  cy='3460.55'
                  rx='33.034'
                  ry='101.643'
                  transform='rotate(-180 3859.77 3460.55)'
                  fill='white'
                />
              </g>
              <g id='Rectangle 1214_7' filter='url(#filter114_f_344_5378)'>
                <rect
                  x='3857.23'
                  y='3562.2'
                  width='5.08215'
                  height='238.861'
                  transform='rotate(-180 3857.23 3562.2)'
                  fill='white'
                />
              </g>
              <rect
                id='Rectangle 1194_6'
                x='3782.6'
                y='3561.5'
                width='25'
                height='215'
                rx='12.5'
                transform='rotate(-180 3782.6 3561.5)'
                fill='url(#paint247_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1223_9'
                x='3832.6'
                y='3561.5'
                width='25'
                height='215'
                rx='12.5'
                transform='rotate(-180 3832.6 3561.5)'
                fill='url(#paint248_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1224_9'
                x='3892.6'
                y='3561.5'
                width='25'
                height='215'
                rx='12.5'
                transform='rotate(-180 3892.6 3561.5)'
                fill='url(#paint249_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1225_9'
                x='3952.6'
                y='3561.5'
                width='25'
                height='215'
                rx='12.5'
                transform='rotate(-180 3952.6 3561.5)'
                fill='url(#paint250_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1226_9'
                x='4012.6'
                y='3561.5'
                width='25'
                height='215'
                rx='12.5'
                transform='rotate(-180 4012.6 3561.5)'
                fill='url(#paint251_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#C9C9C9'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1196_6'
                x='4025.1'
                y='3254'
                width='290'
                height='200'
                rx='10'
                transform='rotate(-180 4025.1 3254)'
                fill='url(#paint252_linear_344_5378)'
              />
              <rect
                id='Rectangle 1195_7'
                x='4035.1'
                y='3323.34'
                width='315.093'
                height='81.3144'
                rx='5'
                transform='rotate(-180 4035.1 3323.34)'
                fill='url(#paint253_linear_344_5378)'
              />
              <rect
                id='Rectangle 1240_6'
                x='3742.5'
                y='3266.5'
                width='55'
                height='15'
                rx='7.5'
                fill='url(#paint254_linear_344_5378)'
                stroke='#B3B3B3'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1241_6'
                x='3832.5'
                y='3266.5'
                width='55'
                height='15'
                rx='7.5'
                fill='url(#paint255_linear_344_5378)'
                stroke='#B3B3B3'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1242_6'
                x='3942.5'
                y='3266.5'
                width='55'
                height='15'
                rx='7.5'
                fill='url(#paint256_linear_344_5378)'
                stroke='#B3B3B3'
                strokeWidth='5'
              />
              <g id='Rectangle 1243_7' filter='url(#filter115_f_344_5378)'>
                <rect x='3720' y='3244' width='310' height='10' fill='white' />
              </g>
              <g id='Rectangle 1244_7' filter='url(#filter116_f_344_5378)'>
                <rect x='3720' y='3294' width='310' height='10' fill='white' />
              </g>
              <g id='Rectangle 1245_7' filter='url(#filter117_f_344_5378)'>
                <rect x='3790' y='3244' width='50' height='70' fill='white' />
              </g>
              <rect
                id='Rectangle 1219_6'
                x='3782.6'
                y='3231.5'
                width='25'
                height='155'
                rx='7.5'
                transform='rotate(-180 3782.6 3231.5)'
                fill='url(#paint257_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1220_6'
                x='3862.6'
                y='3231.5'
                width='25'
                height='155'
                rx='7.5'
                transform='rotate(-180 3862.6 3231.5)'
                fill='url(#paint258_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1221_6'
                x='3932.6'
                y='3231.5'
                width='25'
                height='155'
                rx='7.5'
                transform='rotate(-180 3932.6 3231.5)'
                fill='url(#paint259_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <rect
                id='Rectangle 1222_6'
                x='3992.6'
                y='3231.5'
                width='25'
                height='155'
                rx='7.5'
                transform='rotate(-180 3992.6 3231.5)'
                fill='url(#paint260_linear_344_5378)'
                fillOpacity='0.26'
                stroke='#646464'
                strokeWidth='5'
              />
              <g id='Rectangle 1211_17' filter='url(#filter118_f_344_5378)'>
                <rect
                  x='3905.1'
                  y='3244'
                  width='50.8215'
                  height='172.793'
                  transform='rotate(-180 3905.1 3244)'
                  fill='#959595'
                />
              </g>
              <g id='Rectangle 1212_15' filter='url(#filter119_f_344_5378)'>
                <rect
                  x='3882.64'
                  y='3242.02'
                  width='5.08215'
                  height='172.793'
                  transform='rotate(-180 3882.64 3242.02)'
                  fill='#B29D96'
                />
              </g>
            </g>
            <g id='Group 793'>
              <g id='Water Solutions'>
                <path
                  d='M3792.05 2038.07C3793.12 2034.94 3794.65 2028.6 3795.45 2022.95H3799.35C3798.34 2029.19 3796.57 2036.54 3794.3 2041.68H3790.1C3788.79 2038.34 3787.61 2034.4 3786.62 2030.02C3785.61 2034.4 3784.46 2038.34 3783.12 2041.68H3778.92C3776.78 2036.54 3774.88 2029.19 3773.89 2022.95H3777.77C3778.6 2028.6 3780.1 2034.94 3781.19 2038.07C3782.34 2034.94 3784.14 2028.79 3784.91 2022.95H3788.33C3789.14 2028.79 3790.88 2034.94 3792.05 2038.07Z'
                  fill='black'
                />
                <path
                  d='M3805.8 2039.35C3806.6 2039.35 3807.27 2039.19 3807.67 2038.98V2036.11C3807.06 2035.98 3806.42 2035.9 3805.77 2035.9C3804.54 2035.9 3803.58 2036.38 3803.58 2037.64C3803.58 2038.76 3804.38 2039.35 3805.8 2039.35ZM3811.26 2040.82C3810.16 2041.38 3808.1 2042 3805.43 2042C3801.76 2042 3799.92 2040.21 3799.92 2037.8C3799.92 2035.15 3802.08 2033.6 3805.29 2033.57C3806.04 2033.57 3807 2033.68 3807.67 2033.79V2033.15C3807.67 2031.51 3806.74 2030.74 3804.94 2030.74C3803.77 2030.74 3802.51 2030.93 3801.41 2031.38L3800.74 2028.49C3801.89 2028.01 3803.74 2027.69 3805.37 2027.69C3809.3 2027.69 3811.26 2029.78 3811.26 2033.39V2040.82Z'
                  fill='black'
                />
                <path
                  d='M3822.19 2041.76C3821.54 2041.92 3820.69 2042 3819.86 2042C3816.68 2042 3815.04 2040.26 3815.04 2036.73V2030.95H3813.23V2028.01H3815.04V2025.04L3818.74 2024.85V2028.01H3821.7V2030.95H3818.74V2036.68C3818.74 2038.23 3819.38 2038.95 3820.58 2038.95C3821.14 2038.95 3821.65 2038.87 3822 2038.79L3822.19 2041.76Z'
                  fill='black'
                />
                <path
                  d='M3834.87 2038.12L3835.46 2041.09C3834.28 2041.63 3832.55 2042 3830.78 2042C3826.47 2042 3823.53 2039.27 3823.53 2034.83C3823.53 2030.58 3826.23 2027.69 3830.17 2027.69C3833.67 2027.69 3835.97 2030.18 3835.97 2033.76C3835.97 2034.56 3835.92 2035.26 3835.86 2035.79H3827.41C3827.76 2037.93 3829.02 2038.9 3831.16 2038.9C3832.47 2038.9 3833.72 2038.6 3834.87 2038.12ZM3830.17 2030.63C3828.61 2030.63 3827.6 2031.73 3827.36 2033.55H3832.44V2033.23C3832.44 2031.73 3831.64 2030.63 3830.17 2030.63Z'
                  fill='black'
                />
                <path
                  d='M3838.78 2028.87C3840.22 2028.14 3842.47 2027.69 3844.4 2027.69C3845.36 2027.69 3846.27 2027.8 3846.8 2027.93L3846.27 2030.95C3845.81 2030.79 3845.25 2030.74 3844.69 2030.74C3843.7 2030.74 3843.03 2030.93 3842.47 2031.19V2041.68H3838.78V2028.87Z'
                  fill='black'
                />
                <path
                  d='M3854.46 2040.9L3855.15 2037.67C3856.41 2038.15 3858.2 2038.68 3860.08 2038.68C3862.14 2038.68 3863.18 2037.93 3863.18 2036.54C3863.18 2034.86 3861.95 2034.38 3859.54 2033.6C3856.49 2032.56 3854.51 2031.14 3854.51 2028.01C3854.51 2024.61 3856.84 2022.63 3860.96 2022.63C3862.96 2022.63 3864.84 2023.09 3865.99 2023.6L3865.24 2026.78C3864.01 2026.3 3862.7 2025.95 3861.2 2025.95C3859.33 2025.95 3858.39 2026.59 3858.39 2027.9C3858.39 2029.35 3859.33 2029.8 3861.41 2030.55C3864.6 2031.65 3867.03 2032.85 3867.03 2036.52C3867.03 2040.1 3864.25 2042 3860.24 2042C3857.94 2042 3855.8 2041.52 3854.46 2040.9Z'
                  fill='black'
                />
                <path
                  d='M3882.17 2034.83C3882.17 2039.14 3879.66 2042 3875.51 2042C3871.39 2042 3868.83 2039.14 3868.83 2034.83C3868.83 2030.55 3871.39 2027.69 3875.51 2027.69C3879.66 2027.69 3882.17 2030.55 3882.17 2034.83ZM3872.6 2034.83C3872.6 2037.37 3873.64 2038.95 3875.51 2038.95C3877.41 2038.95 3878.4 2037.37 3878.4 2034.83C3878.4 2032.32 3877.41 2030.74 3875.51 2030.74C3873.64 2030.74 3872.6 2032.32 3872.6 2034.83Z'
                  fill='black'
                />
                <path
                  d='M3888.54 2022.29V2036.73C3888.54 2038.17 3888.92 2038.95 3889.99 2038.95C3890.26 2038.95 3890.52 2038.92 3890.76 2038.87L3891.03 2041.79C3890.52 2041.89 3889.69 2042 3889.16 2042C3886.08 2042 3884.85 2039.99 3884.85 2036.78V2022.5L3888.54 2022.29Z'
                  fill='black'
                />
                <path
                  d='M3904.99 2040.82C3903.95 2041.25 3901.43 2042 3898.89 2042C3894.37 2042 3892.87 2039.7 3892.87 2036.28V2028.01H3896.54V2036.28C3896.54 2037.96 3897.29 2038.95 3898.97 2038.95C3899.85 2038.95 3900.63 2038.79 3901.3 2038.47V2028.01H3904.99V2040.82Z'
                  fill='black'
                />
                <path
                  d='M3916.07 2041.76C3915.42 2041.92 3914.57 2042 3913.74 2042C3910.55 2042 3908.92 2040.26 3908.92 2036.73V2030.95H3907.1V2028.01H3908.92V2025.04L3912.61 2024.85V2028.01H3915.58V2030.95H3912.61V2036.68C3912.61 2038.23 3913.26 2038.95 3914.46 2038.95C3915.02 2038.95 3915.53 2038.87 3915.88 2038.79L3916.07 2041.76Z'
                  fill='black'
                />
                <path
                  d='M3922.03 2028.01V2041.68H3918.34V2028.01H3922.03ZM3920.19 2026.19C3918.83 2026.19 3918.05 2025.36 3918.05 2024.13C3918.05 2022.9 3918.83 2022.07 3920.19 2022.07C3921.53 2022.07 3922.3 2022.9 3922.3 2024.13C3922.3 2025.36 3921.53 2026.19 3920.19 2026.19Z'
                  fill='black'
                />
                <path
                  d='M3938.2 2034.83C3938.2 2039.14 3935.69 2042 3931.54 2042C3927.42 2042 3924.86 2039.14 3924.86 2034.83C3924.86 2030.55 3927.42 2027.69 3931.54 2027.69C3935.69 2027.69 3938.2 2030.55 3938.2 2034.83ZM3928.63 2034.83C3928.63 2037.37 3929.67 2038.95 3931.54 2038.95C3933.44 2038.95 3934.43 2037.37 3934.43 2034.83C3934.43 2032.32 3933.44 2030.74 3931.54 2030.74C3929.67 2030.74 3928.63 2032.32 3928.63 2034.83Z'
                  fill='black'
                />
                <path
                  d='M3944.65 2041.68H3940.99V2028.87C3942.68 2028.14 3944.98 2027.69 3947.04 2027.69C3950.94 2027.69 3953.19 2029.62 3953.19 2033.17V2041.68H3949.5V2033.44C3949.5 2031.59 3948.64 2030.74 3947.01 2030.74C3946.15 2030.74 3945.35 2030.9 3944.65 2031.22V2041.68Z'
                  fill='black'
                />
                <path
                  d='M3965.3 2028.47L3964.9 2031.46C3963.67 2031.09 3962.47 2030.74 3961.19 2030.74C3960.06 2030.74 3959.31 2031.06 3959.31 2031.84C3959.31 2032.64 3959.93 2032.88 3961.53 2033.33C3964.64 2034.19 3966.08 2035.23 3966.08 2037.69C3966.08 2040.58 3963.73 2042 3960.46 2042C3958.75 2042 3956.85 2041.65 3955.62 2041.12L3956.13 2038.09C3957.31 2038.55 3958.81 2038.95 3960.38 2038.95C3961.61 2038.95 3962.47 2038.52 3962.47 2037.77C3962.47 2036.89 3961.8 2036.65 3959.61 2036.03C3957.15 2035.39 3955.68 2034.24 3955.68 2031.92C3955.68 2029.19 3957.63 2027.69 3960.89 2027.69C3962.42 2027.69 3964.15 2028.01 3965.3 2028.47Z'
                  fill='black'
                />
              </g>
              <path
                id='DuPont Logo SVG'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3891.02 1928.03C3883.93 1927.66 3879.71 1931.03 3879.71 1938.73V1977.02C3879.71 1985.16 3883.53 1988.51 3891.02 1988.16C3898.34 1987.82 3902.17 1984.82 3902.17 1976.17V1939.62C3902.17 1931.37 3898.71 1928.43 3891.02 1928.03V1928.03ZM3863.51 1928.35C3862.18 1928.35 3857.33 1928.53 3852.87 1928.82V1987.35C3854.38 1987.44 3858.36 1987.66 3860.51 1987.72V1967.84L3863.51 1967.84C3871.52 1967.81 3874.85 1963.95 3874.85 1956.51V1939.27C3874.85 1931.99 3871.11 1928.36 3863.51 1928.36V1928.35V1928.35ZM3839.25 1975C3839.25 1977.32 3838.51 1978.78 3835.83 1978.43C3833.19 1978.09 3832.48 1976.89 3832.48 1974.15V1930.66C3830.73 1930.86 3826.83 1931.44 3825.16 1931.7V1975.69C3825.16 1982.71 3828.33 1985.44 3835.83 1986.37C3842.69 1987.22 3846.9 1983.48 3846.9 1975.69V1929.22C3845.46 1929.3 3840.76 1929.73 3839.25 1929.9V1975L3839.25 1975ZM3923.39 1960.63L3914.91 1930.87C3912.6 1930.54 3909.81 1930.21 3907.66 1930V1986.17C3909.17 1986.02 3913.03 1985.55 3915.02 1985.27L3914.41 1952.17L3923.39 1983.98C3925.3 1983.65 3928.09 1983.13 3929.92 1982.75V1933.4C3928.01 1932.99 3924.54 1932.36 3922.86 1932.09L3923.39 1960.63L3923.39 1960.63ZM3810.99 1935.22C3808.56 1935.22 3805.05 1935.99 3798.72 1938.1V1978.06C3804.29 1979.88 3808.56 1980.94 3810.99 1980.94C3816.59 1980.94 3819.74 1977.25 3819.74 1971.35V1944.81C3819.74 1938.91 3816.59 1935.22 3810.99 1935.22ZM3933.7 1942.03C3935.6 1942.4 3937.46 1942.8 3939.28 1943.23V1980.58C3940.95 1980.16 3944.06 1979.29 3946.13 1978.63V1944.99C3948.11 1945.55 3949.99 1946.1 3951.7 1946.63V1939.43C3946.29 1937.4 3940.49 1935.74 3933.7 1934.22V1942.03L3933.7 1942.03ZM3894.44 1976.34C3894.44 1978.65 3893.72 1979.85 3891.02 1979.94C3888.23 1980.02 3887.47 1978.74 3887.47 1976.34V1939.85C3887.47 1937.45 3888.23 1936.12 3891.02 1936.21C3893.72 1936.29 3894.44 1937.53 3894.44 1939.85V1976.34ZM3812.81 1970.32C3812.81 1972.63 3811.52 1973.4 3809.98 1973.4C3808.77 1973.4 3806.92 1972.93 3805.41 1972.49V1943.66C3806.92 1943.23 3808.77 1942.76 3809.98 1942.76C3811.52 1942.76 3812.81 1943.53 3812.81 1945.84V1970.32V1970.32ZM3959.92 1942.97C3968.62 1947.38 3973.61 1952.52 3973.61 1957.99C3973.61 1963.53 3968.62 1968.69 3959.92 1973.14V1942.97ZM3773 1957.99C3773 1963.52 3777.99 1968.69 3786.68 1973.13V1942.98C3777.99 1947.38 3773 1952.52 3773 1957.99ZM3867.12 1955.9C3867.12 1958.42 3866.31 1959.69 3863.2 1959.7L3860.51 1959.71V1936.61C3861.71 1936.54 3862.34 1936.52 3863.06 1936.52C3866.42 1936.52 3867.12 1937.9 3867.12 1940.46V1955.9Z'
                fill='#E4001C'
              />
            </g>
          </g>
        </g>
        <g id='Group 1275'>
          <g id='Water Solutions_2'>
            <path
              d='M4160.05 2038.07C4161.12 2034.94 4162.65 2028.6 4163.45 2022.95H4167.35C4166.34 2029.19 4164.57 2036.54 4162.3 2041.68H4158.1C4156.79 2038.34 4155.61 2034.4 4154.62 2030.02C4153.61 2034.4 4152.46 2038.34 4151.12 2041.68H4146.92C4144.78 2036.54 4142.88 2029.19 4141.89 2022.95H4145.77C4146.6 2028.6 4148.1 2034.94 4149.19 2038.07C4150.34 2034.94 4152.14 2028.79 4152.91 2022.95H4156.33C4157.14 2028.79 4158.88 2034.94 4160.05 2038.07Z'
              fill='black'
            />
            <path
              d='M4173.8 2039.35C4174.6 2039.35 4175.27 2039.19 4175.67 2038.98V2036.11C4175.06 2035.98 4174.42 2035.9 4173.77 2035.9C4172.54 2035.9 4171.58 2036.38 4171.58 2037.64C4171.58 2038.76 4172.38 2039.35 4173.8 2039.35ZM4179.26 2040.82C4178.16 2041.38 4176.1 2042 4173.43 2042C4169.76 2042 4167.92 2040.21 4167.92 2037.8C4167.92 2035.15 4170.08 2033.6 4173.29 2033.57C4174.04 2033.57 4175 2033.68 4175.67 2033.79V2033.15C4175.67 2031.51 4174.74 2030.74 4172.94 2030.74C4171.77 2030.74 4170.51 2030.93 4169.41 2031.38L4168.74 2028.49C4169.89 2028.01 4171.74 2027.69 4173.37 2027.69C4177.3 2027.69 4179.26 2029.78 4179.26 2033.39V2040.82Z'
              fill='black'
            />
            <path
              d='M4190.19 2041.76C4189.54 2041.92 4188.69 2042 4187.86 2042C4184.68 2042 4183.04 2040.26 4183.04 2036.73V2030.95H4181.23V2028.01H4183.04V2025.04L4186.74 2024.85V2028.01H4189.7V2030.95H4186.74V2036.68C4186.74 2038.23 4187.38 2038.95 4188.58 2038.95C4189.14 2038.95 4189.65 2038.87 4190 2038.79L4190.19 2041.76Z'
              fill='black'
            />
            <path
              d='M4202.87 2038.12L4203.46 2041.09C4202.28 2041.63 4200.55 2042 4198.78 2042C4194.47 2042 4191.53 2039.27 4191.53 2034.83C4191.53 2030.58 4194.23 2027.69 4198.17 2027.69C4201.67 2027.69 4203.97 2030.18 4203.97 2033.76C4203.97 2034.56 4203.92 2035.26 4203.86 2035.79H4195.41C4195.76 2037.93 4197.02 2038.9 4199.16 2038.9C4200.47 2038.9 4201.72 2038.6 4202.87 2038.12ZM4198.17 2030.63C4196.61 2030.63 4195.6 2031.73 4195.36 2033.55H4200.44V2033.23C4200.44 2031.73 4199.64 2030.63 4198.17 2030.63Z'
              fill='black'
            />
            <path
              d='M4206.78 2028.87C4208.22 2028.14 4210.47 2027.69 4212.4 2027.69C4213.36 2027.69 4214.27 2027.8 4214.8 2027.93L4214.27 2030.95C4213.81 2030.79 4213.25 2030.74 4212.69 2030.74C4211.7 2030.74 4211.03 2030.93 4210.47 2031.19V2041.68H4206.78V2028.87Z'
              fill='black'
            />
            <path
              d='M4222.46 2040.9L4223.15 2037.67C4224.41 2038.15 4226.2 2038.68 4228.08 2038.68C4230.14 2038.68 4231.18 2037.93 4231.18 2036.54C4231.18 2034.86 4229.95 2034.38 4227.54 2033.6C4224.49 2032.56 4222.51 2031.14 4222.51 2028.01C4222.51 2024.61 4224.84 2022.63 4228.96 2022.63C4230.96 2022.63 4232.84 2023.09 4233.99 2023.6L4233.24 2026.78C4232.01 2026.3 4230.7 2025.95 4229.2 2025.95C4227.33 2025.95 4226.39 2026.59 4226.39 2027.9C4226.39 2029.35 4227.33 2029.8 4229.41 2030.55C4232.6 2031.65 4235.03 2032.85 4235.03 2036.52C4235.03 2040.1 4232.25 2042 4228.24 2042C4225.94 2042 4223.8 2041.52 4222.46 2040.9Z'
              fill='black'
            />
            <path
              d='M4250.17 2034.83C4250.17 2039.14 4247.66 2042 4243.51 2042C4239.39 2042 4236.83 2039.14 4236.83 2034.83C4236.83 2030.55 4239.39 2027.69 4243.51 2027.69C4247.66 2027.69 4250.17 2030.55 4250.17 2034.83ZM4240.6 2034.83C4240.6 2037.37 4241.64 2038.95 4243.51 2038.95C4245.41 2038.95 4246.4 2037.37 4246.4 2034.83C4246.4 2032.32 4245.41 2030.74 4243.51 2030.74C4241.64 2030.74 4240.6 2032.32 4240.6 2034.83Z'
              fill='black'
            />
            <path
              d='M4256.54 2022.29V2036.73C4256.54 2038.17 4256.92 2038.95 4257.99 2038.95C4258.26 2038.95 4258.52 2038.92 4258.76 2038.87L4259.03 2041.79C4258.52 2041.89 4257.69 2042 4257.16 2042C4254.08 2042 4252.85 2039.99 4252.85 2036.78V2022.5L4256.54 2022.29Z'
              fill='black'
            />
            <path
              d='M4272.99 2040.82C4271.95 2041.25 4269.43 2042 4266.89 2042C4262.37 2042 4260.87 2039.7 4260.87 2036.28V2028.01H4264.54V2036.28C4264.54 2037.96 4265.29 2038.95 4266.97 2038.95C4267.85 2038.95 4268.63 2038.79 4269.3 2038.47V2028.01H4272.99V2040.82Z'
              fill='black'
            />
            <path
              d='M4284.07 2041.76C4283.42 2041.92 4282.57 2042 4281.74 2042C4278.55 2042 4276.92 2040.26 4276.92 2036.73V2030.95H4275.1V2028.01H4276.92V2025.04L4280.61 2024.85V2028.01H4283.58V2030.95H4280.61V2036.68C4280.61 2038.23 4281.26 2038.95 4282.46 2038.95C4283.02 2038.95 4283.53 2038.87 4283.88 2038.79L4284.07 2041.76Z'
              fill='black'
            />
            <path
              d='M4290.03 2028.01V2041.68H4286.34V2028.01H4290.03ZM4288.19 2026.19C4286.83 2026.19 4286.05 2025.36 4286.05 2024.13C4286.05 2022.9 4286.83 2022.07 4288.19 2022.07C4289.53 2022.07 4290.3 2022.9 4290.3 2024.13C4290.3 2025.36 4289.53 2026.19 4288.19 2026.19Z'
              fill='black'
            />
            <path
              d='M4306.2 2034.83C4306.2 2039.14 4303.69 2042 4299.54 2042C4295.42 2042 4292.86 2039.14 4292.86 2034.83C4292.86 2030.55 4295.42 2027.69 4299.54 2027.69C4303.69 2027.69 4306.2 2030.55 4306.2 2034.83ZM4296.63 2034.83C4296.63 2037.37 4297.67 2038.95 4299.54 2038.95C4301.44 2038.95 4302.43 2037.37 4302.43 2034.83C4302.43 2032.32 4301.44 2030.74 4299.54 2030.74C4297.67 2030.74 4296.63 2032.32 4296.63 2034.83Z'
              fill='black'
            />
            <path
              d='M4312.65 2041.68H4308.99V2028.87C4310.68 2028.14 4312.98 2027.69 4315.04 2027.69C4318.94 2027.69 4321.19 2029.62 4321.19 2033.17V2041.68H4317.5V2033.44C4317.5 2031.59 4316.64 2030.74 4315.01 2030.74C4314.15 2030.74 4313.35 2030.9 4312.65 2031.22V2041.68Z'
              fill='black'
            />
            <path
              d='M4333.3 2028.47L4332.9 2031.46C4331.67 2031.09 4330.47 2030.74 4329.19 2030.74C4328.06 2030.74 4327.31 2031.06 4327.31 2031.84C4327.31 2032.64 4327.93 2032.88 4329.53 2033.33C4332.64 2034.19 4334.08 2035.23 4334.08 2037.69C4334.08 2040.58 4331.73 2042 4328.46 2042C4326.75 2042 4324.85 2041.65 4323.62 2041.12L4324.13 2038.09C4325.31 2038.55 4326.81 2038.95 4328.38 2038.95C4329.61 2038.95 4330.47 2038.52 4330.47 2037.77C4330.47 2036.89 4329.8 2036.65 4327.61 2036.03C4325.15 2035.39 4323.68 2034.24 4323.68 2031.92C4323.68 2029.19 4325.63 2027.69 4328.89 2027.69C4330.42 2027.69 4332.15 2028.01 4333.3 2028.47Z'
              fill='black'
            />
          </g>
          <path
            id='DuPont Logo SVG_2'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4259.02 1928.03C4251.93 1927.66 4247.71 1931.03 4247.71 1938.73V1977.02C4247.71 1985.16 4251.53 1988.51 4259.02 1988.16C4266.34 1987.82 4270.17 1984.82 4270.17 1976.17V1939.62C4270.17 1931.37 4266.71 1928.43 4259.02 1928.03V1928.03ZM4231.51 1928.35C4230.18 1928.35 4225.33 1928.53 4220.87 1928.82V1987.35C4222.38 1987.44 4226.36 1987.66 4228.51 1987.72V1967.84L4231.51 1967.84C4239.52 1967.81 4242.85 1963.95 4242.85 1956.51V1939.27C4242.85 1931.99 4239.11 1928.36 4231.51 1928.36V1928.35V1928.35ZM4207.25 1975C4207.25 1977.32 4206.51 1978.78 4203.83 1978.43C4201.19 1978.09 4200.48 1976.89 4200.48 1974.15V1930.66C4198.73 1930.86 4194.83 1931.44 4193.16 1931.7V1975.69C4193.16 1982.71 4196.33 1985.44 4203.83 1986.37C4210.69 1987.22 4214.9 1983.48 4214.9 1975.69V1929.22C4213.46 1929.3 4208.76 1929.73 4207.25 1929.9V1975L4207.25 1975ZM4291.39 1960.63L4282.91 1930.87C4280.6 1930.54 4277.81 1930.21 4275.66 1930V1986.17C4277.17 1986.02 4281.03 1985.55 4283.02 1985.27L4282.41 1952.17L4291.39 1983.98C4293.3 1983.65 4296.09 1983.13 4297.92 1982.75V1933.4C4296.01 1932.99 4292.54 1932.36 4290.86 1932.09L4291.39 1960.63L4291.39 1960.63ZM4178.99 1935.22C4176.56 1935.22 4173.05 1935.99 4166.72 1938.1V1978.06C4172.29 1979.88 4176.56 1980.94 4178.99 1980.94C4184.59 1980.94 4187.74 1977.25 4187.74 1971.35V1944.81C4187.74 1938.91 4184.59 1935.22 4178.99 1935.22ZM4301.7 1942.03C4303.6 1942.4 4305.46 1942.8 4307.28 1943.23V1980.58C4308.95 1980.16 4312.06 1979.29 4314.13 1978.63V1944.99C4316.11 1945.55 4317.99 1946.1 4319.7 1946.63V1939.43C4314.29 1937.4 4308.49 1935.74 4301.7 1934.22V1942.03L4301.7 1942.03ZM4262.44 1976.34C4262.44 1978.65 4261.72 1979.85 4259.02 1979.94C4256.23 1980.02 4255.47 1978.74 4255.47 1976.34V1939.85C4255.47 1937.45 4256.23 1936.12 4259.02 1936.21C4261.72 1936.29 4262.44 1937.53 4262.44 1939.85V1976.34ZM4180.81 1970.32C4180.81 1972.63 4179.52 1973.4 4177.98 1973.4C4176.77 1973.4 4174.92 1972.93 4173.41 1972.49V1943.66C4174.92 1943.23 4176.77 1942.76 4177.98 1942.76C4179.52 1942.76 4180.81 1943.53 4180.81 1945.84V1970.32V1970.32ZM4327.92 1942.97C4336.62 1947.38 4341.61 1952.52 4341.61 1957.99C4341.61 1963.53 4336.62 1968.69 4327.92 1973.14V1942.97ZM4141 1957.99C4141 1963.52 4145.99 1968.69 4154.68 1973.13V1942.98C4145.99 1947.38 4141 1952.52 4141 1957.99ZM4235.12 1955.9C4235.12 1958.42 4234.31 1959.69 4231.2 1959.7L4228.51 1959.71V1936.61C4229.71 1936.54 4230.34 1936.52 4231.06 1936.52C4234.42 1936.52 4235.12 1937.9 4235.12 1940.46V1955.9Z'
            fill='#E4001C'
          />
        </g>
        <g id='Group 1276'>
          <g id='Water Solutions_3'>
            <path
              d='M4523.05 2038.07C4524.12 2034.94 4525.65 2028.6 4526.45 2022.95H4530.35C4529.34 2029.19 4527.57 2036.54 4525.3 2041.68H4521.1C4519.79 2038.34 4518.61 2034.4 4517.62 2030.02C4516.61 2034.4 4515.46 2038.34 4514.12 2041.68H4509.92C4507.78 2036.54 4505.88 2029.19 4504.89 2022.95H4508.77C4509.6 2028.6 4511.1 2034.94 4512.19 2038.07C4513.34 2034.94 4515.14 2028.79 4515.91 2022.95H4519.33C4520.14 2028.79 4521.88 2034.94 4523.05 2038.07Z'
              fill='black'
            />
            <path
              d='M4536.8 2039.35C4537.6 2039.35 4538.27 2039.19 4538.67 2038.98V2036.11C4538.06 2035.98 4537.42 2035.9 4536.77 2035.9C4535.54 2035.9 4534.58 2036.38 4534.58 2037.64C4534.58 2038.76 4535.38 2039.35 4536.8 2039.35ZM4542.26 2040.82C4541.16 2041.38 4539.1 2042 4536.43 2042C4532.76 2042 4530.92 2040.21 4530.92 2037.8C4530.92 2035.15 4533.08 2033.6 4536.29 2033.57C4537.04 2033.57 4538 2033.68 4538.67 2033.79V2033.15C4538.67 2031.51 4537.74 2030.74 4535.94 2030.74C4534.77 2030.74 4533.51 2030.93 4532.41 2031.38L4531.74 2028.49C4532.89 2028.01 4534.74 2027.69 4536.37 2027.69C4540.3 2027.69 4542.26 2029.78 4542.26 2033.39V2040.82Z'
              fill='black'
            />
            <path
              d='M4553.19 2041.76C4552.54 2041.92 4551.69 2042 4550.86 2042C4547.68 2042 4546.04 2040.26 4546.04 2036.73V2030.95H4544.23V2028.01H4546.04V2025.04L4549.74 2024.85V2028.01H4552.7V2030.95H4549.74V2036.68C4549.74 2038.23 4550.38 2038.95 4551.58 2038.95C4552.14 2038.95 4552.65 2038.87 4553 2038.79L4553.19 2041.76Z'
              fill='black'
            />
            <path
              d='M4565.87 2038.12L4566.46 2041.09C4565.28 2041.63 4563.55 2042 4561.78 2042C4557.47 2042 4554.53 2039.27 4554.53 2034.83C4554.53 2030.58 4557.23 2027.69 4561.17 2027.69C4564.67 2027.69 4566.97 2030.18 4566.97 2033.76C4566.97 2034.56 4566.92 2035.26 4566.86 2035.79H4558.41C4558.76 2037.93 4560.02 2038.9 4562.16 2038.9C4563.47 2038.9 4564.72 2038.6 4565.87 2038.12ZM4561.17 2030.63C4559.61 2030.63 4558.6 2031.73 4558.36 2033.55H4563.44V2033.23C4563.44 2031.73 4562.64 2030.63 4561.17 2030.63Z'
              fill='black'
            />
            <path
              d='M4569.78 2028.87C4571.22 2028.14 4573.47 2027.69 4575.4 2027.69C4576.36 2027.69 4577.27 2027.8 4577.8 2027.93L4577.27 2030.95C4576.81 2030.79 4576.25 2030.74 4575.69 2030.74C4574.7 2030.74 4574.03 2030.93 4573.47 2031.19V2041.68H4569.78V2028.87Z'
              fill='black'
            />
            <path
              d='M4585.46 2040.9L4586.15 2037.67C4587.41 2038.15 4589.2 2038.68 4591.08 2038.68C4593.14 2038.68 4594.18 2037.93 4594.18 2036.54C4594.18 2034.86 4592.95 2034.38 4590.54 2033.6C4587.49 2032.56 4585.51 2031.14 4585.51 2028.01C4585.51 2024.61 4587.84 2022.63 4591.96 2022.63C4593.96 2022.63 4595.84 2023.09 4596.99 2023.6L4596.24 2026.78C4595.01 2026.3 4593.7 2025.95 4592.2 2025.95C4590.33 2025.95 4589.39 2026.59 4589.39 2027.9C4589.39 2029.35 4590.33 2029.8 4592.41 2030.55C4595.6 2031.65 4598.03 2032.85 4598.03 2036.52C4598.03 2040.1 4595.25 2042 4591.24 2042C4588.94 2042 4586.8 2041.52 4585.46 2040.9Z'
              fill='black'
            />
            <path
              d='M4613.17 2034.83C4613.17 2039.14 4610.66 2042 4606.51 2042C4602.39 2042 4599.83 2039.14 4599.83 2034.83C4599.83 2030.55 4602.39 2027.69 4606.51 2027.69C4610.66 2027.69 4613.17 2030.55 4613.17 2034.83ZM4603.6 2034.83C4603.6 2037.37 4604.64 2038.95 4606.51 2038.95C4608.41 2038.95 4609.4 2037.37 4609.4 2034.83C4609.4 2032.32 4608.41 2030.74 4606.51 2030.74C4604.64 2030.74 4603.6 2032.32 4603.6 2034.83Z'
              fill='black'
            />
            <path
              d='M4619.54 2022.29V2036.73C4619.54 2038.17 4619.92 2038.95 4620.99 2038.95C4621.26 2038.95 4621.52 2038.92 4621.76 2038.87L4622.03 2041.79C4621.52 2041.89 4620.69 2042 4620.16 2042C4617.08 2042 4615.85 2039.99 4615.85 2036.78V2022.5L4619.54 2022.29Z'
              fill='black'
            />
            <path
              d='M4635.99 2040.82C4634.95 2041.25 4632.43 2042 4629.89 2042C4625.37 2042 4623.87 2039.7 4623.87 2036.28V2028.01H4627.54V2036.28C4627.54 2037.96 4628.29 2038.95 4629.97 2038.95C4630.85 2038.95 4631.63 2038.79 4632.3 2038.47V2028.01H4635.99V2040.82Z'
              fill='black'
            />
            <path
              d='M4647.07 2041.76C4646.42 2041.92 4645.57 2042 4644.74 2042C4641.55 2042 4639.92 2040.26 4639.92 2036.73V2030.95H4638.1V2028.01H4639.92V2025.04L4643.61 2024.85V2028.01H4646.58V2030.95H4643.61V2036.68C4643.61 2038.23 4644.26 2038.95 4645.46 2038.95C4646.02 2038.95 4646.53 2038.87 4646.88 2038.79L4647.07 2041.76Z'
              fill='black'
            />
            <path
              d='M4653.03 2028.01V2041.68H4649.34V2028.01H4653.03ZM4651.19 2026.19C4649.83 2026.19 4649.05 2025.36 4649.05 2024.13C4649.05 2022.9 4649.83 2022.07 4651.19 2022.07C4652.53 2022.07 4653.3 2022.9 4653.3 2024.13C4653.3 2025.36 4652.53 2026.19 4651.19 2026.19Z'
              fill='black'
            />
            <path
              d='M4669.2 2034.83C4669.2 2039.14 4666.69 2042 4662.54 2042C4658.42 2042 4655.86 2039.14 4655.86 2034.83C4655.86 2030.55 4658.42 2027.69 4662.54 2027.69C4666.69 2027.69 4669.2 2030.55 4669.2 2034.83ZM4659.63 2034.83C4659.63 2037.37 4660.67 2038.95 4662.54 2038.95C4664.44 2038.95 4665.43 2037.37 4665.43 2034.83C4665.43 2032.32 4664.44 2030.74 4662.54 2030.74C4660.67 2030.74 4659.63 2032.32 4659.63 2034.83Z'
              fill='black'
            />
            <path
              d='M4675.65 2041.68H4671.99V2028.87C4673.68 2028.14 4675.98 2027.69 4678.04 2027.69C4681.94 2027.69 4684.19 2029.62 4684.19 2033.17V2041.68H4680.5V2033.44C4680.5 2031.59 4679.64 2030.74 4678.01 2030.74C4677.15 2030.74 4676.35 2030.9 4675.65 2031.22V2041.68Z'
              fill='black'
            />
            <path
              d='M4696.3 2028.47L4695.9 2031.46C4694.67 2031.09 4693.47 2030.74 4692.19 2030.74C4691.06 2030.74 4690.31 2031.06 4690.31 2031.84C4690.31 2032.64 4690.93 2032.88 4692.53 2033.33C4695.64 2034.19 4697.08 2035.23 4697.08 2037.69C4697.08 2040.58 4694.73 2042 4691.46 2042C4689.75 2042 4687.85 2041.65 4686.62 2041.12L4687.13 2038.09C4688.31 2038.55 4689.81 2038.95 4691.38 2038.95C4692.61 2038.95 4693.47 2038.52 4693.47 2037.77C4693.47 2036.89 4692.8 2036.65 4690.61 2036.03C4688.15 2035.39 4686.68 2034.24 4686.68 2031.92C4686.68 2029.19 4688.63 2027.69 4691.89 2027.69C4693.42 2027.69 4695.15 2028.01 4696.3 2028.47Z'
              fill='black'
            />
          </g>
          <path
            id='DuPont Logo SVG_3'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4622.02 1928.03C4614.93 1927.66 4610.71 1931.03 4610.71 1938.73V1977.02C4610.71 1985.16 4614.53 1988.51 4622.02 1988.16C4629.34 1987.82 4633.17 1984.82 4633.17 1976.17V1939.62C4633.17 1931.37 4629.71 1928.43 4622.02 1928.03V1928.03ZM4594.51 1928.35C4593.18 1928.35 4588.33 1928.53 4583.87 1928.82V1987.35C4585.38 1987.44 4589.36 1987.66 4591.51 1987.72V1967.84L4594.51 1967.84C4602.52 1967.81 4605.85 1963.95 4605.85 1956.51V1939.27C4605.85 1931.99 4602.11 1928.36 4594.51 1928.36V1928.35V1928.35ZM4570.25 1975C4570.25 1977.32 4569.51 1978.78 4566.83 1978.43C4564.19 1978.09 4563.48 1976.89 4563.48 1974.15V1930.66C4561.73 1930.86 4557.83 1931.44 4556.16 1931.7V1975.69C4556.16 1982.71 4559.33 1985.44 4566.83 1986.37C4573.69 1987.22 4577.9 1983.48 4577.9 1975.69V1929.22C4576.46 1929.3 4571.76 1929.73 4570.25 1929.9V1975L4570.25 1975ZM4654.39 1960.63L4645.91 1930.87C4643.6 1930.54 4640.81 1930.21 4638.66 1930V1986.17C4640.17 1986.02 4644.03 1985.55 4646.02 1985.27L4645.41 1952.17L4654.39 1983.98C4656.3 1983.65 4659.09 1983.13 4660.92 1982.75V1933.4C4659.01 1932.99 4655.54 1932.36 4653.86 1932.09L4654.39 1960.63L4654.39 1960.63ZM4541.99 1935.22C4539.56 1935.22 4536.05 1935.99 4529.72 1938.1V1978.06C4535.29 1979.88 4539.56 1980.94 4541.99 1980.94C4547.59 1980.94 4550.74 1977.25 4550.74 1971.35V1944.81C4550.74 1938.91 4547.59 1935.22 4541.99 1935.22ZM4664.7 1942.03C4666.6 1942.4 4668.46 1942.8 4670.28 1943.23V1980.58C4671.95 1980.16 4675.06 1979.29 4677.13 1978.63V1944.99C4679.11 1945.55 4680.99 1946.1 4682.7 1946.63V1939.43C4677.29 1937.4 4671.49 1935.74 4664.7 1934.22V1942.03L4664.7 1942.03ZM4625.44 1976.34C4625.44 1978.65 4624.72 1979.85 4622.02 1979.94C4619.23 1980.02 4618.47 1978.74 4618.47 1976.34V1939.85C4618.47 1937.45 4619.23 1936.12 4622.02 1936.21C4624.72 1936.29 4625.44 1937.53 4625.44 1939.85V1976.34ZM4543.81 1970.32C4543.81 1972.63 4542.52 1973.4 4540.98 1973.4C4539.77 1973.4 4537.92 1972.93 4536.41 1972.49V1943.66C4537.92 1943.23 4539.77 1942.76 4540.98 1942.76C4542.52 1942.76 4543.81 1943.53 4543.81 1945.84V1970.32V1970.32ZM4690.92 1942.97C4699.62 1947.38 4704.61 1952.52 4704.61 1957.99C4704.61 1963.53 4699.62 1968.69 4690.92 1973.14V1942.97ZM4504 1957.99C4504 1963.52 4508.99 1968.69 4517.68 1973.13V1942.98C4508.99 1947.38 4504 1952.52 4504 1957.99ZM4598.12 1955.9C4598.12 1958.42 4597.31 1959.69 4594.2 1959.7L4591.51 1959.71V1936.61C4592.71 1936.54 4593.34 1936.52 4594.06 1936.52C4597.42 1936.52 4598.12 1937.9 4598.12 1940.46V1955.9Z'
            fill='#E4001C'
          />
        </g>
        <g id='Group 1350'>
          <g id='Subtract_7' filter='url(#filter120_iii_344_5378)'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M9606 3189.91C9625.33 3189.91 9641 3205.58 9641 3224.91L9641 3422.3C9687.87 3436 9722 3478.1 9722 3527.92C9722 3577.74 9687.87 3619.84 9641 3633.54L9641 4013.86C9641 4033.19 9625.33 4048.86 9606 4048.86C9586.67 4048.86 9571 4033.19 9571 4013.86L9571 3632.29L9571 3619.7C9571 3617.58 9572.38 3615.69 9574.37 3614.96C9641.77 3590.41 9650 3561.72 9650 3521.02C9650 3486.84 9609.74 3448.65 9577.08 3449.97C9573.92 3450.1 9571 3447.73 9571 3444.57L9571 3423.55L9571 3422.66V3224.91C9571 3205.58 9586.67 3189.91 9606 3189.91Z'
              fill='#4F6228'
            />
          </g>
        </g>
        <g id='Subtract_8' filter='url(#filter121_iii_344_5378)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3579.29 139.258C3557.2 139.258 3539.29 157.166 3539.29 179.258C3539.29 201.349 3557.2 219.258 3579.29 219.258H9566.88V3447.45C9571.45 3446.5 9576.18 3446 9581 3446C9608.92 3446 9633.38 3462.7 9646.88 3487.69V179.258C9646.88 157.166 9628.97 139.258 9606.88 139.258H3579.29ZM9646.88 3577.31C9633.38 3602.3 9608.92 3619 9581 3619C9576.18 3619 9571.45 3618.5 9566.88 3617.55V4008.74C9566.88 4030.83 9584.78 4048.74 9606.88 4048.74C9628.97 4048.74 9646.88 4030.83 9646.88 4008.74V3577.31Z'
            fill='#4F6228'
          />
        </g>
        <g id='Vector 300' filter='url(#filter122_iii_344_5378)'>
          <path
            d='M3580 175H9607C9607 1443.03 9607 2153.97 9607 3422'
            stroke='white'
            strokeWidth='10'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeDasharray='110 110'
          />
        </g>
        <g id='Vector 301' filter='url(#filter123_i_344_5378)'>
          <path
            d='M9602 3372.9C9602 3375.66 9604.25 3377.89 9607.01 3377.88C9609.77 3377.88 9612 3375.63 9612 3372.87L9602 3372.9ZM9607 3424.1L9602 3424.1L9602 3427.38L9605 3428.68L9607 3424.1ZM9607 3631.85L9604.74 3627.39C9603.06 3628.24 9602 3629.97 9602 3631.85L9607 3631.85ZM9602 3998.63C9602 4001.39 9604.24 4003.63 9607 4003.63C9609.76 4003.63 9612 4001.39 9612 3998.63L9602 3998.63ZM9602 3385.66C9602 3388.42 9604.23 3390.66 9607 3390.66C9609.76 3390.66 9612 3388.42 9612 3385.66L9602 3385.66ZM9612 3411.28C9612 3408.52 9609.76 3406.28 9607 3406.28C9604.24 3406.28 9602 3408.52 9602 3411.28L9612 3411.28ZM9661.85 3465.38C9663.77 3467.36 9666.94 3467.41 9668.92 3465.48C9670.9 3463.56 9670.95 3460.4 9669.03 3458.41L9661.85 3465.38ZM9664.47 3590.85C9666.23 3588.72 9665.93 3585.57 9663.79 3583.81C9661.66 3582.06 9658.51 3582.36 9656.76 3584.5L9664.47 3590.85ZM9602 3677.61C9602 3680.37 9604.24 3682.61 9607 3682.61C9609.76 3682.61 9612 3680.37 9612 3677.61L9602 3677.61ZM9612 3769.37C9612 3766.6 9609.76 3764.37 9607 3764.37C9604.24 3764.37 9602 3766.6 9602 3769.37H9612ZM9602 3861.1C9602 3863.86 9604.24 3866.1 9607 3866.1C9609.76 3866.1 9612 3863.86 9612 3861.1L9602 3861.1ZM9612 3952.92C9612 3950.16 9609.76 3947.92 9607 3947.92C9604.24 3947.92 9602 3950.16 9602 3952.92L9612 3952.92ZM9607 3372.88C9612 3372.87 9612 3372.87 9612 3372.87C9612 3372.87 9612 3372.87 9612 3372.87C9612 3372.87 9612 3372.87 9612 3372.87C9612 3372.87 9612 3372.87 9612 3372.87C9612 3372.87 9612 3372.86 9612 3372.86C9612 3372.86 9612 3372.85 9612 3372.84C9612 3372.84 9612 3372.83 9612 3372.82C9612 3372.82 9612 3372.81 9612 3372.8C9612 3372.79 9612 3372.76 9612 3372.73C9611.99 3372.71 9611.99 3372.67 9611.99 3372.64C9611.99 3372.58 9611.97 3372.38 9611.95 3372.23C9611.63 3370.99 9605.88 3368.01 9602.09 3371.93C9602.05 3372.19 9602.01 3372.53 9602.01 3372.6C9602 3372.64 9602 3372.7 9602 3372.72C9602 3372.73 9602 3372.76 9602 3372.77C9602 3372.79 9602 3372.8 9602 3372.81C9602 3372.83 9602 3372.85 9602 3372.85C9602 3372.86 9602 3372.87 9602 3372.88C9602 3372.89 9602 3372.93 9602 3373.01C9602 3373.18 9602 3373.53 9602 3374.3C9602 3375.84 9602 3379.03 9602 3385.66L9612 3385.66C9612 3379.03 9612 3375.84 9612 3374.3C9612 3373.53 9612 3373.18 9612 3373.02C9612 3372.94 9612 3372.91 9612 3372.9C9612 3372.9 9612 3372.9 9612 3372.91C9612 3372.91 9612 3372.92 9612 3372.92C9612 3372.93 9612 3372.94 9612 3372.95C9612 3372.96 9612 3372.98 9612 3372.99C9612 3373 9612 3373.03 9611.99 3373.04C9611.99 3373.06 9611.99 3373.12 9611.99 3373.16C9611.98 3373.24 9611.95 3373.57 9611.91 3373.83C9608.12 3377.75 9602.37 3374.77 9602.04 3373.53C9602.02 3373.38 9602.01 3373.18 9602 3373.13C9602 3373.1 9602 3373.05 9602 3373.03C9602 3373 9602 3372.97 9602 3372.97C9602 3372.96 9602 3372.95 9602 3372.94C9602 3372.93 9602 3372.92 9602 3372.92C9602 3372.91 9602 3372.91 9602 3372.9C9602 3372.9 9602 3372.9 9602 3372.9C9602 3372.9 9602 3372.9 9602 3372.9C9602 3372.9 9602 3372.9 9602 3372.9C9602 3372.9 9602 3372.9 9602 3372.9C9602 3372.9 9602 3372.9 9607 3372.88ZM9602 3411.28C9602 3415.15 9602 3419.41 9602 3424.1L9612 3424.1C9612 3419.41 9612 3415.15 9612 3411.28L9602 3411.28ZM9605 3428.68C9630.93 3439.98 9649.33 3452.46 9661.85 3465.38L9669.03 3458.41C9655.36 3444.32 9635.76 3431.18 9608.99 3419.52L9605 3428.68ZM9656.76 3584.5C9640.94 3603.69 9621.17 3619.05 9604.74 3627.39L9609.26 3636.31C9627 3627.31 9647.84 3611.05 9664.47 3590.85L9656.76 3584.5ZM9602 3631.85C9602 3638.84 9602 3655.31 9602 3677.61L9612 3677.61C9612 3655.31 9612 3638.84 9612 3631.85L9602 3631.85ZM9602 3769.37C9602 3799.44 9602 3831.16 9602 3861.1L9612 3861.1C9612 3831.16 9612 3799.44 9612 3769.37H9602ZM9602 3952.92C9602 3966.85 9602 3978.28 9602 3986.23C9602 3990.2 9602 3993.3 9602 3995.41C9602 3996.46 9602 3997.27 9602 3997.81C9602 3998.08 9602 3998.29 9602 3998.43C9602 3998.49 9602 3998.55 9602 3998.58C9602 3998.6 9602 3998.61 9602 3998.62C9602 3998.62 9602 3998.63 9602 3998.63C9602 3998.63 9602 3998.63 9602 3998.63C9602 3998.63 9602 3998.63 9602 3998.63C9602 3998.63 9602 3998.63 9607 3998.63C9612 3998.63 9612 3998.63 9612 3998.63C9612 3998.63 9612 3998.63 9612 3998.63C9612 3998.63 9612 3998.63 9612 3998.63C9612 3998.63 9612 3998.62 9612 3998.62C9612 3998.61 9612 3998.6 9612 3998.58C9612 3998.55 9612 3998.49 9612 3998.43C9612 3998.29 9612 3998.08 9612 3997.81C9612 3997.27 9612 3996.46 9612 3995.41C9612 3993.3 9612 3990.2 9612 3986.23C9612 3978.28 9612 3966.85 9612 3952.92L9602 3952.92Z'
            fill='white'
          />
        </g>
        <g id='Group 1244'>
          <rect
            id='Rectangle 1207_12'
            x='9734.5'
            y='1591.5'
            width='172.5'
            height='52.5'
            rx='26.25'
            transform='rotate(90 9734.5 1591.5)'
            fill='url(#paint261_linear_344_5378)'
          />
          <g id='Rectangle 1211_18' filter='url(#filter124_f_344_5378)'>
            <rect x='9727' y='1749' width='15' height='142.5' transform='rotate(-180 9727 1749)' fill='#B29D96' />
          </g>
          <g id='Rectangle 1212_16' filter='url(#filter125_f_344_5378)'>
            <rect x='9697' y='1749' width='7.50001' height='142.5' transform='rotate(-180 9697 1749)' fill='black' />
          </g>
          <rect
            id='Rectangle 1208_12'
            x='9682'
            y='1644'
            width='67.5'
            height='82.5'
            transform='rotate(90 9682 1644)'
            fill='url(#paint262_linear_344_5378)'
          />
          <path
            id='Polygon 30_9'
            d='M9599.5 1674L9670.95 1786.5L9528.05 1786.5L9599.5 1674Z'
            fill='url(#paint263_linear_344_5378)'
          />
          <path
            id='Polygon 31_9'
            d='M9599.5 1674L9670.95 1561.5L9528.05 1561.5L9599.5 1674Z'
            fill='url(#paint264_linear_344_5378)'
          />
          <rect
            id='Rectangle 1239_9'
            x='9664.5'
            y='1744'
            width='130'
            height='140'
            rx='10'
            transform='rotate(-180 9664.5 1744)'
            fill='url(#paint265_linear_344_5378)'
          />
          <rect
            id='Rectangle 1216_9'
            x='9682'
            y='1786.5'
            width='22.5'
            height='165'
            rx='11.25'
            transform='rotate(90 9682 1786.5)'
            fill='url(#paint266_linear_344_5378)'
          />
          <rect
            id='Rectangle 1217_9'
            x='9682'
            y='1539'
            width='22.5'
            height='165'
            rx='11.25'
            transform='rotate(90 9682 1539)'
            fill='url(#paint267_linear_344_5378)'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_iii_344_5378'
          x='9527'
          y='863'
          width='130'
          height='313'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter1_iii_344_5378'
          x='9527'
          y='903'
          width='130'
          height='313'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter2_iii_344_5378'
          x='3498.61'
          y='828.875'
          width='249.395'
          height='701.977'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter3_iii_344_5378'
          x='3800'
          y='3554'
          width='120'
          height='205'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter4_iii_344_5378'
          x='3800'
          y='1074'
          width='120'
          height='205'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter5_iii_344_5378'
          x='4170'
          y='3554'
          width='120'
          height='205'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter6_iii_344_5378'
          x='4170'
          y='1074'
          width='120'
          height='205'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter7_iii_344_5378'
          x='4540'
          y='3554'
          width='120'
          height='205'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter8_iii_344_5378'
          x='4535'
          y='1069'
          width='130'
          height='215'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter9_iii_344_5378'
          x='4110'
          y='3974'
          width='5960'
          height='120'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter10_iii_344_5378'
          x='4145'
          y='4009'
          width='5890'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter11_iii_344_5378'
          x='-30'
          y='2564'
          width='4740'
          height='1530'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter12_iii_344_5378'
          x='5'
          y='2599'
          width='4670'
          height='1460'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter13_iii_344_5378'
          x='1760'
          y='1804'
          width='1030'
          height='2290'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter14_iii_344_5378'
          x='1795'
          y='1839'
          width='960'
          height='2220'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter15_iii_344_5378'
          x='2410'
          y='184'
          width='2235'
          height='515'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter16_iii_344_5378'
          x='4980'
          y='1054'
          width='3790'
          height='2830'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter17_iii_344_5378'
          x='5015'
          y='1074'
          width='3720'
          height='2760'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter18_iii_344_5378'
          x='2375'
          y='139'
          width='1251'
          height='635'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter19_iii_344_5378'
          x='2410'
          y='174'
          width='2235'
          height='515'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter20_iii_344_5378'
          x='2595'
          y='469'
          width='2835'
          height='695'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter21_iii_344_5378'
          x='2630'
          y='504'
          width='2765'
          height='625'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter22_iii_344_5378'
          x='3740'
          y='1049'
          width='4970'
          height='835'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter23_iii_344_5378'
          x='3795'
          y='1084'
          width='4880'
          height='785'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter24_iii_344_5378'
          x='2925'
          y='3239'
          width='830'
          height='295'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter25_iii_344_5378'
          x='2960'
          y='3274'
          width='760'
          height='225'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter26_iii_344_5378'
          x='9250'
          y='3494'
          width='848'
          height='121.623'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter27_iii_344_5378'
          x='9285'
          y='3529'
          width='778'
          height='51.623'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter28_f_344_5378'
          x='8624.49'
          y='1685.64'
          width='397.41'
          height='2030.55'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='60' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter29_f_344_5378'
          x='8408.4'
          y='1666.29'
          width='573.852'
          height='386.926'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='50' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter30_f_344_5378'
          x='8801.9'
          y='1774.51'
          width='593.527'
          height='278.705'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='50' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter31_f_344_5378'
          x='5762.5'
          y='941.5'
          width='182.5'
          height='55'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter32_f_344_5378'
          x='5762.5'
          y='971.5'
          width='182.5'
          height='47.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter33_f_344_5378'
          x='2670'
          y='14'
          width='240'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter34_f_344_5378'
          x='2900'
          y='334'
          width='240'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter35_f_344_5378'
          x='2576.25'
          y='3107.75'
          width='50'
          height='240'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter36_f_344_5378'
          x='5422.5'
          y='3871.5'
          width='182.5'
          height='55'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter37_f_344_5378'
          x='5422.5'
          y='3901.5'
          width='182.5'
          height='47.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter38_f_344_5378'
          x='3192.5'
          y='3301.5'
          width='182.5'
          height='55'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter39_f_344_5378'
          x='3192.5'
          y='3331.5'
          width='182.5'
          height='47.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter40_f_344_5378'
          x='2152.5'
          y='3871.5'
          width='182.5'
          height='55'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter41_f_344_5378'
          x='2152.5'
          y='3901.5'
          width='182.5'
          height='47.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter42_f_344_5378'
          x='5145'
          y='1466.5'
          width='55'
          height='182.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter43_f_344_5378'
          x='5122.5'
          y='1466.5'
          width='47.5'
          height='182.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter44_f_344_5378'
          x='2167.42'
          y='204'
          width='467.895'
          height='1840.7'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='85' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter45_f_344_5378'
          x='2500'
          y='594.01'
          width='630'
          height='1564.07'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='85' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter46_f_344_5378'
          x='2390'
          y='587.516'
          width='400'
          height='1388.75'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='60' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter47_f_344_5378'
          x='2178.4'
          y='607.516'
          width='573.852'
          height='376.008'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='50' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter48_f_344_5378'
          x='2571.91'
          y='709.418'
          width='593.527'
          height='274.109'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='50' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter49_f_344_5378'
          x='3218.67'
          y='559.742'
          width='175.98'
          height='166.031'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='30' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter50_f_344_5378'
          x='3215.72'
          y='620.846'
          width='173.285'
          height='155.232'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='30' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter51_f_344_5378'
          x='4537.7'
          y='1718.78'
          width='195.574'
          height='566.572'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='40' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter52_f_344_5378'
          x='4431'
          y='1215.47'
          width='216.23'
          height='399.189'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter53_f_344_5378'
          x='4512.31'
          y='1235.8'
          width='206.066'
          height='343.285'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter54_f_344_5378'
          x='4587.88'
          y='1275.8'
          width='65.082'
          height='298.861'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter55_f_344_5378'
          x='4420.01'
          y='1534'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter56_f_344_5378'
          x='4420.01'
          y='1584'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter57_f_344_5378'
          x='4490.01'
          y='1534'
          width='90'
          height='110'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter58_f_344_5378'
          x='4500.01'
          y='1554'
          width='190.82'
          height='312.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter59_f_344_5378'
          x='4562.47'
          y='1595.98'
          width='65.082'
          height='232.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter60_f_344_5378'
          x='4547.88'
          y='3253.34'
          width='216.23'
          height='399.189'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter61_f_344_5378'
          x='4476.73'
          y='3288.91'
          width='206.066'
          height='343.285'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter62_f_344_5378'
          x='4542.14'
          y='3293.33'
          width='65.082'
          height='298.861'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter63_f_344_5378'
          x='4420'
          y='3224'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter64_f_344_5378'
          x='4420'
          y='3274'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter65_f_344_5378'
          x='4490'
          y='3224'
          width='90'
          height='110'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter66_f_344_5378'
          x='4504.28'
          y='3001.21'
          width='190.82'
          height='312.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter67_f_344_5378'
          x='4567.55'
          y='3039.22'
          width='65.082'
          height='232.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter68_f_344_5378'
          x='4546.74'
          y='1209.08'
          width='136.562'
          height='50.1641'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter69_f_344_5378'
          x='4546.74'
          y='1229.41'
          width='136.562'
          height='45.082'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter70_f_344_5378'
          x='4177.7'
          y='1718.78'
          width='195.574'
          height='566.572'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='40' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter71_f_344_5378'
          x='4071'
          y='1215.47'
          width='216.23'
          height='399.189'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter72_f_344_5378'
          x='4152.31'
          y='1235.8'
          width='206.066'
          height='343.285'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter73_f_344_5378'
          x='4227.88'
          y='1275.8'
          width='65.082'
          height='298.861'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter74_f_344_5378'
          x='4060.01'
          y='1534'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter75_f_344_5378'
          x='4060.01'
          y='1584'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter76_f_344_5378'
          x='4130.01'
          y='1534'
          width='90'
          height='110'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter77_f_344_5378'
          x='4140.01'
          y='1554'
          width='190.82'
          height='312.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter78_f_344_5378'
          x='4202.47'
          y='1595.98'
          width='65.082'
          height='232.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter79_f_344_5378'
          x='4187.88'
          y='3253.34'
          width='216.23'
          height='399.189'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter80_f_344_5378'
          x='4116.73'
          y='3288.91'
          width='206.066'
          height='343.285'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter81_f_344_5378'
          x='4182.14'
          y='3293.33'
          width='65.082'
          height='298.861'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter82_f_344_5378'
          x='4060'
          y='3224'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter83_f_344_5378'
          x='4060'
          y='3274'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter84_f_344_5378'
          x='4130'
          y='3224'
          width='90'
          height='110'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter85_f_344_5378'
          x='4144.28'
          y='3001.21'
          width='190.82'
          height='312.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter86_f_344_5378'
          x='4207.55'
          y='3039.22'
          width='65.082'
          height='232.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter87_f_344_5378'
          x='4166.74'
          y='1209.08'
          width='136.562'
          height='50.1641'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter88_f_344_5378'
          x='4166.74'
          y='1229.41'
          width='136.562'
          height='45.082'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter89_f_344_5378'
          x='1800'
          y='3844'
          width='220'
          height='510'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='40' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter90_f_344_5378'
          x='1690.98'
          y='3715.47'
          width='216.23'
          height='399.189'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter91_f_344_5378'
          x='1772.3'
          y='3735.8'
          width='206.066'
          height='343.285'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter92_f_344_5378'
          x='1847.88'
          y='3775.8'
          width='65.082'
          height='298.861'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter93_f_344_5378'
          x='1680'
          y='3804'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter94_f_344_5378'
          x='1680'
          y='3854'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter95_f_344_5378'
          x='1750'
          y='3804'
          width='90'
          height='110'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter96_f_344_5378'
          x='1810'
          y='3894'
          width='80'
          height='430'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter97_iii_344_5378'
          x='3501'
          y='139.377'
          width='201'
          height='968.248'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter98_i_344_5378'
          x='3560'
          y='227'
          width='89.5781'
          height='839.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter99_iii_344_5378'
          x='3546.05'
          y='168.965'
          width='6088.96'
          height='3103.25'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter100_i_344_5378'
          x='3556'
          y='1078.81'
          width='199'
          height='403.855'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter101_f_344_5378'
          x='3817.7'
          y='1718.78'
          width='195.574'
          height='566.572'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='40' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter102_f_344_5378'
          x='3796.74'
          y='1209.08'
          width='136.562'
          height='50.1641'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter103_f_344_5378'
          x='3796.74'
          y='1229.41'
          width='136.562'
          height='45.082'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter104_f_344_5378'
          x='3711'
          y='1215.47'
          width='216.23'
          height='399.189'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter105_f_344_5378'
          x='3792.31'
          y='1235.8'
          width='206.066'
          height='343.285'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter106_f_344_5378'
          x='3867.88'
          y='1275.8'
          width='65.082'
          height='298.861'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter107_f_344_5378'
          x='3700.01'
          y='1534'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter108_f_344_5378'
          x='3700.01'
          y='1584'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter109_f_344_5378'
          x='3770.01'
          y='1534'
          width='90'
          height='110'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter110_f_344_5378'
          x='3780.01'
          y='1554'
          width='190.82'
          height='312.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter111_f_344_5378'
          x='3842.47'
          y='1595.98'
          width='65.082'
          height='232.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter112_f_344_5378'
          x='3827.88'
          y='3253.34'
          width='216.23'
          height='399.189'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter113_f_344_5378'
          x='3756.73'
          y='3288.91'
          width='206.066'
          height='343.285'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter114_f_344_5378'
          x='3822.14'
          y='3293.33'
          width='65.082'
          height='298.861'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter115_f_344_5378'
          x='3700'
          y='3224'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter116_f_344_5378'
          x='3700'
          y='3274'
          width='350'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter117_f_344_5378'
          x='3770'
          y='3224'
          width='90'
          height='110'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter118_f_344_5378'
          x='3784.28'
          y='3001.21'
          width='190.82'
          height='312.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='35' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter119_f_344_5378'
          x='3847.55'
          y='3039.22'
          width='65.082'
          height='232.793'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='15' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter120_iii_344_5378'
          x='9541'
          y='3189.91'
          width='201'
          height='898.947'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter121_iii_344_5378'
          x='3509.29'
          y='139.258'
          width='6157.59'
          height='3949.48'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter122_iii_344_5378'
          x='3545'
          y='170'
          width='6087'
          height='3297'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='40' />
          <feGaussianBlur stdDeviation='15' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-30' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='effect1_innerShadow_344_5378' result='effect2_innerShadow_344_5378' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0' />
          <feBlend mode='normal' in2='effect2_innerShadow_344_5378' result='effect3_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter123_i_344_5378'
          x='9602'
          y='3369.97'
          width='88.4414'
          height='673.658'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='20' dy='40' />
          <feGaussianBlur stdDeviation='20' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_344_5378' />
        </filter>
        <filter
          id='filter124_f_344_5378'
          x='9692'
          y='1586.5'
          width='55'
          height='182.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <filter
          id='filter125_f_344_5378'
          x='9669.5'
          y='1586.5'
          width='47.5'
          height='182.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='10' result='effect1_foregroundBlur_344_5378' />
        </filter>
        <linearGradient
          id='paint0_linear_344_5378'
          x1='1830'
          y1='2476.13'
          x2='2881.18'
          y2='2712.8'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#954300' />
          <stop offset='0.625' stopColor='#962D00' />
          <stop offset='1' stopColor='#8E0900' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_344_5378'
          x1='3566'
          y1='329.021'
          x2='2991.91'
          y2='1007.39'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#954300' />
          <stop offset='0.625' stopColor='#962D00' />
          <stop offset='1' stopColor='#8E0900' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_344_5378'
          x1='5370'
          y1='676.5'
          x2='4928.68'
          y2='1803.54'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#954300' />
          <stop offset='0.625' stopColor='#962D00' />
          <stop offset='1' stopColor='#8E0900' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_344_5378'
          x1='908.821'
          y1='3194.58'
          x2='908.821'
          y2='3483.51'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#243536' />
          <stop offset='0.598958' stopColor='#656269' />
          <stop offset='1' stopColor='#373F40' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_344_5378'
          x1='954.059'
          y1='3483.51'
          x2='954.059'
          y2='3184.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_344_5378'
          x1='757.072'
          y1='3218.95'
          x2='757.072'
          y2='3464.22'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.494792' stopColor='#00C7FF' />
          <stop offset='0.786458' stopColor='#0199B9' />
          <stop offset='0.96875' stopColor='#108098' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_344_5378'
          x1='324.626'
          y1='3413.89'
          x2='324.626'
          y2='3251.58'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_344_5378'
          x1='539.812'
          y1='3118.65'
          x2='377.502'
          y2='3118.65'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_344_5378'
          x1='269.708'
          y1='3372.12'
          x2='269.708'
          y2='3292.77'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_344_5378'
          x1='501.517'
          y1='3063.71'
          x2='422.166'
          y2='3063.71'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_344_5378'
          x1='746.942'
          y1='3177.18'
          x2='746.942'
          y2='3218.95'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_344_5378'
          x1='746.942'
          y1='3229.39'
          x2='746.942'
          y2='3267.68'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_344_5378'
          x1='746.942'
          y1='3288.57'
          x2='746.942'
          y2='3319.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_344_5378'
          x1='746.942'
          y1='3382.55'
          x2='746.942'
          y2='3351.23'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_344_5378'
          x1='746.942'
          y1='3438.25'
          x2='746.942'
          y2='3406.92'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_344_5378'
          x1='746.942'
          y1='3486.99'
          x2='746.942'
          y2='3455.66'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_344_5378'
          x1='745.199'
          y1='3187.62'
          x2='745.199'
          y2='3218.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_344_5378'
          x1='745.199'
          y1='3239.84'
          x2='745.199'
          y2='3267.69'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_344_5378'
          x1='745.199'
          y1='3299.01'
          x2='745.199'
          y2='3319.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_344_5378'
          x1='745.199'
          y1='3372.12'
          x2='745.199'
          y2='3351.23'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_344_5378'
          x1='745.199'
          y1='3427.81'
          x2='745.199'
          y2='3406.92'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_344_5378'
          x1='745.199'
          y1='3476.55'
          x2='745.199'
          y2='3455.66'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_344_5378'
          x1='597.256'
          y1='3267.69'
          x2='597.256'
          y2='3406.93'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_344_5378'
          x1='397.094'
          y1='3295.54'
          x2='397.094'
          y2='3372.12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_344_5378'
          x1='357.052'
          y1='3257.24'
          x2='357.052'
          y2='3413.89'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_344_5378'
          x1='555.477'
          y1='3135.41'
          x2='555.477'
          y2='3292.05'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_344_5378'
          x1='691.245'
          y1='3218.94'
          x2='691.245'
          y2='3372.11'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint27_linear_344_5378'
          x1='498.047'
          y1='3257.24'
          x2='421.463'
          y2='3257.24'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.432292' stopColor='#FCFCFC' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint28_linear_344_5378'
          x1='498.045'
          y1='3452.19'
          x2='498.045'
          y2='3330.35'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C3C3C3' stopOpacity='0.85' />
          <stop offset='1' stopColor='#FAFAF9' stopOpacity='0.71' />
        </linearGradient>
        <linearGradient
          id='paint29_linear_344_5378'
          x1='24.3675'
          y1='0'
          x2='24.3675'
          y2='288.929'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#243536' />
          <stop offset='0.598958' stopColor='#656269' />
          <stop offset='1' stopColor='#373F40' />
        </linearGradient>
        <linearGradient
          id='paint30_linear_344_5378'
          x1='7515.74'
          y1='3923.51'
          x2='7515.74'
          y2='3624.13'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint31_linear_344_5378'
          x1='7712.73'
          y1='3658.95'
          x2='7712.73'
          y2='3904.22'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.494792' stopColor='#00C7FF' />
          <stop offset='0.786458' stopColor='#0199B9' />
          <stop offset='0.96875' stopColor='#108098' />
        </linearGradient>
        <linearGradient
          id='paint32_linear_344_5378'
          x1='8145.17'
          y1='3853.89'
          x2='8145.17'
          y2='3691.58'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint33_linear_344_5378'
          x1='7929.98'
          y1='3558.64'
          x2='8092.29'
          y2='3558.64'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint34_linear_344_5378'
          x1='8200.09'
          y1='3812.12'
          x2='8200.09'
          y2='3732.77'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint35_linear_344_5378'
          x1='7968.28'
          y1='3503.71'
          x2='8047.63'
          y2='3503.71'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint36_linear_344_5378'
          x1='7722.86'
          y1='3617.17'
          x2='7722.86'
          y2='3658.95'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint37_linear_344_5378'
          x1='7722.86'
          y1='3669.39'
          x2='7722.86'
          y2='3707.68'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint38_linear_344_5378'
          x1='7722.86'
          y1='3728.57'
          x2='7722.86'
          y2='3759.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint39_linear_344_5378'
          x1='7722.86'
          y1='3822.55'
          x2='7722.86'
          y2='3791.22'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint40_linear_344_5378'
          x1='7722.86'
          y1='3878.25'
          x2='7722.86'
          y2='3846.92'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint41_linear_344_5378'
          x1='7722.86'
          y1='3926.99'
          x2='7722.86'
          y2='3895.66'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint42_linear_344_5378'
          x1='7724.6'
          y1='3627.61'
          x2='7724.6'
          y2='3658.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint43_linear_344_5378'
          x1='7724.6'
          y1='3679.84'
          x2='7724.6'
          y2='3707.69'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint44_linear_344_5378'
          x1='7724.6'
          y1='3739.01'
          x2='7724.6'
          y2='3759.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint45_linear_344_5378'
          x1='7724.6'
          y1='3812.12'
          x2='7724.6'
          y2='3791.23'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint46_linear_344_5378'
          x1='7724.6'
          y1='3867.81'
          x2='7724.6'
          y2='3846.92'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint47_linear_344_5378'
          x1='7724.6'
          y1='3916.55'
          x2='7724.6'
          y2='3895.66'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint48_linear_344_5378'
          x1='22.6269'
          y1='0'
          x2='22.6269'
          y2='139.243'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint49_linear_344_5378'
          x1='24.3675'
          y1='0'
          x2='24.3675'
          y2='76.5835'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint50_linear_344_5378'
          x1='15.6648'
          y1='0'
          x2='15.6648'
          y2='156.648'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint51_linear_344_5378'
          x1='15.6648'
          y1='0'
          x2='15.6648'
          y2='156.648'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint52_linear_344_5378'
          x1='116.616'
          y1='0'
          x2='116.616'
          y2='153.167'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint53_linear_344_5378'
          x1='7971.75'
          y1='3697.24'
          x2='8048.33'
          y2='3697.24'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.432292' stopColor='#FCFCFC' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint54_linear_344_5378'
          x1='7971.75'
          y1='3892.19'
          x2='7971.75'
          y2='3770.35'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C3C3C3' stopOpacity='0.85' />
          <stop offset='1' stopColor='#FAFAF9' stopOpacity='0.71' />
        </linearGradient>
        <linearGradient
          id='paint55_linear_344_5378'
          x1='2578.82'
          y1='2384.58'
          x2='2578.82'
          y2='2673.51'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#243536' />
          <stop offset='0.598958' stopColor='#656269' />
          <stop offset='1' stopColor='#373F40' />
        </linearGradient>
        <linearGradient
          id='paint56_linear_344_5378'
          x1='2624.06'
          y1='2673.51'
          x2='2624.06'
          y2='2374.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint57_linear_344_5378'
          x1='2427.07'
          y1='2408.95'
          x2='2427.07'
          y2='2654.22'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.494792' stopColor='#00C7FF' />
          <stop offset='0.786458' stopColor='#0199B9' />
          <stop offset='0.96875' stopColor='#108098' />
        </linearGradient>
        <linearGradient
          id='paint58_linear_344_5378'
          x1='1994.63'
          y1='2603.89'
          x2='1994.63'
          y2='2441.58'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint59_linear_344_5378'
          x1='2209.81'
          y1='2308.65'
          x2='2047.5'
          y2='2308.65'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint60_linear_344_5378'
          x1='1939.71'
          y1='2562.12'
          x2='1939.71'
          y2='2482.77'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint61_linear_344_5378'
          x1='2171.52'
          y1='2253.71'
          x2='2092.17'
          y2='2253.71'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00516D' />
          <stop offset='0.34375' stopColor='#11ABD9' />
          <stop offset='0.692708' stopColor='#00C7FF' />
          <stop offset='1' stopColor='#0199B9' />
        </linearGradient>
        <linearGradient
          id='paint62_linear_344_5378'
          x1='2416.94'
          y1='2367.18'
          x2='2416.94'
          y2='2408.95'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint63_linear_344_5378'
          x1='2416.94'
          y1='2419.39'
          x2='2416.94'
          y2='2457.68'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint64_linear_344_5378'
          x1='2416.94'
          y1='2478.57'
          x2='2416.94'
          y2='2509.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint65_linear_344_5378'
          x1='2416.94'
          y1='2572.55'
          x2='2416.94'
          y2='2541.23'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint66_linear_344_5378'
          x1='2416.94'
          y1='2628.25'
          x2='2416.94'
          y2='2596.92'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint67_linear_344_5378'
          x1='2416.94'
          y1='2676.99'
          x2='2416.94'
          y2='2645.66'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1BD1FF' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint68_linear_344_5378'
          x1='2415.2'
          y1='2377.62'
          x2='2415.2'
          y2='2408.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint69_linear_344_5378'
          x1='2415.2'
          y1='2429.84'
          x2='2415.2'
          y2='2457.69'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint70_linear_344_5378'
          x1='2415.2'
          y1='2489.01'
          x2='2415.2'
          y2='2509.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint71_linear_344_5378'
          x1='2415.2'
          y1='2562.12'
          x2='2415.2'
          y2='2541.23'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint72_linear_344_5378'
          x1='2415.2'
          y1='2617.81'
          x2='2415.2'
          y2='2596.92'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint73_linear_344_5378'
          x1='2415.2'
          y1='2666.55'
          x2='2415.2'
          y2='2645.66'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#02A9DC' />
          <stop offset='1' stopColor='#0089B5' />
        </linearGradient>
        <linearGradient
          id='paint74_linear_344_5378'
          x1='2267.26'
          y1='2457.69'
          x2='2267.26'
          y2='2596.93'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint75_linear_344_5378'
          x1='2067.09'
          y1='2485.54'
          x2='2067.09'
          y2='2562.12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint76_linear_344_5378'
          x1='2027.05'
          y1='2447.24'
          x2='2027.05'
          y2='2603.89'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint77_linear_344_5378'
          x1='2225.48'
          y1='2325.41'
          x2='2225.48'
          y2='2482.05'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint78_linear_344_5378'
          x1='2361.24'
          y1='2408.94'
          x2='2361.24'
          y2='2562.11'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.265625' stopColor='#FCFCFC' />
          <stop offset='0.484375' stopColor='#E2E1D8' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint79_linear_344_5378'
          x1='2168.05'
          y1='2447.24'
          x2='2091.46'
          y2='2447.24'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E4E2DB' />
          <stop offset='0.432292' stopColor='#FCFCFC' />
          <stop offset='0.75' stopColor='#C4C4C4' />
          <stop offset='1' stopColor='#A9A9A9' />
        </linearGradient>
        <linearGradient
          id='paint80_linear_344_5378'
          x1='2168.05'
          y1='2642.19'
          x2='2168.05'
          y2='2520.35'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C3C3C3' stopOpacity='0.85' />
          <stop offset='1' stopColor='#FAFAF9' stopOpacity='0.71' />
        </linearGradient>
        <linearGradient
          id='paint81_linear_344_5378'
          x1='9334.8'
          y1='2494.31'
          x2='8429.69'
          y2='2494.31'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#105392' />
          <stop offset='0.223958' stopColor='#0CA3C5' />
          <stop offset='0.416667' stopColor='#2078CA' />
          <stop offset='0.697917' stopColor='#0A63B5' />
          <stop offset='0.838542' stopColor='#0A849F' />
          <stop offset='1' stopColor='#0A4B87' />
        </linearGradient>
        <linearGradient
          id='paint82_linear_344_5378'
          x1='9334.79'
          y1='2764.77'
          x2='8429.69'
          y2='2759.17'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E2E2E2' />
          <stop offset='0.0729167' stopColor='white' />
          <stop offset='0.214403' stopColor='#EAEAEA' />
          <stop offset='0.406184' stopColor='#F9F9F9' />
          <stop offset='0.5' stopColor='white' />
          <stop offset='0.593139' stopColor='#F9F9F9' />
          <stop offset='0.777999' stopColor='#F7F1F1' />
          <stop offset='0.915606' stopColor='white' stopOpacity='0.75625' />
          <stop offset='1' stopColor='#E7E7E7' />
        </linearGradient>
        <linearGradient
          id='paint83_linear_344_5378'
          x1='9334.79'
          y1='2287.7'
          x2='8429.68'
          y2='2287.7'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint84_linear_344_5378'
          x1='9334.79'
          y1='2287.71'
          x2='8429.68'
          y2='2287.71'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint85_linear_344_5378'
          x1='9334.79'
          y1='2582.86'
          x2='8429.68'
          y2='2582.86'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint86_linear_344_5378'
          x1='9334.79'
          y1='2582.86'
          x2='8429.68'
          y2='2582.86'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint87_linear_344_5378'
          x1='9334.79'
          y1='2877.99'
          x2='8429.68'
          y2='2877.99'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint88_linear_344_5378'
          x1='9334.79'
          y1='2877.99'
          x2='8429.68'
          y2='2877.99'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint89_linear_344_5378'
          x1='9334.79'
          y1='3173.14'
          x2='8429.68'
          y2='3173.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint90_linear_344_5378'
          x1='9334.79'
          y1='3173.15'
          x2='8429.68'
          y2='3173.15'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint91_linear_344_5378'
          x1='9334.79'
          y1='3468.29'
          x2='8429.68'
          y2='3468.29'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint92_linear_344_5378'
          x1='9334.79'
          y1='3468.28'
          x2='8429.68'
          y2='3468.28'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint93_linear_344_5378'
          x1='8823.2'
          y1='1805.64'
          x2='8823.2'
          y2='3596.19'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint94_linear_344_5378'
          x1='5940'
          y1='977.905'
          x2='5767.76'
          y2='971.204'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint95_linear_344_5378'
          x1='5887.5'
          y1='1044.07'
          x2='5820'
          y2='1043.41'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint96_linear_344_5378'
          x1='5918.3'
          y1='1006.5'
          x2='5916.15'
          y2='1171.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint97_linear_344_5378'
          x1='5781.7'
          y1='1006.5'
          x2='5783.85'
          y2='1171.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint98_linear_344_5378'
          x1='6050'
          y1='1087.75'
          x2='5920.01'
          y2='1086.32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint99_linear_344_5378'
          x1='5985'
          y1='1081.63'
          x2='5962.5'
          y2='1081.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint100_linear_344_5378'
          x1='5737.5'
          y1='1081.63'
          x2='5715'
          y2='1081.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint101_linear_344_5378'
          x1='2910'
          y1='46.7668'
          x2='2670.77'
          y2='33.1698'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint102_linear_344_5378'
          x1='2770'
          y1='114.98'
          x2='2700'
          y2='114.336'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint103_linear_344_5378'
          x1='2798.3'
          y1='96.5'
          x2='2796.15'
          y2='261.476'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint104_linear_344_5378'
          x1='2661.7'
          y1='96.5'
          x2='2663.85'
          y2='261.476'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint105_linear_344_5378'
          x1='2930'
          y1='177.747'
          x2='2800.01'
          y2='176.318'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint106_linear_344_5378'
          x1='2865'
          y1='171.63'
          x2='2842.5'
          y2='171.594'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint107_linear_344_5378'
          x1='2617.5'
          y1='171.63'
          x2='2595'
          y2='171.594'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint108_linear_344_5378'
          x1='3140'
          y1='366.767'
          x2='2900.77'
          y2='353.17'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint109_linear_344_5378'
          x1='3000'
          y1='434.98'
          x2='2930'
          y2='434.336'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint110_linear_344_5378'
          x1='3028.3'
          y1='416.5'
          x2='3026.15'
          y2='581.476'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint111_linear_344_5378'
          x1='2891.7'
          y1='416.5'
          x2='2893.85'
          y2='581.476'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint112_linear_344_5378'
          x1='3160'
          y1='497.747'
          x2='3030.01'
          y2='496.318'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint113_linear_344_5378'
          x1='3095'
          y1='491.63'
          x2='3072.5'
          y2='491.594'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint114_linear_344_5378'
          x1='2847.5'
          y1='491.63'
          x2='2825'
          y2='491.594'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint115_linear_344_5378'
          x1='2826.25'
          y1='3370.52'
          x2='2587.02'
          y2='3356.92'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint116_linear_344_5378'
          x1='2706.25'
          y1='3358.73'
          x2='2636.25'
          y2='3358.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint117_linear_344_5378'
          x1='2658.75'
          y1='3219.45'
          x2='2823.73'
          y2='3221.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint118_linear_344_5378'
          x1='2658.75'
          y1='3356.05'
          x2='2823.73'
          y2='3353.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint119_linear_344_5378'
          x1='2806.25'
          y1='3281.5'
          x2='2676.26'
          y2='3280.07'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint120_linear_344_5378'
          x1='2681.25'
          y1='3250.38'
          x2='2658.75'
          y2='3250.34'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint121_linear_344_5378'
          x1='2681.25'
          y1='3497.88'
          x2='2658.75'
          y2='3497.84'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint122_linear_344_5378'
          x1='5600'
          y1='3907.91'
          x2='5427.76'
          y2='3901.2'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint123_linear_344_5378'
          x1='5547.5'
          y1='3974.07'
          x2='5480'
          y2='3973.41'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint124_linear_344_5378'
          x1='5578.3'
          y1='3936.5'
          x2='5576.15'
          y2='4101.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint125_linear_344_5378'
          x1='5441.7'
          y1='3936.5'
          x2='5443.85'
          y2='4101.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint126_linear_344_5378'
          x1='5710'
          y1='4017.75'
          x2='5580.01'
          y2='4016.32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint127_linear_344_5378'
          x1='5645'
          y1='4011.63'
          x2='5622.5'
          y2='4011.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint128_linear_344_5378'
          x1='5397.5'
          y1='4011.63'
          x2='5375'
          y2='4011.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint129_linear_344_5378'
          x1='3370'
          y1='3337.91'
          x2='3197.76'
          y2='3331.2'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint130_linear_344_5378'
          x1='3317.5'
          y1='3404.07'
          x2='3250'
          y2='3403.41'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint131_linear_344_5378'
          x1='3348.3'
          y1='3366.5'
          x2='3346.15'
          y2='3531.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint132_linear_344_5378'
          x1='3211.7'
          y1='3366.5'
          x2='3213.85'
          y2='3531.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint133_linear_344_5378'
          x1='3480'
          y1='3447.75'
          x2='3350.01'
          y2='3446.32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint134_linear_344_5378'
          x1='3415'
          y1='3441.63'
          x2='3392.5'
          y2='3441.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint135_linear_344_5378'
          x1='3167.5'
          y1='3441.63'
          x2='3145'
          y2='3441.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint136_linear_344_5378'
          x1='2330'
          y1='3907.91'
          x2='2157.76'
          y2='3901.2'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint137_linear_344_5378'
          x1='2277.5'
          y1='3974.07'
          x2='2210'
          y2='3973.41'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint138_linear_344_5378'
          x1='2308.3'
          y1='3936.5'
          x2='2306.15'
          y2='4101.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint139_linear_344_5378'
          x1='2171.7'
          y1='3936.5'
          x2='2173.85'
          y2='4101.48'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint140_linear_344_5378'
          x1='2440'
          y1='4017.75'
          x2='2310.01'
          y2='4016.32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint141_linear_344_5378'
          x1='2375'
          y1='4011.63'
          x2='2352.5'
          y2='4011.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint142_linear_344_5378'
          x1='2127.5'
          y1='4011.63'
          x2='2105'
          y2='4011.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint143_linear_344_5378'
          x1='5360'
          y1='1495.41'
          x2='5187.76'
          y2='1488.7'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint144_linear_344_5378'
          x1='5202.5'
          y1='1561.57'
          x2='5135'
          y2='1560.91'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint145_linear_344_5378'
          x1='5135'
          y1='1622.3'
          x2='4970.02'
          y2='1620.15'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint146_linear_344_5378'
          x1='5135'
          y1='1485.7'
          x2='4970.02'
          y2='1487.85'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint147_linear_344_5378'
          x1='5247.5'
          y1='1687.75'
          x2='5117.51'
          y2='1686.32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint148_linear_344_5378'
          x1='5157.5'
          y1='1741.63'
          x2='5135'
          y2='1741.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint149_linear_344_5378'
          x1='5157.5'
          y1='1494.13'
          x2='5135'
          y2='1494.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint150_linear_344_5378'
          x1='3100'
          y1='1180.72'
          x2='2200'
          y2='1180.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#105392' />
          <stop offset='0.223958' stopColor='#0CA3C5' />
          <stop offset='0.416667' stopColor='#2078CA' />
          <stop offset='0.697917' stopColor='#0A63B5' />
          <stop offset='0.838542' stopColor='#0A849F' />
          <stop offset='1' stopColor='#0A4B87' />
        </linearGradient>
        <linearGradient
          id='paint151_linear_344_5378'
          x1='3100'
          y1='1441.9'
          x2='2200.08'
          y2='1432.36'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E2E2E2' />
          <stop offset='0.0729167' stopColor='white' />
          <stop offset='0.214403' stopColor='#EAEAEA' />
          <stop offset='0.406184' stopColor='#F9F9F9' />
          <stop offset='0.5' stopColor='white' />
          <stop offset='0.593139' stopColor='#F9F9F9' />
          <stop offset='0.777999' stopColor='#F7F1F1' />
          <stop offset='0.915606' stopColor='white' stopOpacity='0.75625' />
          <stop offset='1' stopColor='#E7E7E7' />
        </linearGradient>
        <linearGradient
          id='paint152_linear_344_5378'
          x1='3104.79'
          y1='1179.93'
          x2='2199.68'
          y2='1179.93'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint153_linear_344_5378'
          x1='3104.79'
          y1='1179.93'
          x2='2199.68'
          y2='1179.93'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint154_linear_344_5378'
          x1='3104.79'
          y1='1457.84'
          x2='2199.68'
          y2='1457.84'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint155_linear_344_5378'
          x1='3104.79'
          y1='1457.85'
          x2='2199.68'
          y2='1457.85'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint156_linear_344_5378'
          x1='3104.79'
          y1='1735.75'
          x2='2199.68'
          y2='1735.75'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#2D82CF' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#126EC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint157_linear_344_5378'
          x1='3104.79'
          y1='1735.75'
          x2='2199.68'
          y2='1735.75'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#124C81' />
          <stop offset='0.203125' stopColor='#499BE6' />
          <stop offset='0.484375' stopColor='#2374BD' />
          <stop offset='0.765625' stopColor='#12ACC1' />
          <stop offset='1' stopColor='#124C81' />
        </linearGradient>
        <linearGradient
          id='paint158_linear_344_5378'
          x1='2590'
          y1='707.516'
          x2='2590'
          y2='1856.26'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint159_linear_344_5378'
          x1='4730.01'
          y1='2113.48'
          x2='4460'
          y2='2112.78'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C4C4C4' />
          <stop offset='0.25' stopColor='#CCCDCA' />
          <stop offset='0.5' stopColor='#E2DED4' />
          <stop offset='0.75' stopColor='#D1D1D1' />
          <stop offset='1' stopColor='#9F9F9F' />
        </linearGradient>
        <linearGradient
          id='paint160_linear_344_5378'
          x1='4740.01'
          y1='1411.49'
          x2='4450.05'
          y2='1407.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A7A59B' />
          <stop offset='0.197917' stopColor='#D3D2D3' />
          <stop offset='0.515625' stopColor='#E9E5EA' />
          <stop offset='0.859375' stopColor='#B0ADA8' />
          <stop offset='1' stopColor='#9C9C92' />
        </linearGradient>
        <linearGradient
          id='paint161_linear_344_5378'
          x1='4720.01'
          y1='1402.72'
          x2='4690.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint162_linear_344_5378'
          x1='4670.01'
          y1='1402.72'
          x2='4640.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint163_linear_344_5378'
          x1='4610.01'
          y1='1402.72'
          x2='4580.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint164_linear_344_5378'
          x1='4550.01'
          y1='1402.72'
          x2='4520.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint165_linear_344_5378'
          x1='4490.01'
          y1='1402.72'
          x2='4460.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint166_linear_344_5378'
          x1='4740.01'
          y1='1705.07'
          x2='4450.09'
          y2='1700.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#121212' />
          <stop offset='0.25' stopColor='#555555' />
          <stop offset='0.53125' stopColor='#464646' />
          <stop offset='0.765625' stopColor='#3A3A3A' />
          <stop offset='1' stopColor='#0B0B0B' />
        </linearGradient>
        <linearGradient
          id='paint167_linear_344_5378'
          x1='4755.1'
          y1='1581.69'
          x2='4440.67'
          y2='1567.26'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A706B' />
          <stop offset='0.25' stopColor='#E2E2E2' />
          <stop offset='0.53125' stopColor='#CBC9C8' />
          <stop offset='0.765625' stopColor='#959387' />
          <stop offset='1' stopColor='#5B5750' />
        </linearGradient>
        <linearGradient
          id='paint168_linear_344_5378'
          x1='4520.01'
          y1='1583.11'
          x2='4460.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint169_linear_344_5378'
          x1='4610.01'
          y1='1583.11'
          x2='4550.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint170_linear_344_5378'
          x1='4720.01'
          y1='1583.11'
          x2='4660.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint171_linear_344_5378'
          x1='4720.01'
          y1='1705.79'
          x2='4690.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint172_linear_344_5378'
          x1='4640.01'
          y1='1705.79'
          x2='4610.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint173_linear_344_5378'
          x1='4570.01'
          y1='1705.79'
          x2='4540.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint174_linear_344_5378'
          x1='4510.01'
          y1='1705.79'
          x2='4480.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint175_linear_344_5378'
          x1='5035.1'
          y1='3711.49'
          x2='4745.13'
          y2='3707.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A7A59B' />
          <stop offset='0.197917' stopColor='#D3D2D3' />
          <stop offset='0.515625' stopColor='#E9E5EA' />
          <stop offset='0.859375' stopColor='#B0ADA8' />
          <stop offset='1' stopColor='#9C9C92' />
        </linearGradient>
        <linearGradient
          id='paint176_linear_344_5378'
          x1='4535.1'
          y1='3662.72'
          x2='4505.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint177_linear_344_5378'
          x1='4585.1'
          y1='3662.72'
          x2='4555.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint178_linear_344_5378'
          x1='4645.1'
          y1='3662.72'
          x2='4615.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint179_linear_344_5378'
          x1='4705.1'
          y1='3662.72'
          x2='4675.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint180_linear_344_5378'
          x1='4765.1'
          y1='3662.72'
          x2='4735.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint181_linear_344_5378'
          x1='5035.1'
          y1='3345.07'
          x2='4745.18'
          y2='3340.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#121212' />
          <stop offset='0.25' stopColor='#555555' />
          <stop offset='0.53125' stopColor='#464646' />
          <stop offset='0.765625' stopColor='#3A3A3A' />
          <stop offset='1' stopColor='#0B0B0B' />
        </linearGradient>
        <linearGradient
          id='paint182_linear_344_5378'
          x1='5070.19'
          y1='3360.36'
          x2='4755.75'
          y2='3345.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A706B' />
          <stop offset='0.25' stopColor='#E2E2E2' />
          <stop offset='0.53125' stopColor='#CBC9C8' />
          <stop offset='0.765625' stopColor='#959387' />
          <stop offset='1' stopColor='#5B5750' />
        </linearGradient>
        <linearGradient
          id='paint183_linear_344_5378'
          x1='4520'
          y1='3273.11'
          x2='4460.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint184_linear_344_5378'
          x1='4610'
          y1='3273.11'
          x2='4550.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint185_linear_344_5378'
          x1='4720'
          y1='3273.11'
          x2='4660.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint186_linear_344_5378'
          x1='4535.1'
          y1='3305.79'
          x2='4505.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint187_linear_344_5378'
          x1='4615.1'
          y1='3305.79'
          x2='4585.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint188_linear_344_5378'
          x1='4685.1'
          y1='3305.79'
          x2='4655.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint189_linear_344_5378'
          x1='4745.1'
          y1='3305.79'
          x2='4715.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint190_linear_344_5378'
          x1='4650.01'
          y1='1245.87'
          x2='4570.02'
          y2='1244.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#090909' />
          <stop offset='0.25' stopColor='#292929' />
          <stop offset='0.53125' stopColor='#676767' />
          <stop offset='0.765625' stopColor='#515151' />
          <stop offset='1' stopColor='#141414' />
        </linearGradient>
        <linearGradient
          id='paint191_linear_344_5378'
          x1='4690.01'
          y1='1242.21'
          x2='4530.37'
          y2='1234.65'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#303030' />
          <stop offset='0.25' stopColor='#505050' />
          <stop offset='0.53125' stopColor='#585858' />
          <stop offset='0.765625' stopColor='#555555' />
          <stop offset='1' stopColor='#262626' />
        </linearGradient>
        <linearGradient
          id='paint192_linear_344_5378'
          x1='4370.01'
          y1='2113.48'
          x2='4100'
          y2='2112.78'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C4C4C4' />
          <stop offset='0.25' stopColor='#CCCDCA' />
          <stop offset='0.5' stopColor='#E2DED4' />
          <stop offset='0.75' stopColor='#D1D1D1' />
          <stop offset='1' stopColor='#9F9F9F' />
        </linearGradient>
        <linearGradient
          id='paint193_linear_344_5378'
          x1='4380.01'
          y1='1411.49'
          x2='4090.05'
          y2='1407.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A7A59B' />
          <stop offset='0.197917' stopColor='#D3D2D3' />
          <stop offset='0.515625' stopColor='#E9E5EA' />
          <stop offset='0.859375' stopColor='#B0ADA8' />
          <stop offset='1' stopColor='#9C9C92' />
        </linearGradient>
        <linearGradient
          id='paint194_linear_344_5378'
          x1='4360.01'
          y1='1402.72'
          x2='4330.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint195_linear_344_5378'
          x1='4310.01'
          y1='1402.72'
          x2='4280.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint196_linear_344_5378'
          x1='4250.01'
          y1='1402.72'
          x2='4220.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint197_linear_344_5378'
          x1='4190.01'
          y1='1402.72'
          x2='4160.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint198_linear_344_5378'
          x1='4130.01'
          y1='1402.72'
          x2='4100.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint199_linear_344_5378'
          x1='4380.01'
          y1='1705.07'
          x2='4090.09'
          y2='1700.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#121212' />
          <stop offset='0.25' stopColor='#555555' />
          <stop offset='0.53125' stopColor='#464646' />
          <stop offset='0.765625' stopColor='#3A3A3A' />
          <stop offset='1' stopColor='#0B0B0B' />
        </linearGradient>
        <linearGradient
          id='paint200_linear_344_5378'
          x1='4395.1'
          y1='1581.69'
          x2='4080.67'
          y2='1567.26'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A706B' />
          <stop offset='0.25' stopColor='#E2E2E2' />
          <stop offset='0.53125' stopColor='#CBC9C8' />
          <stop offset='0.765625' stopColor='#959387' />
          <stop offset='1' stopColor='#5B5750' />
        </linearGradient>
        <linearGradient
          id='paint201_linear_344_5378'
          x1='4160.01'
          y1='1583.11'
          x2='4100.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint202_linear_344_5378'
          x1='4250.01'
          y1='1583.11'
          x2='4190.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint203_linear_344_5378'
          x1='4360.01'
          y1='1583.11'
          x2='4300.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint204_linear_344_5378'
          x1='4360.01'
          y1='1705.79'
          x2='4330.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint205_linear_344_5378'
          x1='4280.01'
          y1='1705.79'
          x2='4250.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint206_linear_344_5378'
          x1='4210.01'
          y1='1705.79'
          x2='4180.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint207_linear_344_5378'
          x1='4150.01'
          y1='1705.79'
          x2='4120.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint208_linear_344_5378'
          x1='4675.1'
          y1='3711.49'
          x2='4385.13'
          y2='3707.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A7A59B' />
          <stop offset='0.197917' stopColor='#D3D2D3' />
          <stop offset='0.515625' stopColor='#E9E5EA' />
          <stop offset='0.859375' stopColor='#B0ADA8' />
          <stop offset='1' stopColor='#9C9C92' />
        </linearGradient>
        <linearGradient
          id='paint209_linear_344_5378'
          x1='4175.1'
          y1='3662.72'
          x2='4145.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint210_linear_344_5378'
          x1='4225.1'
          y1='3662.72'
          x2='4195.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint211_linear_344_5378'
          x1='4285.1'
          y1='3662.72'
          x2='4255.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint212_linear_344_5378'
          x1='4345.1'
          y1='3662.72'
          x2='4315.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint213_linear_344_5378'
          x1='4405.1'
          y1='3662.72'
          x2='4375.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint214_linear_344_5378'
          x1='4675.1'
          y1='3345.07'
          x2='4385.18'
          y2='3340.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#121212' />
          <stop offset='0.25' stopColor='#555555' />
          <stop offset='0.53125' stopColor='#464646' />
          <stop offset='0.765625' stopColor='#3A3A3A' />
          <stop offset='1' stopColor='#0B0B0B' />
        </linearGradient>
        <linearGradient
          id='paint215_linear_344_5378'
          x1='4710.19'
          y1='3360.36'
          x2='4395.75'
          y2='3345.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A706B' />
          <stop offset='0.25' stopColor='#E2E2E2' />
          <stop offset='0.53125' stopColor='#CBC9C8' />
          <stop offset='0.765625' stopColor='#959387' />
          <stop offset='1' stopColor='#5B5750' />
        </linearGradient>
        <linearGradient
          id='paint216_linear_344_5378'
          x1='4160'
          y1='3273.11'
          x2='4100.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint217_linear_344_5378'
          x1='4250'
          y1='3273.11'
          x2='4190.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint218_linear_344_5378'
          x1='4360'
          y1='3273.11'
          x2='4300.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint219_linear_344_5378'
          x1='4175.1'
          y1='3305.79'
          x2='4145.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint220_linear_344_5378'
          x1='4255.1'
          y1='3305.79'
          x2='4225.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint221_linear_344_5378'
          x1='4325.1'
          y1='3305.79'
          x2='4295.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint222_linear_344_5378'
          x1='4385.1'
          y1='3305.79'
          x2='4355.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint223_linear_344_5378'
          x1='4270.01'
          y1='1245.87'
          x2='4190.02'
          y2='1244.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#090909' />
          <stop offset='0.25' stopColor='#292929' />
          <stop offset='0.53125' stopColor='#676767' />
          <stop offset='0.765625' stopColor='#515151' />
          <stop offset='1' stopColor='#141414' />
        </linearGradient>
        <linearGradient
          id='paint224_linear_344_5378'
          x1='4310.01'
          y1='1242.21'
          x2='4150.37'
          y2='1234.65'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#303030' />
          <stop offset='0.25' stopColor='#505050' />
          <stop offset='0.53125' stopColor='#585858' />
          <stop offset='0.765625' stopColor='#555555' />
          <stop offset='1' stopColor='#262626' />
        </linearGradient>
        <linearGradient
          id='paint225_linear_344_5378'
          x1='1990'
          y1='3979.4'
          x2='1720.02'
          y2='3976.7'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C4C4C4' />
          <stop offset='0.25' stopColor='#CCCDCA' />
          <stop offset='0.5' stopColor='#E2DED4' />
          <stop offset='0.75' stopColor='#D1D1D1' />
          <stop offset='1' stopColor='#9F9F9F' />
        </linearGradient>
        <linearGradient
          id='paint226_linear_344_5378'
          x1='2000'
          y1='3854.09'
          x2='1710.28'
          y2='3845.04'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A7A59B' />
          <stop offset='0.197917' stopColor='#D3D2D3' />
          <stop offset='0.515625' stopColor='#E9E5EA' />
          <stop offset='0.859375' stopColor='#B0ADA8' />
          <stop offset='1' stopColor='#9C9C92' />
        </linearGradient>
        <linearGradient
          id='paint227_linear_344_5378'
          x1='2015.09'
          y1='3851.69'
          x2='1700.66'
          y2='3837.26'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A706B' />
          <stop offset='0.25' stopColor='#E2E2E2' />
          <stop offset='0.53125' stopColor='#CBC9C8' />
          <stop offset='0.765625' stopColor='#959387' />
          <stop offset='1' stopColor='#5B5750' />
        </linearGradient>
        <linearGradient
          id='paint228_linear_344_5378'
          x1='3900.01'
          y1='1245.87'
          x2='3820.02'
          y2='1244.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#090909' />
          <stop offset='0.25' stopColor='#292929' />
          <stop offset='0.53125' stopColor='#676767' />
          <stop offset='0.765625' stopColor='#515151' />
          <stop offset='1' stopColor='#141414' />
        </linearGradient>
        <linearGradient
          id='paint229_linear_344_5378'
          x1='3940.01'
          y1='1242.21'
          x2='3780.37'
          y2='1234.65'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#303030' />
          <stop offset='0.25' stopColor='#505050' />
          <stop offset='0.53125' stopColor='#585858' />
          <stop offset='0.765625' stopColor='#555555' />
          <stop offset='1' stopColor='#262626' />
        </linearGradient>
        <linearGradient
          id='paint230_linear_344_5378'
          x1='4010.01'
          y1='2113.48'
          x2='3740'
          y2='2112.78'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C4C4C4' />
          <stop offset='0.25' stopColor='#CCCDCA' />
          <stop offset='0.5' stopColor='#E2DED4' />
          <stop offset='0.75' stopColor='#D1D1D1' />
          <stop offset='1' stopColor='#9F9F9F' />
        </linearGradient>
        <linearGradient
          id='paint231_linear_344_5378'
          x1='4020.01'
          y1='1411.49'
          x2='3730.05'
          y2='1407.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A7A59B' />
          <stop offset='0.197917' stopColor='#D3D2D3' />
          <stop offset='0.515625' stopColor='#E9E5EA' />
          <stop offset='0.859375' stopColor='#B0ADA8' />
          <stop offset='1' stopColor='#9C9C92' />
        </linearGradient>
        <linearGradient
          id='paint232_linear_344_5378'
          x1='4000.01'
          y1='1402.72'
          x2='3970.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint233_linear_344_5378'
          x1='3950.01'
          y1='1402.72'
          x2='3920.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint234_linear_344_5378'
          x1='3890.01'
          y1='1402.72'
          x2='3860.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint235_linear_344_5378'
          x1='3830.01'
          y1='1402.72'
          x2='3800.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint236_linear_344_5378'
          x1='3770.01'
          y1='1402.72'
          x2='3740.01'
          y2='1402.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint237_linear_344_5378'
          x1='4020.01'
          y1='1705.07'
          x2='3730.09'
          y2='1700.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#121212' />
          <stop offset='0.25' stopColor='#555555' />
          <stop offset='0.53125' stopColor='#464646' />
          <stop offset='0.765625' stopColor='#3A3A3A' />
          <stop offset='1' stopColor='#0B0B0B' />
        </linearGradient>
        <linearGradient
          id='paint238_linear_344_5378'
          x1='4035.1'
          y1='1581.69'
          x2='3720.67'
          y2='1567.26'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A706B' />
          <stop offset='0.25' stopColor='#E2E2E2' />
          <stop offset='0.53125' stopColor='#CBC9C8' />
          <stop offset='0.765625' stopColor='#959387' />
          <stop offset='1' stopColor='#5B5750' />
        </linearGradient>
        <linearGradient
          id='paint239_linear_344_5378'
          x1='3800.01'
          y1='1583.11'
          x2='3740.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint240_linear_344_5378'
          x1='3890.01'
          y1='1583.11'
          x2='3830.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint241_linear_344_5378'
          x1='4000.01'
          y1='1583.11'
          x2='3940.09'
          y2='1580.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint242_linear_344_5378'
          x1='4000.01'
          y1='1705.79'
          x2='3970.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint243_linear_344_5378'
          x1='3920.01'
          y1='1705.79'
          x2='3890.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint244_linear_344_5378'
          x1='3850.01'
          y1='1705.79'
          x2='3820.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint245_linear_344_5378'
          x1='3790.01'
          y1='1705.79'
          x2='3760.01'
          y2='1705.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint246_linear_344_5378'
          x1='4315.1'
          y1='3711.49'
          x2='4025.13'
          y2='3707.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A7A59B' />
          <stop offset='0.197917' stopColor='#D3D2D3' />
          <stop offset='0.515625' stopColor='#E9E5EA' />
          <stop offset='0.859375' stopColor='#B0ADA8' />
          <stop offset='1' stopColor='#9C9C92' />
        </linearGradient>
        <linearGradient
          id='paint247_linear_344_5378'
          x1='3815.1'
          y1='3662.72'
          x2='3785.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint248_linear_344_5378'
          x1='3865.1'
          y1='3662.72'
          x2='3835.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint249_linear_344_5378'
          x1='3925.1'
          y1='3662.72'
          x2='3895.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint250_linear_344_5378'
          x1='3985.1'
          y1='3662.72'
          x2='3955.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint251_linear_344_5378'
          x1='4045.1'
          y1='3662.72'
          x2='4015.1'
          y2='3662.72'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint252_linear_344_5378'
          x1='4315.1'
          y1='3345.07'
          x2='4025.18'
          y2='3340.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#121212' />
          <stop offset='0.25' stopColor='#555555' />
          <stop offset='0.53125' stopColor='#464646' />
          <stop offset='0.765625' stopColor='#3A3A3A' />
          <stop offset='1' stopColor='#0B0B0B' />
        </linearGradient>
        <linearGradient
          id='paint253_linear_344_5378'
          x1='4350.19'
          y1='3360.36'
          x2='4035.75'
          y2='3345.94'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A706B' />
          <stop offset='0.25' stopColor='#E2E2E2' />
          <stop offset='0.53125' stopColor='#CBC9C8' />
          <stop offset='0.765625' stopColor='#959387' />
          <stop offset='1' stopColor='#5B5750' />
        </linearGradient>
        <linearGradient
          id='paint254_linear_344_5378'
          x1='3800'
          y1='3273.11'
          x2='3740.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint255_linear_344_5378'
          x1='3890'
          y1='3273.11'
          x2='3830.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint256_linear_344_5378'
          x1='4000'
          y1='3273.11'
          x2='3940.07'
          y2='3270.98'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#373737' />
          <stop offset='0.25' stopColor='#5A5A5A' />
          <stop offset='0.53125' stopColor='#646464' />
          <stop offset='0.765625' stopColor='#4A4A4A' />
          <stop offset='1' stopColor='#404040' />
        </linearGradient>
        <linearGradient
          id='paint257_linear_344_5378'
          x1='3815.1'
          y1='3305.79'
          x2='3785.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint258_linear_344_5378'
          x1='3895.1'
          y1='3305.79'
          x2='3865.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint259_linear_344_5378'
          x1='3965.1'
          y1='3305.79'
          x2='3935.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint260_linear_344_5378'
          x1='4025.1'
          y1='3305.79'
          x2='3995.1'
          y2='3305.79'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity='0.28' />
          <stop offset='0.447917' stopColor='white' stopOpacity='0.63' />
          <stop offset='1' stopOpacity='0.25' />
        </linearGradient>
        <linearGradient
          id='paint261_linear_344_5378'
          x1='9907'
          y1='1615.41'
          x2='9734.76'
          y2='1608.7'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint262_linear_344_5378'
          x1='9749.5'
          y1='1681.57'
          x2='9682'
          y2='1680.91'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint263_linear_344_5378'
          x1='9682'
          y1='1742.3'
          x2='9517.02'
          y2='1740.15'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint264_linear_344_5378'
          x1='9682'
          y1='1605.7'
          x2='9517.02'
          y2='1607.85'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint265_linear_344_5378'
          x1='9794.5'
          y1='1807.75'
          x2='9664.51'
          y2='1806.32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#362F2F' />
          <stop offset='0.25' stopColor='#564B45' />
          <stop offset='0.53125' stopColor='#A6918B' />
          <stop offset='0.765625' stopColor='#776862' />
          <stop offset='1' stopColor='#473E39' />
        </linearGradient>
        <linearGradient
          id='paint266_linear_344_5378'
          x1='9704.5'
          y1='1861.63'
          x2='9682'
          y2='1861.59'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
        <linearGradient
          id='paint267_linear_344_5378'
          x1='9704.5'
          y1='1614.13'
          x2='9682'
          y2='1614.09'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#221717' />
          <stop offset='0.25' stopColor='#453932' />
          <stop offset='0.53125' stopColor='#896E67' />
          <stop offset='0.765625' stopColor='#55423B' />
          <stop offset='1' stopColor='#382E28' />
        </linearGradient>
      </defs>
    </svg>
  </div>
);

export default UFDiagramDuPontCIPFiltrate;
